var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g2, _path54, _path55, _path56, _path57, _g3, _defs, _defs2, _path58, _path59, _g4, _g5, _g6, _path60, _path61, _g7, _path62, _path63, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g8, _g9, _path71, _g10, _path72, _path73, _g11, _path74, _path75, _g12, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _g13, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _path76, _path77, _path78, _path79, _path80, _path81, _g14, _g15, _path82, _path83, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _g16, _path84, _g17, _g18, _path85, _path86, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _path87, _path88, _path89, _path90, _path91, _g19, _path92, _g20, _path93, _path94, _path95, _path96, _path97, _path98, _g21, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g22, _g23, _path112, _path113, _g24, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _g25, _g26, _path144, _path145, _path146, _g27, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _g28, _path160, _path161, _g29, _path162, _path163, _path164, _g30, _g31, _path165, _path166, _g32, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _g33, _path175, _path176, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _g34, _path177, _g35, _path178, _path179, _path180, _path181, _g36, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _g37, _polygon87, _polygon88, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _g38, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _defs3, _defs4, _path324, _path325, _path326, _path327, _g39, _g40, _defs5, _polygon89, _defs6, _polygon90, _defs7, _polygon91, _defs8, _polygon92, _defs9, _polygon93, _defs10, _polygon94, _defs11, _polygon95, _defs12, _polygon96, _defs13, _polygon97, _defs14, _polygon98, _defs15, _polygon99, _defs16, _polygon100, _defs17, _polygon101, _defs18, _polygon102, _defs19, _polygon103, _defs20, _polygon104, _defs21, _polygon105, _defs22, _polygon106, _defs23, _polygon107, _defs24, _polygon108, _defs25, _polygon109, _defs26, _polygon110, _defs27, _polygon111, _defs28, _polygon112, _defs29, _polygon113, _defs30, _polygon114, _defs31, _polygon115, _defs32, _polygon116, _defs33, _polygon117, _defs34, _polygon118, _defs35, _polygon119, _defs36, _polygon120, _defs37, _polygon121, _defs38, _polygon122, _defs39, _polygon123, _defs40, _polygon124, _defs41, _polygon125, _defs42, _polygon126, _defs43, _polygon127, _defs44, _polygon128, _defs45, _polygon129, _defs46, _polygon130, _defs47, _polygon131, _defs48, _polygon132, _path328, _path329, _path330, _path331, _path332, _defs49, _defs50, _path333, _path334, _path335, _path336, _g41, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _g42, _path351, _path352, _path353, _path354, _g43, _g44, _path355, _g45, _path356, _path357, _g46, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _g47, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _g48, _g49, _path375, _g50, _path376, _g51, _path377, _path378, _g52, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _defs51, _defs52, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _defs53, _defs54, _path416, _path417, _path418, _path419, _g53, _path420, _path421, _path422, _path423, _g54, _path424, _path425, _path426, _ellipse, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 619.1 594",
    style: {
      enableBackground: "new 0 0 619.1 594"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{opacity:0.43;fill:#0C25BA;enable-background:new    ;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#F0F0FC;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:#232F6D;}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:#212D60;}\n\t.st16{fill:url(#SVGID_12_);}\n\t.st17{fill:#36399F;}\n\t.st18{fill:url(#SVGID_13_);}\n\t.st19{fill:url(#SVGID_14_);}\n\t.st20{fill:url(#SVGID_15_);}\n\t.st21{fill:url(#SVGID_16_);}\n\t.st22{fill:url(#SVGID_17_);}\n\t.st23{fill:#757575;}\n\t.st24{fill:url(#SVGID_18_);}\n\t.st25{fill:#F7F7F9;}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{fill:#626FA6;}\n\t.st32{fill:url(#SVGID_24_);}\n\t.st33{fill:url(#SVGID_25_);}\n\t.st34{fill:#4A5EA5;}\n\t.st35{fill:url(#SVGID_26_);}\n\t.st36{opacity:0.21;}\n\t.st37{fill:#9FAFFC;}\n\t.st38{clip-path:url(#SVGID_29_);}\n\t.st39{clip-path:url(#SVGID_30_);fill:url(#SVGID_31_);}\n\t.st40{fill:url(#SVGID_32_);}\n\t.st41{opacity:0.69;}\n\t.st42{fill:url(#SVGID_33_);}\n\t.st43{fill:url(#SVGID_34_);}\n\t.st44{fill:url(#SVGID_35_);}\n\t.st45{fill:#5A3B72;}\n\t.st46{fill:url(#SVGID_36_);}\n\t.st47{opacity:0.2;fill:#9FAFFC;enable-background:new    ;}\n\t.st48{fill:url(#SVGID_37_);}\n\t.st49{fill:url(#SVGID_38_);}\n\t.st50{fill:#9FAFFC;fill-opacity:0;}\n\t.st51{fill:url(#SVGID_39_);}\n\t.st52{fill:url(#SVGID_40_);}\n\t.st53{fill:url(#SVGID_41_);}\n\t.st54{fill:url(#SVGID_42_);}\n\t.st55{fill:url(#SVGID_43_);}\n\t.st56{fill:url(#SVGID_44_);}\n\t.st57{fill:#FF969B;}\n\t.st58{fill:#2A4280;}\n\t.st59{fill:url(#SVGID_45_);}\n\t.st60{fill:url(#SVGID_46_);}\n\t.st61{fill:url(#SVGID_47_);}\n\t.st62{fill:url(#SVGID_48_);}\n\t.st63{fill:url(#SVGID_49_);}\n\t.st64{fill:url(#SVGID_50_);}\n\t.st65{fill:url(#SVGID_51_);}\n\t.st66{fill:url(#SVGID_52_);}\n\t.st67{fill:url(#SVGID_53_);}\n\t.st68{fill:url(#SVGID_54_);}\n\t.st69{fill:url(#SVGID_55_);}\n\t.st70{fill:url(#SVGID_56_);}\n\t.st71{fill:url(#SVGID_57_);}\n\t.st72{fill:url(#SVGID_58_);}\n\t.st73{fill:url(#SVGID_59_);}\n\t.st74{fill:url(#SVGID_60_);}\n\t.st75{fill:url(#SVGID_61_);}\n\t.st76{fill:url(#SVGID_62_);}\n\t.st77{fill:url(#SVGID_63_);}\n\t.st78{fill:url(#SVGID_64_);}\n\t.st79{fill:url(#SVGID_65_);}\n\t.st80{fill:url(#SVGID_66_);}\n\t.st81{fill:url(#SVGID_67_);}\n\t.st82{fill:url(#SVGID_68_);}\n\t.st83{fill:url(#SVGID_69_);}\n\t.st84{fill:url(#SVGID_70_);}\n\t.st85{fill:#24325B;}\n\t.st86{fill:#FFAB83;}\n\t.st87{fill:#1A254F;}\n\t.st88{fill:url(#SVGID_71_);}\n\t.st89{fill:url(#SVGID_72_);}\n\t.st90{fill:url(#SVGID_73_);}\n\t.st91{fill:url(#SVGID_74_);}\n\t.st92{fill:url(#SVGID_75_);}\n\t.st93{fill:url(#SVGID_76_);}\n\t.st94{fill:url(#SVGID_77_);}\n\t.st95{fill:url(#SVGID_78_);}\n\t.st96{fill:url(#SVGID_79_);}\n\t.st97{fill:url(#SVGID_80_);}\n\t.st98{fill:url(#SVGID_81_);}\n\t.st99{fill:url(#SVGID_82_);}\n\t.st100{fill:#474AB6;}\n\t.st101{fill:url(#SVGID_83_);}\n\t.st102{fill:url(#SVGID_84_);}\n\t.st103{fill:url(#SVGID_85_);}\n\t.st104{fill:url(#SVGID_86_);}\n\t.st105{fill:url(#SVGID_87_);}\n\t.st106{fill:url(#SVGID_88_);}\n\t.st107{fill:url(#SVGID_89_);}\n\t.st108{fill:url(#SVGID_90_);}\n\t.st109{fill:url(#SVGID_91_);}\n\t.st110{fill:url(#SVGID_92_);}\n\t.st111{fill:url(#SVGID_93_);}\n\t.st112{fill:url(#SVGID_94_);}\n\t.st113{fill:url(#SVGID_95_);}\n\t.st114{fill:url(#SVGID_96_);}\n\t.st115{fill:url(#SVGID_97_);}\n\t.st116{fill:url(#SVGID_98_);}\n\t.st117{fill:url(#SVGID_99_);}\n\t.st118{fill:url(#SVGID_100_);}\n\t.st119{fill:url(#SVGID_101_);}\n\t.st120{fill:url(#SVGID_102_);}\n\t.st121{fill:url(#SVGID_103_);}\n\t.st122{fill:url(#SVGID_104_);}\n\t.st123{fill:url(#SVGID_105_);}\n\t.st124{fill:url(#SVGID_106_);}\n\t.st125{fill:url(#SVGID_107_);}\n\t.st126{fill:url(#SVGID_108_);}\n\t.st127{fill:url(#SVGID_109_);}\n\t.st128{fill:url(#SVGID_110_);}\n\t.st129{fill:url(#SVGID_111_);}\n\t.st130{fill:url(#SVGID_112_);}\n\t.st131{fill:url(#SVGID_113_);}\n\t.st132{fill:url(#SVGID_114_);}\n\t.st133{fill:url(#SVGID_115_);}\n\t.st134{fill:url(#SVGID_116_);}\n\t.st135{fill:url(#SVGID_117_);}\n\t.st136{fill:url(#SVGID_118_);}\n\t.st137{fill:url(#SVGID_119_);}\n\t.st138{fill:url(#SVGID_120_);}\n\t.st139{fill:url(#SVGID_121_);}\n\t.st140{fill:url(#SVGID_122_);}\n\t.st141{fill:url(#SVGID_123_);}\n\t.st142{fill:url(#SVGID_124_);}\n\t.st143{fill:url(#SVGID_125_);}\n\t.st144{fill:url(#SVGID_126_);}\n\t.st145{fill:#FF7A93;}\n\t.st146{fill:url(#SVGID_127_);}\n\t.st147{fill:url(#SVGID_128_);}\n\t.st148{opacity:0.38;fill:#9FAFFC;enable-background:new    ;}\n\t.st149{fill:url(#SVGID_129_);}\n\t.st150{fill:url(#SVGID_130_);}\n\t.st151{fill:url(#SVGID_131_);}\n\t.st152{fill:url(#SVGID_132_);}\n\t.st153{fill:url(#SVGID_133_);}\n\t.st154{fill:#71D4FF;}\n\t.st155{fill:url(#SVGID_134_);}\n\t.st156{fill:url(#SVGID_135_);}\n\t.st157{opacity:0.36;}\n\t.st158{opacity:0.36;fill:#9FAFFC;enable-background:new    ;}\n\t.st159{fill:url(#SVGID_136_);}\n\t.st160{fill:url(#SVGID_137_);}\n\t.st161{fill:url(#SVGID_138_);}\n\t.st162{fill:url(#SVGID_139_);}\n\t.st163{fill:url(#SVGID_140_);}\n\t.st164{fill:url(#SVGID_141_);}\n\t.st165{fill:url(#SVGID_142_);}\n\t.st166{fill:url(#SVGID_143_);}\n\t.st167{fill:url(#SVGID_144_);}\n\t.st168{fill:url(#SVGID_145_);}\n\t.st169{fill:url(#SVGID_146_);}\n\t.st170{fill:url(#SVGID_147_);}\n\t.st171{fill:url(#SVGID_148_);}\n\t.st172{fill:url(#SVGID_149_);}\n\t.st173{fill:url(#SVGID_150_);}\n\t.st174{fill:url(#SVGID_151_);}\n\t.st175{fill:url(#SVGID_152_);}\n\t.st176{fill:url(#SVGID_153_);}\n\t.st177{fill:url(#SVGID_154_);}\n\t.st178{opacity:0.38;fill:#9898ED;enable-background:new    ;}\n\t.st179{fill:#FFD33F;}\n\t.st180{fill:url(#SVGID_155_);}\n\t.st181{fill:url(#SVGID_156_);}\n\t.st182{fill:url(#SVGID_157_);}\n\t.st183{fill:url(#SVGID_158_);}\n\t.st184{fill:url(#SVGID_159_);}\n\t.st185{fill:url(#SVGID_160_);}\n\t.st186{fill:url(#SVGID_161_);}\n\t.st187{fill:url(#SVGID_162_);}\n\t.st188{fill:url(#SVGID_163_);}\n\t.st189{fill:url(#SVGID_164_);}\n\t.st190{fill:url(#SVGID_165_);}\n\t.st191{fill:url(#SVGID_166_);}\n\t.st192{fill:url(#SVGID_167_);}\n\t.st193{fill:url(#SVGID_168_);}\n\t.st194{fill:url(#SVGID_169_);}\n\t.st195{fill:url(#SVGID_170_);}\n\t.st196{fill:#FD256F;}\n\t.st197{fill:url(#SVGID_171_);}\n\t.st198{fill:url(#SVGID_172_);}\n\t.st199{fill:#FBA129;}\n\t.st200{fill:url(#SVGID_173_);}\n\t.st201{fill:url(#SVGID_174_);}\n\t.st202{fill:url(#SVGID_175_);}\n\t.st203{fill:url(#SVGID_176_);}\n\t.st204{fill:url(#SVGID_177_);}\n\t.st205{fill:url(#SVGID_178_);}\n\t.st206{fill:url(#SVGID_179_);}\n\t.st207{fill:#F9A935;}\n\t.st208{fill:url(#SVGID_180_);}\n\t.st209{fill:url(#SVGID_181_);}\n\t.st210{fill:url(#SVGID_182_);}\n\t.st211{fill:url(#SVGID_183_);}\n\t.st212{fill:url(#SVGID_184_);}\n\t.st213{fill:url(#SVGID_185_);}\n\t.st214{fill:url(#SVGID_186_);}\n\t.st215{fill:url(#SVGID_187_);}\n\t.st216{fill:url(#SVGID_188_);}\n\t.st217{fill:url(#SVGID_189_);}\n\t.st218{fill:url(#SVGID_190_);}\n\t.st219{fill:url(#SVGID_191_);}\n\t.st220{fill:url(#SVGID_192_);}\n\t.st221{fill:url(#SVGID_193_);}\n\t.st222{fill:url(#SVGID_194_);}\n\t.st223{fill:url(#SVGID_195_);}\n\t.st224{fill:url(#SVGID_196_);}\n\t.st225{fill:url(#SVGID_197_);}\n\t.st226{fill:url(#SVGID_198_);}\n\t.st227{fill:url(#SVGID_199_);}\n\t.st228{fill:url(#SVGID_200_);}\n\t.st229{fill:url(#SVGID_202_);}\n\t.st230{fill:url(#SVGID_203_);}\n\t.st231{fill:url(#SVGID_204_);}\n\t.st232{fill:url(#SVGID_205_);}\n\t.st233{fill:url(#SVGID_206_);}\n\t.st234{fill:url(#SVGID_207_);}\n\t.st235{fill:url(#SVGID_208_);}\n\t.st236{clip-path:url(#SVGID_211_);}\n\t.st237{clip-path:url(#SVGID_212_);fill:url(#SVGID_213_);}\n\t.st238{fill:url(#SVGID_214_);}\n\t.st239{fill:url(#SVGID_215_);}\n\t.st240{clip-path:url(#SVGID_217_);fill:#F9A935;}\n\t.st241{clip-path:url(#SVGID_219_);fill:#F9A935;}\n\t.st242{clip-path:url(#SVGID_221_);fill:#F9A935;}\n\t.st243{clip-path:url(#SVGID_223_);fill:#F9A935;}\n\t.st244{clip-path:url(#SVGID_225_);fill:#F9A935;}\n\t.st245{clip-path:url(#SVGID_227_);fill:#F9A935;}\n\t.st246{clip-path:url(#SVGID_229_);fill:#F9A935;}\n\t.st247{clip-path:url(#SVGID_231_);fill:#F9A935;}\n\t.st248{clip-path:url(#SVGID_233_);fill:#F9A935;}\n\t.st249{clip-path:url(#SVGID_235_);fill:#F9A935;}\n\t.st250{clip-path:url(#SVGID_237_);fill:#F9A935;}\n\t.st251{clip-path:url(#SVGID_239_);fill:#F9A935;}\n\t.st252{clip-path:url(#SVGID_241_);fill:#F9A935;}\n\t.st253{clip-path:url(#SVGID_243_);fill:#F9A935;}\n\t.st254{clip-path:url(#SVGID_245_);fill:#F9A935;}\n\t.st255{clip-path:url(#SVGID_247_);fill:#F9A935;}\n\t.st256{clip-path:url(#SVGID_249_);fill:#F9A935;}\n\t.st257{clip-path:url(#SVGID_251_);fill:#F9A935;}\n\t.st258{clip-path:url(#SVGID_253_);fill:#F9A935;}\n\t.st259{clip-path:url(#SVGID_255_);fill:#F9A935;}\n\t.st260{clip-path:url(#SVGID_257_);fill:#F9A935;}\n\t.st261{clip-path:url(#SVGID_259_);fill:#F9A935;}\n\t.st262{clip-path:url(#SVGID_261_);fill:#F9A935;}\n\t.st263{clip-path:url(#SVGID_263_);fill:#F9A935;}\n\t.st264{clip-path:url(#SVGID_265_);fill:#F9A935;}\n\t.st265{clip-path:url(#SVGID_267_);fill:#F9A935;}\n\t.st266{clip-path:url(#SVGID_269_);fill:#F9A935;}\n\t.st267{clip-path:url(#SVGID_271_);fill:#F9A935;}\n\t.st268{clip-path:url(#SVGID_273_);fill:#F9A935;}\n\t.st269{clip-path:url(#SVGID_275_);fill:#F9A935;}\n\t.st270{clip-path:url(#SVGID_277_);fill:#F9A935;}\n\t.st271{clip-path:url(#SVGID_279_);fill:#F9A935;}\n\t.st272{clip-path:url(#SVGID_281_);fill:#F9A935;}\n\t.st273{clip-path:url(#SVGID_283_);fill:#F9A935;}\n\t.st274{clip-path:url(#SVGID_285_);fill:#F9A935;}\n\t.st275{clip-path:url(#SVGID_287_);fill:#F9A935;}\n\t.st276{clip-path:url(#SVGID_289_);fill:#F9A935;}\n\t.st277{clip-path:url(#SVGID_291_);fill:#F9A935;}\n\t.st278{clip-path:url(#SVGID_293_);fill:#F9A935;}\n\t.st279{clip-path:url(#SVGID_295_);fill:#F9A935;}\n\t.st280{clip-path:url(#SVGID_297_);fill:#F9A935;}\n\t.st281{clip-path:url(#SVGID_299_);fill:#F9A935;}\n\t.st282{clip-path:url(#SVGID_301_);fill:#F9A935;}\n\t.st283{clip-path:url(#SVGID_303_);fill:#F9A935;}\n\t.st284{fill:url(#SVGID_304_);}\n\t.st285{fill:url(#SVGID_305_);}\n\t.st286{clip-path:url(#SVGID_308_);}\n\t.st287{clip-path:url(#SVGID_309_);fill:url(#SVGID_310_);}\n\t.st288{fill:url(#SVGID_311_);}\n\t.st289{fill:url(#SVGID_312_);}\n\t.st290{fill:url(#SVGID_313_);}\n\t.st291{fill:url(#SVGID_314_);}\n\t.st292{fill:url(#SVGID_315_);}\n\t.st293{fill:#E9DBEF;}\n\t.st294{fill:#5855A2;}\n\t.st295{fill:url(#SVGID_316_);}\n\t.st296{fill:#FF227D;}\n\t.st297{fill:url(#SVGID_317_);}\n\t.st298{fill:url(#SVGID_318_);}\n\t.st299{fill:url(#SVGID_319_);}\n\t.st300{fill:url(#SVGID_320_);}\n\t.st301{fill:url(#SVGID_321_);}\n\t.st302{fill:#2B1C3C;}\n\t.st303{fill:#FFE115;}\n\t.st304{fill:url(#SVGID_322_);}\n\t.st305{fill:url(#SVGID_323_);}\n\t.st306{fill:url(#SVGID_324_);}\n\t.st307{fill:url(#SVGID_325_);}\n\t.st308{fill:url(#SVGID_326_);}\n\t.st309{fill:url(#SVGID_327_);}\n\t.st310{fill:url(#SVGID_328_);}\n\t.st311{fill:url(#SVGID_329_);}\n\t.st312{fill:url(#SVGID_330_);}\n\t.st313{fill:url(#SVGID_331_);}\n\t.st314{fill:url(#SVGID_332_);}\n\t.st315{fill:url(#SVGID_333_);}\n\t.st316{fill:url(#SVGID_334_);}\n\t.st317{fill:url(#SVGID_335_);}\n\t.st318{fill:url(#SVGID_336_);}\n\t.st319{fill:url(#SVGID_337_);}\n\t.st320{fill:url(#SVGID_338_);}\n\t.st321{fill:url(#SVGID_339_);}\n\t.st322{fill:url(#SVGID_340_);}\n\t.st323{fill:url(#SVGID_341_);}\n\t.st324{fill:url(#SVGID_342_);}\n\t.st325{fill:url(#SVGID_343_);}\n\t.st326{fill:url(#SVGID_344_);}\n\t.st327{fill:url(#SVGID_345_);}\n\t.st328{fill:url(#SVGID_346_);}\n\t.st329{fill:url(#SVGID_347_);}\n\t.st330{fill:url(#SVGID_348_);}\n\t.st331{fill:url(#SVGID_349_);}\n\t.st332{fill:url(#SVGID_350_);}\n\t.st333{fill:url(#SVGID_351_);}\n\t.st334{fill:url(#SVGID_352_);}\n\t.st335{fill:url(#SVGID_353_);}\n\t.st336{fill:url(#SVGID_354_);}\n\t.st337{fill:url(#SVGID_355_);}\n\t.st338{clip-path:url(#SVGID_358_);}\n\t.st339{clip-path:url(#SVGID_359_);fill:url(#SVGID_360_);}\n\t.st340{fill:url(#SVGID_361_);}\n\t.st341{fill:url(#SVGID_362_);}\n\t.st342{fill:url(#SVGID_363_);}\n\t.st343{fill:url(#SVGID_364_);}\n\t.st344{clip-path:url(#SVGID_367_);}\n\t.st345{clip-path:url(#SVGID_368_);fill:url(#SVGID_369_);}\n\t.st346{fill:url(#SVGID_370_);}\n\t.st347{fill:url(#SVGID_371_);}\n\t.st348{fill:url(#SVGID_372_);}\n\t.st349{fill:url(#SVGID_373_);}\n\t.st350{fill:#492817;}\n\t.st351{fill:url(#SVGID_374_);}\n\t.st352{fill:url(#SVGID_375_);}\n\t.st353{fill:url(#SVGID_376_);}\n\t.st354{fill:url(#SVGID_377_);}\n\t.st355{fill:url(#SVGID_378_);}\n\t.st356{fill:url(#SVGID_379_);}\n\t.st357{fill:url(#SVGID_380_);}\n\t.st358{fill:url(#SVGID_381_);}\n\t.st359{fill:url(#SVGID_382_);}\n\t.st360{fill:url(#SVGID_383_);}\n\t.st361{fill:url(#SVGID_384_);}\n\t.st362{fill:url(#SVGID_385_);}\n\t.st363{fill:url(#SVGID_386_);}\n\t.st364{fill:url(#SVGID_387_);}\n\t.st365{fill:url(#SVGID_388_);}\n\t.st366{fill:url(#SVGID_389_);}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576.9,407.8l-25.3-14.7c-2.5-1.5-5.6-1.5-8.1,0l-24.2,21.2l20.2,14.5h12.2l25.1-15.5 C579,412,579,409,576.9,407.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 514.6422,
    y1: 208.5,
    x2: 567.5422,
    y2: 208.5,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.1,341.9h-52.9v71.8c0,0.6,0.3,1.3,0.9,1.6l22.2,12.9c2,1.2,4.5,1.2,6.6,0l22.2-12.8 c0.6-0.4,0.9-1,0.9-1.7h0.1V341.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M535.3,356.5l-22.2-12.9c-1.3-0.7-1.3-2.6,0-3.3l22.3-12.9c1.8-1.1,4.1-1.1,6,0l22.6,13.1 c1.2,0.7,1.2,2.5,0,3.2l-22.2,12.8C539.9,357.7,537.4,357.7,535.3,356.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565,228.3l-80.3-46.1c-7.9-4.6-17.7-4.6-25.7,0L380.7,227v28.3l66,38.7h38.9l79.7-48.6 C571.7,241.4,571.6,232.1,565,228.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 858.453,
    y1: 391.5125,
    x2: 1031.311,
    y2: 391.5125,
    gradientTransform: "matrix(1 0 0 -1 -515.401 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M363,111.3v133.8c0,2,1,4,3,5.2l70.2,40.6c6.4,3.7,14.3,3.7,20.7,0l69.9-40.5c2-1.2,3-3.3,2.9-5.3h0.4V111.9 L363,111.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M436.3,156.9l-70.2-40.6c-4-2.3-4-8.1,0-10.4L436.7,65c5.8-3.4,13-3.4,18.8,0l71.4,41.4 c3.8,2.2,4.4,7.4,0.6,9.6L457,156.9C450.6,160.6,442.7,160.6,436.3,156.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M247.9,464.9L66.4,359.8c-10.3-6-10.3-20.8,0-26.8l182.5-105.6c15.1-8.7,33.7-8.7,48.7,0l184.8,107 c9.9,5.7,9.9,20.1,0,25.8L301.5,464.9C284.9,474.5,264.5,474.5,247.9,464.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.2106,
    y1: 307.1125,
    x2: 15.8124,
    y2: 307.1125,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.3,347.1l182.8-105.4c15.1-8.7,33.7-8.7,48.8,0L483,348.4c2.4,1.4,4.1,3.2,5.4,5.3 c4-6.7,2.2-16.1-5.4-20.4L297.9,226.6c-15.1-8.7-33.7-8.7-48.8,0L66.3,332c-7.7,4.5-9.7,14-5.8,20.9 C61.8,350.6,63.7,348.6,66.3,347.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.9431,
    y1: 255.4125,
    x2: 368.3701,
    y2: 255.4125,
    gradientTransform: "matrix(1 0 0 -1 -25.5488 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M189.4,293.5v41.4c0,2,1,4,3,5.2l70.4,40.8c6.4,3.7,14.4,3.7,20.8,0l70.2-40.6c2-1.2,3.4-3.3,3.3-5.3v-41.4 H189.4V293.5z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M262.9,339l-70.4-40.8c-4-2.3-4-8.1,0-10.4l70.8-41c5.8-3.4,13.1-3.4,18.9,0l71.7,41.5c3.8,2.2,3.8,7.8,0,10 L283.7,339C277.3,342.7,269.3,342.7,262.9,339z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.4,298.1l-8.6-5c-0.9-0.5-1.9-0.5-2.8,0l-11,6.4l9.7,5.8h4.2l8.6-5.3 C542.1,299.6,542.1,298.5,541.4,298.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.2059,
    y1: 294.5125,
    x2: 539.5708,
    y2: 294.5125,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M539,293.6v5.4c0,0.3-0.1,0.5-0.4,0.7l-9.2,5.3c-0.8,0.5-1.9,0.5-2.7,0l-9.1-5.3c-0.3-0.2-0.4-0.4-0.4-0.7 c-0.1,0-0.1-5.4-0.1-5.4H539z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M529.4,299.5l9.2-5.3c0.5-0.3,0.5-1.1,0-1.4l-9.2-5.3c-0.8-0.4-1.7-0.4-2.5,0l-9.3,5.4c-0.5,0.3-0.5,1,0,1.3 l9.1,5.3C527.5,300,528.5,300,529.4,299.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M557.3,303.5l-10.6-6.2c-1.1-0.6-2.3-0.6-3.4,0l-10.2,8.9l8.5,6.1h5.2l10.6-6.5 C558.2,305.2,558.2,304,557.3,303.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.5162,
    y1: 299.9125,
    x2: 554.8162,
    y2: 299.9125,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M552.3,275.7H530V306c0,0.3,0.1,0.5,0.4,0.7l9.4,5.4c0.9,0.5,1.9,0.5,2.8,0l9.3-5.4 c0.3-0.2,0.4-0.4,0.4-0.7C552.3,306,552.3,275.7,552.3,275.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M539.8,281.9l-9.4-5.4c-0.5-0.3-0.5-1.1,0-1.4l9.4-5.4c0.8-0.5,1.7-0.5,2.5,0l9.5,5.5c0.5,0.3,0.5,1,0,1.3 l-9.3,5.4C541.7,282.4,540.6,282.4,539.8,281.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568.1,311.3l-9.8-5.6c-1-0.6-2.2-0.6-3.1,0l-9.6,5.5v3.5l8.1,4.7h4.8l9.8-5.9 C568.9,312.9,568.9,311.7,568.1,311.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1056.3174,
    y1: 285.8125,
    x2: 1077.4713,
    y2: 285.8125,
    gradientTransform: "matrix(1 0 0 -1 -515.401 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M543.4,297v16.4c0,0.2,0.1,0.5,0.4,0.6l8.6,5c0.8,0.5,1.8,0.5,2.5,0l8.6-5c0.2-0.1,0.4-0.4,0.3-0.7 c0.1,0,0.1-16.3,0.1-16.3H543.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M552.3,302.5l-8.6-5c-0.5-0.3-0.5-1,0-1.3l8.6-5c0.7-0.4,1.6-0.4,2.3,0l8.7,5.1c0.5,0.3,0.5,0.9,0,1.2 l-8.6,5C554.1,303,553.1,303,552.3,302.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.5,317.6l-10.6-6.2c-1.1-0.6-2.3-0.6-3.4,0l-10.2,8.9l8.5,6.1h5.2l10.6-6.5 C584.4,319.4,584.4,318.1,583.5,317.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.7514,
    y1: 285.8125,
    x2: 581.0515,
    y2: 285.8125,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M578.5,289.8h-22.3v30.3c0,0.3,0.1,0.5,0.4,0.7l9.4,5.4c0.9,0.5,1.9,0.5,2.8,0l9.3-5.4 c0.3-0.2,0.4-0.4,0.4-0.7C578.5,320.1,578.5,289.8,578.5,289.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M566,296l-9.4-5.4c-0.5-0.3-0.5-1.1,0-1.4l9.4-5.4c0.8-0.5,1.7-0.5,2.5,0l9.5,5.5c0.5,0.3,0.5,1,0,1.3 l-9.3,5.4C567.9,296.5,566.9,296.5,566,296z"
  })))))), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.4,271.5l-8.6-5c-0.9-0.5-1.9-0.5-2.8,0l-11,6.4l9.7,5.8h4.2l8.6-5.3 C307.1,272.9,307.1,271.9,306.4,271.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.2012,
    y1: 321.2125,
    x2: 304.5661,
    y2: 321.2125,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M303.9,266.9v5.4c0,0.3-0.1,0.5-0.4,0.7l-9.2,5.3c-0.8,0.5-1.9,0.5-2.7,0l-9.1-5.3c-0.3-0.2-0.4-0.4-0.4-0.7 c-0.1,0-0.1-5.4-0.1-5.4H303.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M294.4,272.9l9.2-5.3c0.5-0.3,0.5-1.1,0-1.4l-9.2-5.3c-0.8-0.4-1.7-0.4-2.5,0l-9.3,5.4c-0.5,0.3-0.5,1,0,1.3 l9.1,5.3C292.5,273.3,293.5,273.3,294.4,272.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.9,486.9l-9.2-5.4c-0.9-0.5-2-0.5-2.9,0l-11.8,6.8l10.4,6.2h4.5l9.1-5.6 C352.6,488.4,352.6,487.3,351.9,486.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.0187,
    y1: 105.7125,
    x2: 349.965,
    y2: 105.7125,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M349.3,482v5.8c0,0.3-0.1,0.6-0.4,0.7l-9.8,5.7c-0.9,0.5-2,0.5-2.9,0l-9.8-5.6c-0.3-0.2-0.4-0.5-0.4-0.7 c-0.1,0-0.1-5.8-0.1-5.8h23.4V482z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M339.1,488.4l9.8-5.7c0.6-0.3,0.6-1.1,0-1.4l-9.8-5.7c-0.8-0.5-1.8-0.5-2.6,0l-10,5.8c-0.5,0.3-0.5,1.1,0,1.4 l9.8,5.6C337.1,488.9,338.2,488.9,339.1,488.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.7,534l-17-9.9c-1.7-1-3.7-1-5.4,0l-16.2,14.2l13.6,9.7h8.2l16.9-10.4 C287.1,536.9,287.1,534.8,285.7,534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.7162,
    y1: 74.95,
    x2: 280.2162,
    y2: 74.95,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M277.7,489.8h-35.5V538c0,0.4,0.2,0.9,0.6,1.1l14.9,8.6c1.4,0.8,3,0.8,4.4,0l14.9-8.6 c0.4-0.2,0.6-0.7,0.6-1.1h0.1V489.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.8,499.6l-14.9-8.6c-0.8-0.5-0.8-1.7,0-2.2l15-8.7c1.2-0.7,2.8-0.7,4,0l15.2,8.8 c0.8,0.5,0.8,1.6,0,2.1l-14.9,8.6C260.8,500.4,259.2,500.4,257.8,499.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M258.5,496.3l-10.8-6.2c-0.6-0.4-0.6-1.2,0-1.6l10.8-6.3c0.9-0.5,2-0.5,2.9,0l10.9,6.3 c0.6,0.3,0.6,1.2,0,1.5l-10.7,6.2C260.7,496.9,259.5,496.9,258.5,496.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.5689,
    y1: 108.1375,
    x2: 247.1207,
    y2: 108.1375,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M247.8,489.4l10.8-6.2c0.9-0.5,2-0.5,2.9,0l11,6.3c0.1,0.1,0.2,0.2,0.3,0.3c0.2-0.4,0.1-1-0.3-1.2 l-11-6.3c-0.9-0.5-2-0.5-2.9,0l-10.8,6.2c-0.5,0.3-0.6,0.8-0.3,1.2C247.5,489.6,247.6,489.5,247.8,489.4z"
  })))))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M256.1,536.2l-8.9-5.1c-0.7-0.4-1.1-1.1-1.1-1.9v-29.6l-0.1-0.1c-0.6-0.3-1.3,0.1-1.3,0.7v29.9 c0,0.8,0.4,1.5,1.1,1.9l8.9,5.1c0.8,0.4,1.7,0,1.9-0.8C256.5,536.4,256.3,536.3,256.1,536.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.7,507.3c0-1-0.5-1.9-1.4-2.4l-9.2-5.3v29.6c0,0.8,0.4,1.5,1.1,1.9l8.9,5.1c0.2,0.1,0.4,0.1,0.5,0.2 c0-0.1,0-0.2,0-0.3L256.7,507.3L256.7,507.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.6,
    y1: 81.7218,
    x2: 248.6,
    y2: 59.9442,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M248.6,528.5c-0.3-0.2-0.6-0.7-0.6-1.1v-23.6c0-0.4,0.3-0.6,0.6-0.4s0.6,0.7,0.6,1.1V528 C249.1,528.4,248.9,528.6,248.6,528.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.9,
    y1: 81.7218,
    x2: 250.9,
    y2: 59.9442,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M250.9,529.8c-0.3-0.2-0.6-0.7-0.6-1.1v-15.5c0-0.4,0.3-0.6,0.6-0.4c0.3,0.2,0.6,0.7,0.6,1.1v15.5 C251.5,529.8,251.2,529.9,250.9,529.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.4,
    y1: 81.7217,
    x2: 253.4,
    y2: 59.9441,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M253.4,508c-0.3-0.2-0.6,0-0.6,0.4v6.3v9.2v6.3c0,0.4,0.3,0.9,0.6,1.1c0.3,0.2,0.6,0,0.6-0.4v-6.3v-9.2V509 C253.9,508.6,253.7,508.1,253.4,508z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.514,
    y1: 54.3,
    x2: 272.314,
    y2: 54.3,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M271.7,539.8l-2.6,1.5c-0.3,0.2-0.6,0-0.6-0.5s0.3-1,0.6-1.2l2.6-1.5c0.3-0.2,0.6,0,0.6,0.5 C272.3,539.1,272,539.7,271.7,539.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495,544.8l-16-9.3c-1.6-0.9-3.5-0.9-5.1,0l-15.3,13.4l12.8,9.2h7.7l15.9-9.8 C496.3,547.4,496.3,545.5,495,544.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 456.5162,
    y1: 63.3875,
    x2: 489.9806,
    y2: 63.3875,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M487.5,503.1H454v45.4c0,0.4,0.2,0.8,0.6,1l14.1,8.1c1.3,0.7,2.9,0.7,4.2,0l14-8.1 c0.4-0.2,0.6-0.7,0.6-1.1h0.1v-45.3H487.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M468.7,512.3l-14.1-8.1c-0.8-0.5-0.8-1.6,0-2.1l14.1-8.2c1.2-0.7,2.6-0.7,3.8,0l14.3,8.3 c0.8,0.4,0.8,1.6,0,2l-14,8.1C471.5,513.1,470,513.1,468.7,512.3z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M363.3,36.4L363.3,36.4L363.3,36.4L363.3,36.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.451,
    y1: 454.6208,
    x2: 379.7006,
    y2: 520.8719,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    style: {
      stopColor: "#BEBEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5405,
    style: {
      stopColor: "#EAEAF9"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M455.1,86.5c-0.4-2.7-2-5.1-4.4-6.5l-79.9-46.1c-1.1-0.6-2.3-0.6-3.3,0l-4.1,2.4c1-0.5,2.2-0.6,3.2,0 l79.8,46.1c2.3,1.4,3.9,3.7,4.4,6.3c0.1,0.5,0.2,1.1,0.2,1.6v53.1c0,1.7-0.9,3-2.1,3.8l3.9-2.2c1.4-0.7,2.4-2.1,2.4-3.9V88 C455.3,87.5,455.2,87,455.1,86.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M363.3,36.4L363.3,36.4c0.1-0.1,0.2-0.1,0.2-0.1c1-0.5,2.2-0.6,3.2,0l79.8,46.1c2.8,1.6,4.6,4.7,4.6,7.9 v53.1c0,1.7-0.9,3-2.1,3.8c-1.3,0.8-3,0.9-4.5,0.1l-78.2-44.7c-2.8-1.6-4.5-4.6-4.5-7.8V39.2C361.8,38,362.4,37,363.3,36.4z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M445.5,84.6l-79.7-46c-0.9-0.5-2.1,0.1-2.1,1.2l0.1,55c0,2.6,1.4,5.1,3.7,6.4l76.3,43.5 c2.1,1.2,4.7-0.3,4.7-2.8v-52C448.6,87.7,447.4,85.7,445.5,84.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.1,268l-34.6-20.1c-3.4-2-7.6-2-11,0l-44.3,25.6l38.9,23.2h16.7l34.3-21.2 C157,273.7,156.9,269.6,154.1,268z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.157,
    y1: 320.7875,
    x2: 146.9026,
    y2: 320.7875,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M144.4,249.7v21.6c0,1.1-0.5,2.1-1.6,2.7L106,295.3c-3.4,1.9-7.5,1.9-10.9,0l-36.7-21.2 c-1.1-0.6-1.6-1.7-1.5-2.8h-0.2v-21.6L144.4,249.7L144.4,249.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106,273.5l36.8-21.3c2.1-1.2,2.1-4.2,0-5.4l-37-21.4c-3.1-1.8-6.8-1.8-9.9,0l-37.4,21.7c-2,1.2-2,4.1,0,5.2 l36.7,21.2C98.5,275.4,102.7,275.4,106,273.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M96.5,268.4l-29.5-17c-1.7-1-1.7-3.4,0-4.4l29.7-17.2c2.5-1.4,5.5-1.4,7.9,0l30,17.4c1.6,0.9,1.6,3.3,0,4.2 l-29.4,17C102.6,270,99.2,270,96.5,268.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5413,
    y1: 354.375,
    x2: 58.8094,
    y2: 354.375,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M67,249.3l29.7-17.1c2.5-1.4,5.5-1.4,7.9,0l30.1,17.4c0.4,0.2,0.7,0.5,0.9,0.9c0.6-1.1,0.4-2.6-0.9-3.3 l-30.1-17.4c-2.5-1.4-5.5-1.4-7.9,0l-29.7,17c-1.3,0.7-1.6,2.3-0.9,3.4C66.3,249.9,66.6,249.5,67,249.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.0351,
    y1: 390.9863,
    x2: 337.8938,
    y2: 390.9863,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4649,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4976,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M374.3,233.1V132.4c0-0.2,0-0.4,0.1-0.6c-1.7-0.6-3.6,0.6-3.6,2.5V235c0,1.6,0.8,3,2.2,3.8l61.1,35.3 c1.3,0.8,3-0.2,3-1.7V272l-60.6-35C375.1,236.1,374.3,234.7,374.3,233.1z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M434.1,166.3L374.9,132c-0.2-0.1-0.3-0.1-0.5-0.2c0,0.2-0.1,0.4-0.1,0.6v100.7c0,1.6,0.8,3,2.2,3.8l60.6,35 V171.4C437.1,169.3,435.9,167.4,434.1,166.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -26.5348,
    y1: -845.5438,
    x2: -26.5348,
    y2: -827.7829,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 408.9419 -793.6656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M390.9,162.8c-0.4-0.9-1-1.7-1.9-2.5v-0.1c0.7,0.2,1.2,0.1,1.6-0.3c0.4-0.4,0.6-1.1,0.6-2 c0-1.4-0.5-2.7-1.4-3.9c-0.6-0.7-1.3-1.4-2.2-2.1v-2.2l-1.5-0.9v2c-0.2-0.1-0.4-0.2-0.6-0.4l-1.3-0.8v-2l-1.5-0.9v2l-2.1-1.3 l-0.1,16.4l2.1,1.2v2l1.5,0.9v-2l1.9,1.1v2l1.5,0.9v-2.1c1,0.4,1.8,0.5,2.4,0.3c1-0.3,1.5-1.2,1.5-2.7 C391.5,164.6,391.3,163.7,390.9,162.8z M384.4,153.2l1.1,0.6c1.2,0.7,1.8,1.5,1.8,2.5c0,0.5-0.2,0.8-0.5,0.9 c-0.3,0.1-0.7,0-1.3-0.4l-1.2-0.7L384.4,153.2z M385.7,163.6l-1.4-0.8v-3.5l1.3,0.8c0.6,0.4,1.1,0.8,1.4,1.3s0.5,1,0.5,1.5 C387.5,164.1,386.9,164.3,385.7,163.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.12,
    y1: -776.1749,
    x2: -43.12,
    y2: -764.8168,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 408.9419 -793.6656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M374.7,76.8c-0.3-0.6-0.7-1.1-1.2-1.6c0.4,0.1,0.8,0,1-0.3c0.3-0.3,0.4-0.7,0.4-1.3c0-0.9-0.3-1.7-0.9-2.5 c-0.4-0.5-0.8-0.9-1.4-1.4v-1.4l-1-0.6V69c-0.1-0.1-0.3-0.2-0.4-0.2l-0.8-0.5V67l-1-0.6v1.3l-1.4-0.8l0,10.6l1.4,0.8v1.3l1,0.6 v-1.3l1.2,0.7v1.3l1,0.6v-1.3c0.6,0.2,1.1,0.3,1.6,0.2c0.6-0.2,0.9-0.7,1-1.7C375.1,77.9,375,77.3,374.7,76.8z M370.6,70.6l0.7,0.4 c0.8,0.5,1.2,1,1.2,1.6c0,0.3-0.1,0.5-0.3,0.6c-0.2,0.1-0.5,0-0.8-0.2l-0.7-0.4L370.6,70.6z M371.4,77.3l-0.9-0.5v-2.2l0.8,0.5 c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.6,0.3,1C372.6,77.6,372.2,77.7,371.4,77.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,171 380.1,171.7 382.7,173.3 382.7,172.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,172.4 380.1,173.1 382.7,174.7 382.7,174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,173.8 380.1,174.5 382.7,176 382.7,175.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,175.2 380.1,175.9 386.5,179.7 386.5,179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,177.7 380.1,178.4 384.8,181.2 384.8,180.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,179.1 380.1,179.8 384.8,182.6 384.8,181.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,189.6 394.1,187.3 394.1,188 398,190.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,180.5 380.1,181.2 384.8,183.9 384.8,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "395.4,180.7 383.3,173.6 383.3,172.9 395.4,180  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "392.3,180.3 383.3,175 383.3,174.3 392.3,179.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,182.9 393,180 393,180.7 398,183.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,184.3 383.3,175.7 383.3,176.4 398,185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,185.7 388.2,179.9 388.2,180.6 398,186.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,188.3 385.4,180.8 385.4,181.5 398,189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "393.5,187.7 385.4,182.9 385.4,182.2 393.5,187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "397.9,191.7 385.4,184.3 385.4,183.6 397.9,190.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "387.4,187.1 382.6,184.3 382.6,183.6 387.4,186.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,192.7 388,186.8 388,187.5 398,193.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,194.1 382.6,185 382.6,185.7 398,194.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "393.8,193.7 382.6,187.1 382.6,186.4 393.8,193  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,195.4 394.5,193.4 394.5,194.1 398,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,186.3 380.1,187 384.8,189.7 384.8,189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,187.6 380.1,188.3 392.2,195.5 392.2,194.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "398,198.2 392.9,195.2 392.9,195.9 398,198.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,189 380.1,189.7 388.9,194.9 389,194.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "380.1,190.4 380.1,191.1 390.7,197.4 390.7,196.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "394.7,201.2 382.8,194.2 382.8,193.5 394.7,200.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "397.7,204.3 382.8,195.5 382.8,194.8 397.7,203.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.2,
    y1: 336.0026,
    x2: 405.2,
    y2: 379.6041,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M377.6,233.5l8.2-12.2c1-1.5,3.4-1.2,3.9,0.5l1.9,5.6c0.4,1.3,2,1.6,3,0.7l8.8-9.2c1.5-1.6,4.1-1,4.8,1.1 l6.4,18.6c1.2,3.4,5.3,4.6,8.1,2.4l1-0.8c1.1-0.8,2.7-0.3,3,1l6.1,23.4L377.6,233.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.9202,
    y1: 377.9173,
    x2: 423.0202,
    y2: 377.9173,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M419.4,220.7c0-2.3,1.6-3.2,3.6-2.1v-6.1c-5-2.9-9.1-0.5-9.1,5.2l5.5,3.2 C419.5,220.9,419.4,220.8,419.4,220.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M419.5,221l-5.5-3.2c0,3,1,6.2,2.7,9.1l4-2.4C419.9,223.3,419.5,222.1,419.5,221z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.6,
    y1: 370.2517,
    x2: 432.2312,
    y2: 370.2517,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M432.2,228.4c0-5.8-4.1-12.9-9.2-15.8c-0.1,0,0,6,0,6c2.1,1.2,3.7,4,3.7,6.3s-1.6,3.2-3.6,2.1 c-1-0.6-1.8-1.5-2.5-2.6l-4,2.4c1.7,2.9,3.9,5.4,6.5,6.8C428.1,236.6,432.2,234.2,432.2,228.4L432.2,228.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M394.2,157.4v1.3v1.3v1.3v1.3v1.3v1.3v1.3v4.8l0.3,0.1v-15l-0.2-0.1L394.2,157.4L394.2,157.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "399.5,174.2 399.7,174.4 399.7,172.5 399.7,159.3 399.5,159.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "404.8,177.3 405,177.4 405,173.7 405,162.4 404.8,162.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "410.1,180.3 410.3,180.5 410.3,174.8 410.3,165.4 410.1,165.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "415.4,183.4 415.6,183.5 415.6,176 415.6,168.5 415.4,168.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "420.7,186.5 420.9,186.6 420.9,177.2 420.9,171.6 420.7,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "425.9,189.5 426.2,189.7 426.2,178.4 426.2,174.6 425.9,174.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "431.2,177.6 431.2,192.6 431.5,192.7 431.5,179.6 431.5,177.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_27_",
    points: "1,1 2,1 1,2  "
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_28_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_",
    className: "st38"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.9371,
    y1: -190.1739,
    x2: 375.549,
    y2: -190.1739,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 106.4636 -220.5789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M431.6,184.1l-4.3,3l0,0c-0.2,0.4-0.7,0.5-1.3,0.3c-0.5-0.2-1.1-0.8-1.4-1.5c-0.5-1.2-1-2.2-1.5-3.4 l-1.5-3.3c-0.1-0.3-0.3-0.6-0.4-0.8s-0.3-0.4-0.5-0.6c-0.3-0.4-0.7-0.6-1.1-0.7l-2.4-0.2c-0.4,0-0.9-0.1-1.3-0.4 c-0.5-0.3-0.9-0.7-1.4-1.2c-0.2-0.2-0.4-0.5-0.6-0.8l-0.5-0.8l-1-1.6l-1-1.6l-0.5-0.8c-0.1-0.2-0.3-0.4-0.5-0.5 s-0.4-0.2-0.5-0.2c-0.2,0-0.3,0.1-0.4,0.2l-0.8,0.8l-1.5,1.6l-1.5,1.6c-0.2,0.3-0.6,0.5-1.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.3 c-0.2-0.2-0.4-0.4-0.6-0.6l-2.5-2.3c-0.8-0.7-1.8-1-2.4-0.8l-4.1,1.3l4.1-1.4c0.7-0.3,1.6,0,2.5,0.8l2.5,2.3 c0.2,0.2,0.4,0.4,0.6,0.5s0.4,0.2,0.6,0.3c0.4,0.1,0.7,0,0.9-0.3l1.5-1.6l1.5-1.6l0.7-0.8c0.1-0.1,0.3-0.3,0.5-0.3 s0.5,0.1,0.7,0.2c0.2,0.2,0.5,0.4,0.7,0.7l0.5,0.8l1,1.6l1,1.6l0.5,0.8c0.2,0.2,0.3,0.5,0.5,0.7c0.4,0.4,0.8,0.8,1.2,1 c0.4,0.2,0.8,0.3,1.2,0.3l2.4,0.2c0.5,0.1,1,0.4,1.5,0.9c0.2,0.2,0.4,0.5,0.6,0.8s0.3,0.6,0.4,0.9l1.6,3.3l1.6,3.3 c0.2,0.4,0.6,0.8,0.9,0.9c0.3,0.2,0.6,0.1,0.8-0.2l0,0l0,0l4.2-3.1c0.1-0.1,0.3,0,0.5,0.2C431.7,183.7,431.7,184,431.6,184.1 L431.6,184.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.9371,
    y1: -190.0373,
    x2: 375.549,
    y2: -190.0373,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 106.4636 -220.5789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M425.2,185.7c0.2,0.4,0.6,0.8,0.9,0.9c0.3,0.2,0.6,0.1,0.8-0.2l4.3-3.2c0.1-0.1,0.3,0,0.5,0.2 c0,0.3,0,0.6-0.1,0.7l0,0l-4.3,3c-0.2,0.4-0.7,0.5-1.2,0.2c-0.5-0.2-1.1-0.8-1.4-1.5c-0.5-1.2-1-2.2-1.5-3.4l-1.5-3.3 c-0.1-0.3-0.3-0.6-0.4-0.8s-0.3-0.4-0.5-0.6c-0.3-0.4-0.7-0.6-1.1-0.7l-2.4-0.2c-0.4,0-0.9-0.1-1.3-0.4c-0.5-0.3-0.9-0.7-1.4-1.2 c-0.2-0.2-0.4-0.5-0.6-0.8l-0.5-0.8l-1-1.6l-1-1.6l-0.5-0.8c-0.1-0.2-0.3-0.4-0.5-0.5s-0.4-0.2-0.5-0.2c-0.2,0-0.3,0.1-0.4,0.2 l-0.8,0.8l-1.5,1.6l-1.5,1.6c-0.2,0.3-0.6,0.5-1.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.2-0.4-0.4-0.6-0.6l-2.5-2.3 c-0.8-0.7-1.8-1-2.4-0.8l-4.1,1.3l4.1-1.4c0.7-0.3,1.6,0,2.5,0.8l2.5,2.3c0.2,0.2,0.4,0.4,0.6,0.5s0.4,0.2,0.6,0.3 c0.4,0.1,0.7,0,0.9-0.3l1.5-1.6l1.5-1.6l0.7-0.8c0.1-0.1,0.3-0.3,0.5-0.3s0.5,0.1,0.7,0.2c0.2,0.2,0.5,0.4,0.7,0.7l0.5,0.8l1,1.6 l1,1.6l0.5,0.8c0.2,0.2,0.3,0.5,0.5,0.7c0.4,0.4,0.8,0.8,1.2,1c0.4,0.2,0.8,0.3,1.2,0.3l2.4,0.2c0.5,0.1,1,0.4,1.5,0.9 c0.2,0.2,0.4,0.5,0.6,0.8s0.3,0.6,0.4,0.9l1.6,3.3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M379.8,53.9v1.3v1.3v1.3v1.3v1.3v1.3V63v4.8l0.3,0.1v-15l-0.2-0.1L379.8,53.9L379.8,53.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "385,70.8 385.3,70.9 385.3,69 385.3,55.9 385,55.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "390.3,73.8 390.6,74 390.6,70.2 390.6,58.9 390.3,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "395.6,76.9 395.9,77 395.9,71.4 395.9,62 395.6,61.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "400.9,80 401.2,80.1 401.2,72.6 401.2,65.1 400.9,64.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "406.2,83 406.4,83.2 406.4,73.8 406.4,68.1 406.2,68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "411.5,86.1 411.7,86.2 411.7,74.9 411.7,71.2 411.5,71  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M416.8,74.1v1.3v1.3V78v1.3v1.3v1.3v1.3v1.3v4.8l0.3,0.1V76.2v-1.9L416.8,74.1L416.8,74.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "422.1,92.2 422.3,92.3 422.3,90.5 422.3,77.3 422.1,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "427.4,95.3 427.6,95.4 427.6,91.6 427.6,80.4 427.4,80.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "432.7,98.3 432.9,98.5 432.9,92.8 432.9,83.4 432.7,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "437.9,101.4 438.2,101.5 438.2,94 438.2,86.5 437.9,86.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "443.2,104.5 443.5,104.6 443.5,95.2 443.5,89.6 443.2,89.4  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M379.8,72v1.3v1.3v1.3v1.3v1.3v1.3v1.3v4.8l0.3,0.1V71l-0.2-0.1L379.8,72L379.8,72z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "385,88.8 385.3,88.9 385.3,87 385.3,73.9 385,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "390.3,91.8 390.6,92 390.6,88.2 390.6,76.9 390.3,76.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "395.6,94.9 395.9,95 395.9,89.4 395.9,80 395.6,79.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "400.9,98 401.2,98.1 401.2,90.6 401.2,83.1 400.9,82.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "406.2,101 406.4,101.2 406.4,91.8 406.4,86.1 406.2,86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "411.5,104.1 411.7,104.2 411.7,93 411.7,89.2 411.5,89.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M416.8,92.1v1.3v1.3V96v1.3v1.3v1.3v1.3v1.3v4.8l0.3,0.1V94.2v-1.9L416.8,92.1L416.8,92.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "422.1,110.2 422.3,110.4 422.3,108.5 422.3,95.3 422.1,95.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "427.4,113.3 427.6,113.4 427.6,109.7 427.6,98.4 427.4,98.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "432.7,116.3 432.9,116.5 432.9,110.8 432.9,101.4 432.7,101.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "437.9,119.4 438.2,119.5 438.2,112 438.2,104.5 437.9,104.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "443.2,122.5 443.5,122.6 443.5,113.2 443.5,107.6 443.2,107.4  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M379.6,89.3v1.3v1.3v1.3v1.3v1.3v1.3v1.3v4.8l0.3,0.1v-15l-0.2-0.1L379.6,89.3L379.6,89.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "384.8,106.1 385.1,106.3 385.1,104.4 385.1,91.2 384.8,91.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "390.1,109.2 390.4,109.3 390.4,105.6 390.4,94.3 390.1,94.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "395.4,112.3 395.7,112.4 395.7,106.8 395.7,97.4 395.4,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "400.7,115.3 401,115.5 401,107.9 401,100.4 400.7,100.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "406,118.4 406.2,118.5 406.2,109.1 406.2,103.5 406,103.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "411.3,121.4 411.5,121.6 411.5,110.3 411.5,106.5 411.3,106.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M416.6,109.5v1.3v1.3v1.3v1.3v1.3v1.3v1.3v1.3v4.8l0.3,0.1v-13.2v-1.9L416.6,109.5L416.6,109.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "421.9,127.6 422.1,127.7 422.1,125.8 422.1,112.7 421.9,112.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "427.2,130.6 427.4,130.8 427.4,127 427.4,115.7 427.2,115.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "432.5,133.7 432.7,133.8 432.7,128.2 432.7,118.8 432.5,118.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "437.7,136.8 438,136.9 438,129.4 438,121.9 437.7,121.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "443,139.8 443.3,140 443.3,130.6 443.3,124.9 443,124.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 5938.0142,
    y1: 400.9076,
    x2: 5943.1108,
    y2: 400.9076,
    gradientTransform: "matrix(-1 0 0 -1 6353.8403 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M410.8,196.7c1.9,1.1,3.4,0.2,3.4-2s-1.5-4.8-3.4-5.9v-1.9c2.8,1.6,5.1,5.6,5.1,8.8s-2.3,4.5-5.1,2.9 C410.7,198.6,410.7,196.7,410.8,196.7C410.7,196.7,410.8,196.7,410.8,196.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M410.8,187v1.9c-1.9-1.1-3.4-0.2-3.4,1.9l-1.6-0.9C405.8,186.7,408,185.4,410.8,187z"
  }))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M426.2,197.8v0.9c-0.9-0.5-1.6-0.1-1.6,0.9l-0.8-0.4C423.8,197.6,424.9,197,426.2,197.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M426.1,205c2.2,1.3,3.9,0.2,3.9-2.2c0-2.5-1.8-5.5-3.9-6.8v-2.2c3.2,1.9,5.8,6.4,5.8,10.1 c0,3.7-2.6,5.2-5.8,3.3C426,207.1,426,205,426.1,205L426.1,205z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 5927.729,
    y1: 391.8032,
    x2: 5933.4814,
    y2: 391.8032,
    gradientTransform: "matrix(-1 0 0 -1 6353.8403 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M422.2,198.2c0,2.5,1.7,5.5,3.9,6.8v2.2c-3.2-1.9-5.8-6.3-5.8-10C420.4,197.1,422.2,198.2,422.2,198.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.5654,
    y1: 380.3,
    x2: 380.8535,
    y2: 380.3,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "380.9,213.4 380.8,214.8 379.6,214.1 379.6,212.6  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "380.9,210.4 380.9,211.9 379.6,211.1 379.6,209.7  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "380.9,207.5 380.9,208.9 379.6,208.2 379.7,206.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.6684,
    y1: 389.1,
    x2: 380.9565,
    y2: 389.1,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "381,204.6 380.9,206 379.7,205.3 379.7,203.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "381,201.6 381,203.1 379.7,202.3 379.7,200.9  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "381,198.7 381,200.1 379.7,199.4 379.8,197.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "382.8,214.5 382.8,216 381.5,215.2 381.5,213.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.5497,
    y1: 382.1,
    x2: 382.8375,
    y2: 382.1,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "382.8,211.6 382.8,213 381.5,212.3 381.6,210.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.5842,
    y1: 385,
    x2: 382.8719,
    y2: 385,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "382.9,208.7 382.9,210.1 381.6,209.3 381.6,207.9  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "382.9,205.7 382.9,207.2 381.6,206.4 381.6,205  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "382.9,202.8 382.9,204.2 381.7,203.5 381.7,202  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "383,199.8 383,201.3 381.7,200.5 381.7,199.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "384.8,215.7 384.8,217.2 383.5,216.4 383.5,214.9  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "384.8,212.8 384.8,214.2 383.5,213.5 383.6,212  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "384.9,209.8 384.8,211.3 383.6,210.5 383.6,209.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.6031,
    y1: 386.8,
    x2: 384.8908,
    y2: 386.8,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "384.9,206.9 384.9,208.3 383.6,207.6 383.6,206.1  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "384.9,204 384.9,205.4 383.6,204.7 383.7,203.2  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "385,201 384.9,202.5 383.7,201.7 383.7,200.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.345,
    y1: 376.9,
    x2: 386.6331,
    y2: 376.9,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "386.6,216.8 386.6,218.2 385.3,217.5 385.4,216  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.3795,
    y1: 379.8,
    x2: 386.6676,
    y2: 379.8,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "386.7,213.9 386.7,215.3 385.4,214.6 385.4,213.1  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "386.7,210.9 386.7,212.4 385.4,211.6 385.4,210.2  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "386.7,208 386.7,209.4 385.4,208.7 385.5,207.2  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "386.8,205.1 386.8,206.5 385.5,205.8 385.5,204.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.5169,
    y1: 391.5,
    x2: 386.805,
    y2: 391.5,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "386.8,202.1 386.8,203.6 385.5,202.8 385.5,201.4  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.3129,
    y1: -785.2117,
    x2: -42.3129,
    y2: -763.5563,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 407.193 -779.7098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "370.7,90.9 372.2,90.6 372.2,88.9 370.7,89.2 370.7,85.6 368,84.1 368,89.7 366.6,89.9 366.6,91.6  368,91.4 368,95.4 374.5,99.1 374.5,96.7 370.7,94.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.518,
    y1: -745.2309,
    x2: -40.518,
    y2: -734.1564,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 407.1886 -777.1612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M371.4,60.5c-1-0.6-1.9-1.4-2.8-2.4v-2.6c0.5,0.6,1.1,1.2,1.7,1.7c0.6,0.6,1.1,1,1.6,1.2 c0.4,0.2,0.7,0.3,0.8,0.3c0.2,0,0.3-0.1,0.3-0.4c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.3-0.4-0.6-0.8c-0.3-0.3-0.7-0.7-1.2-1.2 c-0.6-0.6-1-1.1-1.4-1.6c-0.3-0.5-0.6-1-0.8-1.5c-0.2-0.5-0.2-1-0.2-1.5c0-0.8,0.2-1.4,0.7-1.6c0.5-0.2,1.2-0.1,2.1,0.3v-1.1 l1.4,0.8v1c0.9,0.6,1.8,1.3,2.7,2.3l-0.8,1.7c-0.9-1-1.8-1.8-2.5-2.2c-0.4-0.2-0.6-0.3-0.8-0.3c-0.1,0-0.2,0.1-0.2,0.3 s0.1,0.3,0.2,0.5s0.3,0.4,0.5,0.7c0.3,0.3,0.6,0.7,1.1,1.1c0.9,0.9,1.6,1.7,2,2.5c0.4,0.7,0.6,1.5,0.6,2.2c0,0.9-0.2,1.4-0.7,1.7 s-1.2,0.2-2.1-0.2v1.5l-1.4-0.8L371.4,60.5L371.4,60.5z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M443.5,91.8l-2.7,0.5l-1.4,0.2l-0.7,0.1c-0.2,0-0.6,0.1-1,0c-0.2-0.1-0.4-0.2-0.4-0.3L437,92l-0.5-0.5l-0.9-1 l-1.8-2.1l-0.9-1l-0.2-0.2l-0.1-0.1c-0.1,0-0.1,0-0.4,0.1l-2.7,0.7l-1.4,0.4c-0.4,0.1-0.7,0-1-0.3l-0.5-0.5l-1.9-2.1l-1.9-2.1 l-0.5-0.5c-0.1-0.2-0.2-0.2-0.3-0.2c-0.2-0.1-0.6,0.4-0.9,0.7l-2.1,1.8l-1.1,0.9l-0.3,0.2c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.3,0.1-0.7-0.1-0.9-0.3c-1.1-1.6-2-3.2-3.1-4.7l-1.5-2.3c-0.2-0.3-0.5-0.2-0.9,0.1l-1.3,0.6c-0.9,0.4-1.6,0.8-2.6,1.2 c-0.3,0.1-0.6,0-0.9-0.2s-0.3-0.5-0.4-0.7l-0.6-1.3l-2.4-5l-1.2-2.5c-0.2-0.4-0.3-0.9-0.7-1c-0.4,0-0.9,0.1-1.3,0.1l-2.8,0.3 c-0.2,0-0.5,0.1-0.8,0s-0.5-0.4-0.5-0.6l-0.6-1.2L392,64l-0.6-1.2c-0.2-0.4-0.4-0.9-0.7-1.1c-0.2-0.1-0.4-0.1-0.6,0 s-0.3,0.3-0.5,0.5l-0.9,1.1c-1.2,1.4-2.3,2.9-3.6,4.3c-0.5,0.2-0.9-0.1-1.4-0.1l-1.4-0.3l-2.7-0.5l2.7,0.5l1.4,0.3 c0.4,0,0.9,0.3,1.3,0.1c1.2-1.4,2.3-2.9,3.5-4.3l0.9-1.1c0.2-0.2,0.3-0.4,0.5-0.5s0.5-0.1,0.7,0c0.5,0.3,0.5,0.8,0.8,1.2l0.7,1.2 l2.7,4.9c0.5,0.7,0.7,2,1.7,1.6l2.8-0.3c0.5,0,0.9-0.1,1.4-0.1c0.3,0,0.5,0.3,0.6,0.5l0.3,0.6l1.2,2.5l2.5,5l0.6,1.3 c0.2,0.5,0.4,0.7,0.7,0.6l2.5-1.2l1.3-0.6c0.2-0.1,0.4-0.2,0.7-0.3c0.3,0,0.7,0.1,0.9,0.3l1.6,2.4l3,4.6c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2-0.1,0.4-0.3l1.1-0.9l2.1-1.8l0.5-0.5c0.1-0.1,0.5-0.4,0.8-0.4s0.7,0.2,0.9,0.4l0.5,0.5l1.9,2l1.9,2l0.4,0.5 c0.1,0.1,0.2,0.1,0.3,0.1l1.3-0.4l2.7-0.7c0.2,0,0.6-0.2,0.9-0.1c0.2,0.1,0.3,0.2,0.5,0.3l0.2,0.3l0.9,1l1.9,2.1l0.9,1l0.5,0.5 l0.2,0.3c0.1,0.1,0.1,0.1,0.1,0.1c0,0.1,0.7-0.1,1.1-0.2l1.4-0.2l2.7-0.5c0.3-0.1,0.6,0.1,0.6,0.4 C443.9,91.5,443.8,91.7,443.5,91.8L443.5,91.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M443.4,109.2l-6.2,1.3l-3.1,0.6c-0.3,0.1-0.5,0.1-0.8,0.2c-0.4,0.1-1-0.3-1.1-0.6l-0.9-1.3l-3.8-5.1 c-0.2-0.3-0.3-0.2-0.8,0.2l-1.4,0.8l-1.4,0.8l-0.7,0.4l-0.4,0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.4,0-0.8-0.5-0.8-0.7l-0.3-0.7 l-0.6-1.5l-1.3-2.9l-1.3-2.9l-0.6-1.5l-0.3-0.7c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.6,0.6-0.9,0.9l-1,1.2l-2,2.5l-0.5,0.6 c-0.2,0.3-0.7,0.4-1,0.3c-0.4-0.2-0.5-0.4-0.7-0.6L410,100l-2.2-2.3l-1.1-1.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.2-0.2-0.3-0.2-0.4 l-0.3-0.7l-1.4-2.9l-2.8-5.7c-0.1-0.5-0.6-0.7-0.9-0.4l-1,1.2l-2,2.5l-1,1.2c-0.2,0.2-0.6,0.3-0.9,0.2c-0.3-0.1-0.4-0.5-0.6-0.7 l-1.6-2.8l-1.6-2.8l-0.8-1.4c-0.2-0.5-0.7-0.7-1.1-0.3l-2.5,2l-1.2,1c-0.2,0.2-0.4,0.4-0.7,0.4c-0.3,0-0.6-0.2-0.6-0.5l-5.1-11.7 l5.2,11.6c0.2,0.5,0.8,0.5,1.2,0.1l1.2-1l2.5-2c0.2-0.2,0.5-0.3,0.8-0.2c0.3,0.1,0.5,0.4,0.6,0.6l0.8,1.4l1.6,2.8l1.6,2.8 c0.1,0.2,0.2,0.5,0.4,0.5c0.2,0.1,0.4,0,0.6-0.1l1-1.2l2-2.5l1-1.2c0.2-0.3,0.6-0.4,0.9-0.3c0.4,0.1,0.5,0.5,0.6,0.7l2.8,5.7 l1.4,2.9l0.4,0.7c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3l1.1,1.1l2.3,2.2l0.6,0.6c0.2,0.2,0.4,0.4,0.5,0.4s0.3,0,0.4-0.1 l0.5-0.6l2-2.5l1-1.2l0.5-0.6c0.1-0.2,0.4-0.6,0.9-0.6c0.4,0,0.8,0.2,0.9,0.6l0.3,0.7l0.7,1.5l1.3,2.9l1.3,2.9l0.7,1.5l0.3,0.7 c0.1,0.3,0.1,0.2,0.3,0.3c0.1,0,0.2,0,0.5-0.2l0.7-0.4l1.4-0.8l1.4-0.8c0.3-0.1,0.3-0.3,0.8-0.4c0.4-0.1,0.9,0.2,1.1,0.5l3.8,5.1 l1,1.3c0.2,0.2,0.1,0.2,0.2,0.2l0.7-0.2l3.1-0.7l6.2-1.3c0.3-0.1,0.6,0.1,0.6,0.4C443.9,108.8,443.7,109.1,443.4,109.2L443.4,109.2 z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M443.3,129.4l-2.7,0.8l-1.4,0.4l-0.7,0.2c-0.3,0-0.3,0.2-0.9,0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1-0.1l-0.3-0.2 l-0.6-0.4l-1.1-0.8l-2.3-1.6l-0.4-0.3l-0.2,0.1l-0.3,0.1l-1.3,0.5l-2.6,1.1l-0.4,0.1c-0.2,0.1-0.5,0.1-0.7,0s-0.4-0.3-0.4-0.4 l-0.2-0.3l-0.6-1.3l-1.3-2.5l-2.6-5c-0.1-0.2-0.2-0.5-0.3-0.6l-0.5-0.5l-1-1l-2-2l-1-1c-0.3-0.3-0.7-0.8-0.8-0.7 c0,0-0.2,0.2-0.4,0.3l-0.5,0.5l-1,1l-2,1.9c-0.2,0.2-0.3,0.3-0.5,0.5c-0.3,0.2-0.8,0.1-1-0.2c-0.3-0.5-0.4-0.9-0.6-1.4l-4.3-10.4 c-0.2-0.5-0.4-0.5-0.8-0.1l-1.1,0.8l-2.3,1.7l-0.6,0.4c-0.2,0.1-0.4,0.4-0.7,0.3c-0.3-0.1-0.5-0.4-0.6-0.5l-0.5-0.5l-1.8-2.1 l-1.8-2.1c-0.2-0.2-0.3-0.4-0.5-0.4c-0.2-0.1-0.4,0.1-0.6,0.2l-1.3,0.6l-2.6,1.1c-0.2,0.1-0.4,0.3-0.7,0.2 c-0.3-0.1-0.4-0.3-0.6-0.5l-0.9-1l-3.8-4.2c-0.1-0.2-0.4-0.2-0.6-0.2l-0.7,0.1l-1.4,0.2l-2.8,0.4l2.8-0.4l1.4-0.2l0.7-0.1 c0.2-0.1,0.5,0,0.7,0.2l3.8,4.1l1,1c0.2,0.2,0.3,0.4,0.5,0.4s0.4-0.1,0.6-0.2l2.6-1.2l1.3-0.6c0.2-0.1,0.4-0.3,0.7-0.2 c0.3,0.1,0.4,0.4,0.6,0.5l1.9,2.1l1.9,2.1l0.5,0.5c0.2,0.2,0.3,0.4,0.4,0.4c0.2,0,0.3-0.1,0.5-0.3l0.6-0.4l2.2-1.7l1.1-0.9l0.3-0.2 c0.1-0.1,0.3-0.2,0.5-0.1c0.4,0,0.6,0.4,0.6,0.6l4.4,10.4l0.5,1.2c0.1,0.1,0.2,0.1,0.3,0l0.5-0.5l2-2l1-1l0.5-0.5 c0.2-0.1,0.2-0.4,0.7-0.5c0.4-0.1,0.8,0.3,0.9,0.4l0.5,0.5l1,1l2,2l1,1l0.5,0.5c0.2,0.3,0.3,0.4,0.4,0.7l2.6,5l1.3,2.5l0.7,1.2 l0.2,0.3c0.1,0.1,0,0,0,0.1l0.3-0.1l2.6-1.1l1.3-0.5l0.3-0.1l0.2-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.5,0.2,0.6,0.2l0.3,0.2l4.5,3.1 l5.1-1.5c0.3-0.1,0.6,0.1,0.6,0.4C443.7,129,443.5,129.3,443.3,129.4L443.3,129.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M343,210.6c0.4-0.7,1.6-0.1,1.2,0.6c-0.7,1.3-1.4,2.5-2.2,3.8l-1.4-0.4C341.3,213.3,342.2,212,343,210.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M344.1,236.4c-0.4-0.2-1.1-0.2-1.6,0.1l-0.6,0.3c-0.5,0.2-0.5,0.6-0.1,0.8s1.1,0.2,1.6-0.1l0.6-0.3 C344.4,237,344.5,236.6,344.1,236.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M347.5,238.2c-0.4-0.2-1.1-0.2-1.6,0.1l-0.6,0.3c-0.5,0.2-0.5,0.6-0.1,0.8s1.1,0.2,1.6-0.1l0.6-0.3 C347.9,238.7,348,238.4,347.5,238.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M343.6,227.3c0.2,2.8,0.2,6.1,0.4,8.9c0,0.8-1.4,0.8-1.4,0c-0.2-2.8-0.3-5.6-0.5-8.4c0-0.8,1.4-0.8,1.4,0 L343.6,227.3z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M347.3,228.6c0.1,3.2,0.1,6.3,0.2,9.5c0,0.8-1.4,0.8-1.4,0c-0.1-3.2-0.5-6.9-0.6-10 C345.4,227.3,347.3,227.9,347.3,228.6L347.3,228.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.0059,
    y1: 380.1636,
    x2: 344.5973,
    y2: 370.3042,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M342.5,212.6c-0.3,1.4-0.3,5.7-0.6,7.1c-0.8,3.7-1.4,4.6-0.2,8.7c0.1,0.3,0.3,0.7,0.6,1 c1.2,1.2,6.4,2.5,7.4,1.8c0.5-0.3,0.2-1-0.1-1.6c-0.5-0.9-3-4.4-2.8-8.4c0.1-2.3,0.8-4.7,1-7c0-0.9,0.1-1.9-0.4-2.8 c-0.5-0.9-2.6-1.5-3.6-1.2C342.5,210.6,342.7,211.7,342.5,212.6z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M347.6,212.1c0.2,1.1,0.4,2.2,0.6,3.3c0.2,0.8,0.7,2.2,0.1,2.9c-1.2,1.5-2.5-0.2-6.2-2.7 c-0.7-0.5,0-1.2,0.7-0.7s1.5,1,2.2,1.5c0.5,0.3,0.9,0.8,1.5,1c0.3,0.2,0.5,0.3,0.6-0.1c0.1-0.3-0.1-0.9-0.1-1.1 c-0.5-2.4-0.4-1.4-0.8-3.9C346.1,211.7,347.5,211.4,347.6,212.1L347.6,212.1z"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M340.6,214.6l1.4,0.4c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.3,0.4-0.2,0.4c0.1,0.1,1,0.1,1.1,0.1 c0.9,0,1.8,0.1,2.7,0.1c0.9,0,0.8,0.8-0.1,0.8c-1.4-0.1-6,0.7-5.1-1.5C340.4,215.1,340.5,214.9,340.6,214.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M345.9,211c0.3-0.1,0.2-0.4-0.1-0.5l-0.4-0.2c-0.3-0.2-0.8-0.2-1.1,0c-0.3,0.1-0.2,0.4,0.1,0.5l0.4,0.2 C345.2,211.1,345.7,211.1,345.9,211z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M345.1,207.4c0.1,0,0.1,0.2,0.2,0.2c0,0.1,0,0.3,0.1,0.4v-0.1c0-0.2,0.1-0.4,0.3-0.4c0.1,0,0.3,0.2,0.3,0.4 s-0.1,0.3-0.2,0.4c0,0.1,0,0.2,0,0.2c0,0.6,0,1.2,0,1.8c0,0.4-1.1,0.4-1.1,0s0-0.7,0-1.1h-0.1c-0.6,0-1.2-0.4-1.2-1v-1.5 C344.2,206.6,343.5,207.6,345.1,207.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M343.6,206.2c0.3-0.2,0.6-0.3,1-0.3c0.1-0.1,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.3,0-0.4 c-0.1-0.2-0.1-0.5,0.1-0.7c0.2-0.1,0.5-0.2,0.7-0.1c0.5,0.1,0.9,0.4,0.9,0.8c0,0.4-0.4,0.7-0.3,1c0,0.1,0.1,0.2,0.1,0.2 c0.1,0.3,0.1,0.6-0.1,0.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2v-0.1 c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.4-0.3-0.4c-0.1,0-0.3,0.2-0.3,0.4v0.1c-0.2-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.3-0.2-0.2 c-1.6,0.2-0.9-0.8-1.8-0.6C343.1,206.8,343.4,206.3,343.6,206.2z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M345.9,215.8c0.4,0,0.7,0.2,0.7,0.6c0,0.3-0.3,0.6-0.7,0.6h-1.1c-0.4,0-0.7-0.2-0.7-0.6 c0-0.3,0.3-0.6,0.7-0.6H345.9z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M342,214.6c0.4,0,0.7,0.2,0.7,0.6c0,0.3-0.3,0.6-0.7,0.6h-1.1c-0.4,0-0.7-0.2-0.7-0.6c0-0.3,0.3-0.6,0.7-0.6 H342z"
  }))), /*#__PURE__*/React.createElement("g", null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M505.8,248.1l12.7-7.4c1-0.6,1.6-1.6,1.6-2.7v-42.4l0.2-0.1c0.8-0.5,1.8,0.1,1.8,1.1v42.8 c0,1.1-0.6,2.2-1.6,2.7l-12.7,7.4c-1.1,0.6-2.5,0-2.8-1.1C505.3,248.3,505.6,248.2,505.8,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M505,206.7c0-1.4,0.7-2.7,2-3.4l13.2-7.6V238c0,1.1-0.6,2.2-1.6,2.7l-12.7,7.4c-0.3,0.1-0.5,0.2-0.8,0.2 c0-0.2-0.1-0.3-0.1-0.5L505,206.7L505,206.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 385.3,
    x2: -2130.0967,
    y2: 385.3,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "509.5,210.8 518.3,205.7 518.3,206.6 509.5,211.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 382,
    x2: -2130.0967,
    y2: 382,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "509.5,214.1 518.3,209 518.3,209.9 509.5,215  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 392.35,
    x2: -2135.8098,
    y2: 392.35,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "518.3,200.3 518.3,201.3 515.2,203 515.2,202.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 390.55,
    x2: -2135.8098,
    y2: 390.55,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "518.3,202.1 518.3,203 515.2,204.8 515.2,203.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 378,
    x2: -2136.3035,
    y2: 378,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "518.3,214.8 518.3,215.7 515.7,217.2 515.7,216.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 376.2,
    x2: -2136.3035,
    y2: 376.2,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "518.3,216.6 518.3,217.5 515.7,219 515.7,218  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 369.9,
    x2: -2132.9277,
    y2: 369.9,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "518.3,221.9 518.3,222.8 512.3,226.3 512.3,225.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 366.3,
    x2: -2132.9277,
    y2: 366.3,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "518.3,225.5 518.3,226.4 512.3,229.9 512.3,229  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 365.5,
    x2: -2136.6445,
    y2: 365.5,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "518.3,227.4 518.3,228.3 516,229.6 516,228.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 360.1,
    x2: -2136.6445,
    y2: 360.1,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "518.3,232.8 518.3,233.7 516,235 516,234.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: -2138.8826,
    y1: 356.5,
    x2: -2136.6445,
    y2: 356.5,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "518.3,236.4 518.3,237.3 516,238.6 516,237.7  "
  })))), /*#__PURE__*/React.createElement("g", null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M476,541.7l7.5-4.3c0.6-0.3,0.9-1,0.9-1.6v-25l0.1-0.1c0.5-0.3,1.1,0.1,1.1,0.6v25.3c0,0.7-0.4,1.3-0.9,1.6 l-7.5,4.3c-0.7,0.4-1.5,0-1.6-0.7C475.7,541.8,475.9,541.8,476,541.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M475.5,517.2c0-0.8,0.4-1.6,1.2-2l7.8-4.5v25c0,0.7-0.4,1.3-0.9,1.6l-7.5,4.3c-0.1,0.1-0.3,0.1-0.5,0.1 c0-0.1,0-0.2,0-0.3v-24.2H475.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 75.55,
    x2: -2098.7708,
    y2: 75.55,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "478.2,519.7 483.4,516.7 483.4,517.2 478.2,520.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 73.6,
    x2: -2098.7708,
    y2: 73.6,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "478.2,521.6 483.4,518.6 483.4,519.2 478.2,522.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 79.7,
    x2: -2102.1462,
    y2: 79.7,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "483.4,513.5 483.4,514 481.5,515.1 481.5,514.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 78.7,
    x2: -2102.1462,
    y2: 78.7,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "483.4,514.5 483.4,515.1 481.5,516.1 481.5,515.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 71.3,
    x2: -2102.4377,
    y2: 71.3,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "483.4,522 483.4,522.6 481.8,523.4 481.8,522.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 70.2,
    x2: -2102.4377,
    y2: 70.2,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "483.4,523.1 483.4,523.6 481.8,524.5 481.8,524  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 66.5,
    x2: -2100.4436,
    y2: 66.5,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "483.4,526.2 483.4,526.8 479.8,528.8 479.8,528.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 64.35,
    x2: -2100.4436,
    y2: 64.35,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "483.4,528.4 483.4,528.9 479.8,530.9 479.8,530.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 63.85,
    x2: -2102.6394,
    y2: 63.85,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "483.4,529.5 483.4,530 482,530.8 482,530.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 60.65,
    x2: -2102.6394,
    y2: 60.65,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "483.4,532.7 483.4,533.2 482,534 482,533.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.9614,
    y1: 58.55,
    x2: -2102.6394,
    y2: 58.55,
    gradientTransform: "matrix(-1 0 0 -1 -1620.6021 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "483.4,534.8 483.4,535.3 482,536.1 482,535.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 5814.7852,
    y1: 299.425,
    x2: 5842.0005,
    y2: 299.425,
    gradientTransform: "matrix(-1 0 0 -1 6049.4707 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M231.5,287.5v6.5c0,0.3-0.2,0.6-0.5,0.8l-11,6.4c-1,0.6-2.3,0.6-3.3,0l-11-6.4c-0.3-0.2-0.5-0.5-0.4-0.8 c-0.1,0-0.1-6.5-0.1-6.5H231.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220,294.7l11-6.4c0.6-0.4,0.6-1.3,0-1.6l-11.1-6.4c-0.9-0.5-2-0.5-3,0l-11.2,6.5c-0.6,0.3-0.6,1.2,0,1.6 l11,6.4C217.8,295.2,219,295.2,220,294.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.6,
    y1: 320.5569,
    x2: 239.8849,
    y2: 320.5569,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M232.9,278.9L221,272c-0.3-0.2-0.4-0.4-0.4-0.6c0-0.3,0.2-0.6,0.5-0.8l4.3-2.5c0.6-0.4,1.6-0.4,2.1-0.1 l11.9,6.9c0.3,0.2,0.4,0.4,0.4,0.6c0,0.3-0.2,0.6-0.5,0.8l-4.3,2.5c-0.3,0.2-0.8,0.3-1.2,0.3C233.5,279.1,233.2,279,232.9,278.9z  M225.5,268.3l-4.3,2.5c-0.3,0.2-0.5,0.4-0.5,0.6s0.1,0.3,0.3,0.4l11.9,6.9c0.5,0.3,1.4,0.3,2-0.1l4.3-2.5 c0.3-0.2,0.5-0.4,0.5-0.6s-0.1-0.3-0.3-0.4l-11.9-6.9c-0.2-0.1-0.5-0.2-0.8-0.2C226.2,268,225.8,268.1,225.5,268.3z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M229.1,273c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.2,0.6,0,0.9l-0.7,0.7c-0.2,0.2-0.6,0.2-0.9,0 c-0.2-0.2-0.2-0.6,0-0.9L229.1,273z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M226,272.2c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.2,0.6,0,0.9l-0.7,0.7c-0.2,0.2-0.6,0.2-0.9,0 c-0.2-0.2-0.2-0.6,0-0.9L226,272.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 5797.6128,
    y1: 319.9731,
    x2: 5806.4341,
    y2: 319.9731,
    gradientTransform: "matrix(-1 0 0 -1 6023.9219 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M226,274.1c-0.8,0.4-1.6,0.9-2.4,1.3c-0.7,0.4-1.6,1.1-2.4,1.1c-1,0-1.5-0.9-2-1.7 c-0.5-0.8-1.1-1.6-1.6-2.3c-0.5-0.7,0.6-1.3,1.1-0.7c0.4,0.6,0.8,1.1,1.2,1.7c0.4,0.5,0.9,1.7,1.6,1.5c0.7-0.2,1.5-0.8,2.1-1.2 c0.6-0.3,1.1-0.6,1.7-1C226.1,272.5,226.7,273.6,226,274.1L226,274.1z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M222.5,279.7c-1.9,0.9-3.7,2.1-5.5,3.1c-1.2,0.7-0.1,2.5,1.1,1.8c1.6-0.9,3.2-1.8,4.8-2.7 c0.1-0.1,0.2-0.2,0.4-0.2c0-0.1,0.1-0.1,0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0.1,0.4v0.1l2.5,1.4 C225.5,281,224.6,278.7,222.5,279.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M223.2,281.6c0.1-0.1,0.2-0.1,0.3-0.2C223.3,281.5,223.2,281.6,223.2,281.6z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M217.9,266.2c0.2-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.3,0.2-0.4c0.2-0.3,0.7,0,1-0.1c0.1,0,0.1-0.1,0.2-0.2 c0.3-0.1,0.6,0.4,0.9,0.3c0.1,0,0.2-0.1,0.3-0.1s0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0,0.1,0.1,0.2,0.1 c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.5-0.2,0.7c0,0.1,0,0.2-0.1,0.3c-0.1,0.3-0.3,0.5-0.5,0.6c-0.1,0.1-0.2,0.1-0.3,0.2v0.4 c0,0.1-0.1,0.1-0.1,0.1h-0.1v-0.1c0-0.3-0.1-0.5-0.3-0.5c-0.1,0-0.3,0.2-0.3,0.5c0,0.1,0,0.3,0.1,0.3c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.2,0.3-0.4,0.5-0.7,0.3l-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1,0-0.1-0.1s-0.1-0.2-0.1-0.2c-0.1-0.2-0.4-0.2-0.4-0.4 c0-0.1,0-0.2,0-0.4c0-0.2-0.3-0.3-0.4-0.4c-0.1-0.2,0-0.3,0.1-0.5c0.1-0.3-0.1-0.6-0.2-0.9C217.6,266.5,217.8,266.3,217.9,266.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M219.1,269.8c0.2,0.1,0.5-0.1,0.7-0.3c0.1-0.2,0.2-0.4,0.3-0.6c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.3,0.1-0.5,0.3-0.5c0.1,0,0.3,0.2,0.3,0.5v0.1c0.2,0,0.2,0,0.2-0.1v-0.4c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.4,0.5-0.6 v1.1c0,0.8-0.6,1.4-1.3,1.5c0,0.5,0,1,0,1.4s-1.1,0.4-1.1,0c0-0.6,0-1.2,0-1.8C219,269.7,219.1,269.8,219.1,269.8z"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M220.1,272c0.2-0.1,0.2-0.4-0.1-0.6l-0.4-0.2c-0.3-0.2-0.7-0.2-1,0c-0.2,0.1-0.2,0.4,0.1,0.6l0.4,0.2 C219.5,272.1,219.9,272.1,220.1,272z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M224.7,262.9l23.2,13.4c0.7,0.4,1.6-0.1,1.6-0.9v-13.3c0-0.7-0.4-1.3-1-1.7l-23.9-13.8 c-0.2-0.1-0.4,0-0.4,0.3V262C224.1,262.3,224.3,262.7,224.7,262.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 342.25,
    x2: 227.7426,
    y2: 342.25,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "227.7,252.4 225,250.8 225,251.1 227.7,252.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 341.25,
    x2: 227.7426,
    y2: 341.25,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "227.7,253.4 225,251.8 225,252.1 227.7,253.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 344.45,
    x2: 225.9704,
    y2: 344.45,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "225,249.1 225,249.4 226,250 226,249.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 343.9,
    x2: 225.9704,
    y2: 343.9,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "225,249.7 225,250 226,250.5 226,250.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 340,
    x2: 225.8173,
    y2: 340,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "225,253.6 225,253.9 225.8,254.4 225.8,254.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 339.45,
    x2: 225.8173,
    y2: 339.45,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "225,254.2 225,254.4 225.8,254.9 225.8,254.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 337.5,
    x2: 226.8642,
    y2: 337.5,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "225,255.8 225,256.1 226.9,257.2 226.9,256.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 336.4,
    x2: 226.8642,
    y2: 336.4,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "225,256.9 225,257.2 226.9,258.3 226.9,258  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 336.15,
    x2: 225.7115,
    y2: 336.15,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "225,257.5 225,257.8 225.7,258.2 225.7,257.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 334.45,
    x2: 225.7115,
    y2: 334.45,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "225,259.2 225,259.5 225.7,259.9 225.7,259.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0173,
    y1: 333.35,
    x2: 225.7115,
    y2: 333.35,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "225,260.3 225,260.6 225.7,261 225.7,260.7  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M226.2,283.1c0.1,0,0.1-0.1,0.2-0.1C226.2,283,226.2,283,226.2,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M219.6,284.5c1.3-0.7,2.5-1.6,3.8-2.3c0.6-0.4,1.3-0.7,1.9-1.1c2.1-1,2.9,1.2,3.3,2.8 c0.2,0.5,0.3,1,0.4,1.5l-2.6-1.5c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.3-0.1-0.4c0.1,0,0.1-0.1,0.2-0.1c-0.2,0-0.2,0-0.2,0.1 c-0.2,0.1-0.4,0.3-0.5,0.4c-1.7,1-3.1,1.9-4.8,2.9C219.7,287,218.4,285.2,219.6,284.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 5801.3496,
    y1: 309.2449,
    x2: 5800.9702,
    y2: 319.5689,
    gradientTransform: "matrix(-1 0 0 -1 6023.9219 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M216.7,275.1c0.1-1.6,0.7-4.4,2.1-4c1.3,0.4,2.3,0.6,2.8,1.6l0.1,0.1c0.4,0.6,2.1,3.4,2.8,3.3 s0.6-0.3,3.8-2.1c0.7-0.4,1.4,0.7,0.7,1.1c-3.8,2.1-4,2.4-4.8,2.4s-1.1-0.4-2.3-2.2c-0.1,1.2-0.2,3.6-0.1,8.6c0,0.4,0.2,1.8,0,2.1 c-0.2,0.4-0.4,0.7-0.8,0.7c-0.4,0-0.9-0.1-1.2-0.4c-3.1-1.7-3.2-2.1-3.3-4C216.3,279.9,216.5,277.5,216.7,275.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M390.9,367.5c-14.6-8.4-14.6-22.1-0.2-30.5c14.5-8.4,38.1-8.3,52.7,0.1s14.7,22.1,0.2,30.5 C429.2,376,405.5,376,390.9,367.5z M441.8,338.1c-13.6-7.9-35.7-7.9-49.2-0.1s-13.5,20.6,0.2,28.5c13.6,7.9,35.7,7.9,49.2,0.1 C455.4,358.8,455.4,346,441.8,338.1z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M401.1,361.6c-9-5.2-9-13.6-0.1-18.7c8.9-5.2,23.4-5.1,32.4,0.1s9,13.6,0.1,18.7 C424.6,366.9,410,366.8,401.1,361.6z M432.5,343.5c-8.5-4.9-22.2-4.9-30.6-0.1c-8.4,4.9-8.4,12.8,0.1,17.7 c8.5,4.9,22.2,4.9,30.6,0.1C441,356.3,441,348.4,432.5,343.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.8993,
    y1: 241.8492,
    x2: 447.0036,
    y2: 241.8492,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M445.7,365.4c-1.7-1-4.4-1-6.1,0c-0.1,0-0.1,0.1-0.2,0.1c-12.4,7-32.3,6.9-44.6-0.3 c-12.4-7.2-12.5-18.8-0.1-26c12.2-7.1,32.1-7.1,44.5-0.1c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1h0.1c1.7,0.8,4.3,0.8,5.9-0.1 s1.7-2.4,0.2-3.4c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-15.8-8.8-41-8.8-56.5,0.2c-15.7,9.1-15.6,23.9,0.2,33 c15.6,9,40.8,9.2,56.5,0.4c0.1-0.1,0.3-0.1,0.4-0.2C447.4,368,447.4,366.4,445.7,365.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.8164,
    y1: 241.7378,
    x2: 442.1326,
    y2: 241.7378,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M434.8,342.1c-9.7-5.6-25.4-5.7-35.1-0.2c-1.1,0.7-1.1,1.6,0,2.2c1,0.6,2.7,0.6,3.8,0l0.1-0.1 c7.6-4.3,19.9-4.2,27.5,0.2c7.7,4.4,7.7,11.6,0.1,16.1c-7.6,4.4-20.1,4.4-27.7-0.1c-1.1-0.6-2.8-0.6-3.8,0s-1,1.6,0,2.2 c9.8,5.7,25.6,5.7,35.3,0.1C444.6,356.9,444.5,347.8,434.8,342.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "89.7,352.4 142.5,382.9 142.9,382.7 90.2,352.1  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "100.5,346.2 153.2,376.7 153.7,376.4 100.9,345.9  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "111.7,339.7 164.4,370.2 164.9,369.9 112.1,339.4  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "122.5,333.4 175.2,364 175.7,363.7 123,333.2  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "131.7,328.1 184.4,358.6 184.8,358.4 132.1,327.9  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "141,322.8 193.7,353.3 194.1,353 141.4,322.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 4417.5464,
    y1: -870.6685,
    x2: 4417.5464,
    y2: -829.1116,
    gradientTransform: "matrix(1.5 -0.2887 -0.866 -0.5 -7230.0825 1214.5962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED3BEF"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M150,374.5c-0.9,0.5-2.3,0.6-3.1,0.1l-32.6-18.9c-0.8-0.5-0.7-1.3,0.2-1.8c0.9-0.5,2.3-0.6,3.1-0.1 l32.6,18.9C151,373.1,150.9,373.9,150,374.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 4458.0698,
    y1: -847.5165,
    x2: 4458.0698,
    y2: -812.6082,
    gradientTransform: "matrix(1.5 -0.2887 -0.866 -0.5 -7230.0825 1214.5962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M190.7,351.2c-0.9,0.5-2.3,0.6-3.1,0.1l-26.9-15.6c-0.8-0.5-0.7-1.3,0.2-1.8s2.3-0.6,3.1-0.1l26.9,15.6 C191.7,349.9,191.6,350.7,190.7,351.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 4439.4336,
    y1: -858.0217,
    x2: 4439.4336,
    y2: -831.0916,
    gradientTransform: "matrix(1.5 -0.2887 -0.866 -0.5 -7230.0825 1214.5962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M171.8,361.8c-0.9,0.5-2.3,0.6-3.1,0.1l-20-11.6c-0.8-0.5-0.7-1.3,0.2-1.8s2.3-0.6,3.1-0.1l20,11.6 C172.9,360.5,172.8,361.3,171.8,361.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 4406.856,
    y1: -873.756,
    x2: 4406.856,
    y2: -867.6561,
    gradientTransform: "matrix(1.5 -0.2887 -0.866 -0.5 -7230.0825 1214.5962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD256F"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M136.7,379.1c-0.9,0.5-2.3,0.6-3.1,0.1l-2-1.1c-0.8-0.5-0.7-1.3,0.2-1.8s2.3-0.6,3.1-0.1l2,1.1 C137.7,377.8,137.6,378.6,136.7,379.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 4428.8081,
    y1: -859.0773,
    x2: 4428.8081,
    y2: -842.2974,
    gradientTransform: "matrix(1.5 -0.2887 -0.866 -0.5 -7230.0825 1214.5962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M156.8,365.4c-0.9,0.5-2.3,0.6-3.1,0.1l-11.2-6.5c-0.8-0.5-0.7-1.3,0.2-1.8s2.3-0.6,3.1-0.1l11.2,6.5 C157.8,364.1,157.7,364.9,156.8,365.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.6,460.6 272.8,461.1 258.3,452.7 259.1,452.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.6,460.6 272.8,461.1 254.4,450.4 255.3,450  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.8,461.1 250.6,448.2 251.4,447.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.8,461.1 246.8,446 247.6,445.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.8,461.1 242.9,443.7 243.8,443.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.9,461 239.1,441.5 239.9,441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.9,461 235.3,439.3 236.1,438.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.9,461 231.4,437.1 232.3,436.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "273.7,460.6 272.9,461 227.6,434.8 228.4,434.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "291.9,450 291.1,450.5 245.8,424.3 246.6,423.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "310.1,439.5 309.3,439.9 264,413.7 264.9,413.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "328.3,428.9 327.5,429.4 282.2,403.2 283.1,402.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "346.6,418.4 345.7,418.9 300.5,392.7 301.3,392.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "364.8,407.8 363.9,408.3 318.7,382.1 319.5,381.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "383,397.3 382.2,397.8 336.9,371.6 337.7,371.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "401.2,386.8 400.4,387.2 355.1,361 355.9,360.5  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 2389.623,
    y1: -598.525,
    x2: 2520.1729,
    y2: -598.525,
    gradientTransform: "matrix(1 -0.5774 -0.866 -0.5 -2653.8894 1531.7961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M371.5,368.6l5.7,20.7l-0.1-0.1c0.8,1.4,0.3,3.1-1.4,4.3c-1.6,1.2-4.3,1.8-6.9,1.7 c-4.4-0.4-8.5-0.8-12.7-1.2l-12.6-1.2c-1.1-0.1-2.1-0.2-3-0.2s-1.8,0.1-2.7,0.3c-1.7,0.4-3.1,1.2-3.9,2.1l-4.7,6.8 c-0.7,1.2-1.9,2.4-3.5,3.3s-3.6,1.6-5.8,2c-1.1,0.2-2.2,0.3-3.3,0.4l-3.2,0.1l-6.4,0.3l-6.4,0.3l-3.2,0.1 c-0.9,0.1-1.8,0.3-2.5,0.6c-0.7,0.3-1.2,0.8-1.5,1.3s-0.2,1,0,1.7l1.1,3.7l2.1,7.3l2.1,7.3c0.5,1.2,0.3,2.6-0.8,3.8 c-0.5,0.6-1.3,1.1-2.2,1.5c-0.9,0.4-1.9,0.6-2.8,1l-11.2,3.5c-3.6,1.2-6.1,3.5-6.5,5.9l-3,14.7l2.7-14.7c0.4-2.5,2.9-4.8,6.6-6.2 l11.1-3.6c0.9-0.3,1.9-0.6,2.7-0.9c0.8-0.4,1.5-0.8,1.9-1.3c1-1,1.1-2.2,0.6-3.4l-2.3-7.3l-2.3-7.3l-1.1-3.6 c-0.2-0.6-0.4-1.4-0.1-2c0.3-0.7,1-1.3,1.9-1.8s2.1-0.8,3.3-0.8l3.2-0.2l6.4-0.3l6.4-0.3l3.2-0.2c1-0.1,2-0.2,2.9-0.3 c1.9-0.3,3.6-1,5-1.8s2.3-1.8,3-2.9l4.6-6.9c1-1.3,2.8-2.3,5.1-2.9c1.1-0.3,2.3-0.4,3.6-0.4c1.3,0,2.3,0.1,3.4,0.2l12.7,1.1 l12.6,1.1c1.7,0.1,3.3-0.3,4.3-1.1c1-0.8,1.3-1.8,0.8-2.7c-0.1-0.1-6.1-20.8-6.1-20.8c-0.2-0.5,0.5-1,1.4-1.1 C370.5,367.7,371.3,368.1,371.5,368.6L371.5,368.6z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M210.3,407.4c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C210.6,407,210.6,407.2,210.3,407.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M212.6,408.7c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C212.8,408.3,212.8,408.5,212.6,408.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M214.8,410c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0C215,409.6,215,409.9,214.8,410z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M217.1,411.3c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C217.3,410.9,217.3,411.2,217.1,411.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M219.3,412.6c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C219.5,412.2,219.5,412.5,219.3,412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M221.5,413.9c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C221.8,413.5,221.8,413.8,221.5,413.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M223.8,415.2c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C224,414.8,224,415.1,223.8,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M226,416.5c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C226.3,416.1,226.3,416.4,226,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M228.3,417.8c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C228.5,417.5,228.5,417.7,228.3,417.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M230.5,419.1c-0.2,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.2-0.4,0-0.5s0.6-0.1,0.9,0 C230.8,418.8,230.8,419,230.5,419.1z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "223.2,400.5 214.7,405.3 213.7,404.7 222.1,399.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "225.3,401.7 216.9,406.5 215.8,405.9 224.2,401.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "227.4,402.9 219,407.8 217.9,407.1 226.3,402.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "236.3,400.2 221.1,409 220,408.4 235.2,399.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "237.2,404.2 228.8,409.1 227.7,408.4 236.1,403.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "239.3,405.4 230.9,410.3 229.8,409.7 238.2,404.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "241.4,406.7 233,411.5 231.9,410.9 240.4,406  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "240.3,389.3 223.1,399.2 224.2,399.8 241.4,389.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "242.3,391.9 226.3,401.1 225.3,400.4 241.2,391.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "244.6,391.8 227.4,401.7 228.5,402.3 245.7,392.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "246.7,393 238.1,397.9 239.2,398.6 247.8,393.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "250.6,395.2 237.2,403 238.3,403.6 251.7,395.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "252.7,396.5 239.3,404.2 240.4,404.8 253.8,397.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "254.9,397.7 241.4,405.4 242.5,406 255.9,398.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "248.6,405.5 240.2,410.3 239.1,409.7 247.5,404.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "257.4,399.2 248.6,404.2 249.7,404.8 258.5,399.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "259.6,400.4 241.3,410.9 242.3,411.6 260.6,401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "261.7,401.6 243.4,412.2 244.5,412.8 262.8,402.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "206.1,409.1 199.2,413.1 200.3,413.7 207.1,409.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "208.2,410.3 201.3,414.3 202.4,414.9 209.2,411  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "212.4,412.8 202,418.8 203.1,419.4 213.5,413.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "205.9,421 207,421.7 215.1,417 214,416.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "195.7,415.1 196.7,415.7 199.2,414.3 198.1,413.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "197.8,416.3 198.9,417 201.3,415.5 200.2,414.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "212.7,425 213.8,425.6 217.3,423.6 216.2,423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "214.8,426.2 215.9,426.9 219.4,424.8 218.3,424.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 163,
    y1: 195.25,
    x2: 196.2502,
    y2: 195.25,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M167.6,402.6c5.2,3,13.5,3,18.6,0s5.1-7.8-0.1-10.8c0,0-0.1,0-0.1-0.1l4.4-2.6c0,0,0.1,0,0.1,0.1 c7.6,4.4,7.7,11.6,0.1,15.9c-7.6,4.4-19.9,4.4-27.5,0c0,0-0.1,0-0.1-0.1l4.4-2.6C167.5,402.5,167.5,402.6,167.6,402.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.3,
    y1: 388.9875,
    x2: 190.6,
    y2: 388.9875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M190.6,389.3l-4.4,2.6c-5.1-2.9-13.3-2.9-18.4,0l-4.5-2.6C170.8,385,183,385,190.6,389.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M167.8,391.9C167.7,391.9,167.7,391.9,167.8,391.9c-5.2,3-5.2,7.8-0.1,10.8l-4.4,2.6 c-7.5-4.4-7.5-11.5,0-15.9C163.3,389.3,167.8,391.9,167.8,391.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M198.4,385.5c5.2,3,13.5,3,18.6,0s5.1-7.8-0.1-10.8c0,0-0.1,0-0.1-0.1l4.4-2.6c0,0,0.1,0,0.1,0.1 c7.6,4.4,7.7,11.6,0.1,15.9c-7.6,4.4-19.9,4.4-27.5,0c0,0-0.1,0-0.1-0.1l4.4-2.6C198.3,385.5,198.4,385.5,198.4,385.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.2,
    y1: 371.95,
    x2: 221.5,
    y2: 371.95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M221.5,372.3l-4.4,2.6c-5.1-2.9-13.3-2.9-18.4,0l-4.5-2.6C201.7,367.9,213.9,367.9,221.5,372.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M198.6,374.8L198.6,374.8c-5.2,3-5.2,7.8-0.1,10.8l-4.4,2.6c-7.5-4.4-7.5-11.5,0-15.9L198.6,374.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M532.7,409.3l-13.5-7.8c-1-0.6-1.7-1.7-1.7-2.9v-44.9l-0.2-0.1c-0.9-0.5-1.9,0.1-1.9,1.1v45.4 c0,1.2,0.6,2.3,1.7,2.9l13.5,7.8c1.2,0.7,2.6,0,2.9-1.2C533.3,409.6,533,409.5,532.7,409.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M533.6,365.4c0-1.5-0.8-2.9-2.1-3.6l-14-8.1v44.9c0,1.2,0.6,2.3,1.7,2.9l13.5,7.8c0.3,0.2,0.5,0.2,0.8,0.2 c0-0.2,0.1-0.3,0.1-0.5V365.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 519.2419,
    y1: 223.6611,
    x2: 525.1798,
    y2: 223.6611,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M522.8,373.4c0-1.5,1-2.1,2.3-1.4v-4c-3.3-1.9-5.9-0.4-5.9,3.4l3.6,2.1 C522.8,373.5,522.8,373.5,522.8,373.4z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M522.9,373.6l-3.6-2.1c0,1.9,0.7,4,1.8,5.9l2.6-1.6C523.2,375.1,522.9,374.3,522.9,373.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.0001,
    y1: 218.617,
    x2: 531.2,
    y2: 218.617,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M531.2,378.4c0-3.8-2.7-8.4-6-10.3v3.9c1.3,0.8,2.4,2.6,2.4,4.1s-1.1,2.1-2.4,1.4c-0.6-0.4-1.2-1-1.6-1.7 l-2.6,1.6c1.1,1.9,2.6,3.5,4.2,4.4C528.5,383.8,531.2,382.2,531.2,378.4L531.2,378.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 519.4104,
    y1: 207.2611,
    x2: 525.349,
    y2: 207.2611,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M523,389.8c0-1.5,1-2.1,2.3-1.4v-4c-3.3-1.9-5.9-0.4-5.9,3.4l3.6,2.1C523,389.9,523,389.9,523,389.8z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M523,390l-3.6-2.1c0,1.9,0.7,4,1.8,5.9l2.6-1.6C523.3,391.5,523.1,390.7,523,390z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.1623,
    y1: 202.217,
    x2: 531.3622,
    y2: 202.217,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M531.4,394.8c0-3.8-2.7-8.4-6-10.3v3.9c1.3,0.8,2.4,2.6,2.4,4.1s-1.1,2.1-2.4,1.4c-0.6-0.4-1.2-1-1.6-1.7 l-2.6,1.6c1.1,1.9,2.6,3.5,4.2,4.4C528.7,400.2,531.4,398.6,531.4,394.8L531.4,394.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.8575,
    y1: 221.65,
    x2: 538.3718,
    y2: 221.65,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M538.4,372.8c0,0.5-0.3,0.7-0.8,0.4c-0.4-0.2-0.8-0.8-0.8-1.3s0.3-0.7,0.8-0.4 C538,371.7,538.4,372.3,538.4,372.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.8575,
    y1: 217.15,
    x2: 538.3718,
    y2: 217.15,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M538.4,377.3c0,0.5-0.3,0.7-0.8,0.4c-0.4-0.2-0.8-0.8-0.8-1.3s0.3-0.7,0.8-0.4 C538,376.3,538.4,376.8,538.4,377.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M538.4,381.9c0,0.5-0.3,0.7-0.8,0.4c-0.4-0.2-0.8-0.8-0.8-1.3s0.3-0.7,0.8-0.4 C538,380.8,538.4,381.4,538.4,381.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.8575,
    y1: 208.05,
    x2: 538.3718,
    y2: 208.05,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M538.4,386.4c0,0.5-0.3,0.7-0.8,0.4c-0.4-0.2-0.8-0.8-0.8-1.3s0.3-0.7,0.8-0.4 C538,385.4,538.4,386,538.4,386.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.8575,
    y1: 203.45,
    x2: 538.3718,
    y2: 203.45,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M538.4,391c0,0.5-0.3,0.7-0.8,0.4c-0.4-0.2-0.8-0.8-0.8-1.3s0.3-0.7,0.8-0.4 C538,389.9,538.4,390.5,538.4,391z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M487.6,559c0.4-0.2,1.2-0.2,1.7,0.1l0.7,0.3c0.5,0.3,0.6,0.7,0.1,0.9c-0.4,0.2-1.2,0.2-1.7-0.1l-0.7-0.3 C487.2,559.7,487.2,559.3,487.6,559z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M492.3,556.8c0.4-0.2,1.2-0.2,1.7,0.1l0.7,0.3c0.5,0.3,0.6,0.7,0.1,0.9c-0.4,0.2-1.2,0.2-1.7-0.1l-0.7-0.3 C491.9,557.4,491.9,557,492.3,556.8z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M489.8,539.4c-2.6,6.2-2.9,13.5-1.5,20c0.3,1.4,2.6,0.8,2.3-0.6c-1.3-6.1-1-13,1.5-18.8 C492.7,538.7,490.3,538.1,489.8,539.4L489.8,539.4z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M493.7,548.6c-0.1-2.5,0.9-5,1.7-7.4c0.2-0.5-0.2-1.1-0.9-1.1h-1.3c-0.9,2.8-2,5.6-2,8.5 c0.1,2.9,1,5.8,1.6,8.6c0.3,1.4,2.6,0.8,2.3-0.6C494.7,554,493.8,551.3,493.7,548.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M479.2,531c-0.9-0.1-0.9,1.3,0,1.4c1.8,0.1,3.6,0.4,5.4,0.4l-0.1-1.4C482.7,531.4,480.9,531.2,479.2,531z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: -7516.9717,
    y1: 64.527,
    x2: -7523.0156,
    y2: 58.7156,
    gradientTransform: "matrix(1 0 0 -1 8014.0376 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M494.7,536.6c-1.1-8.8-1.1-9.2-2.2-9.4s-2,0.6-2.5,1.5c-0.7,0.5-1.4,0.9-2.1,1.4c-0.8,0.5-1.7,1.3-2.8,1.3 c-0.2,0-0.3,0-0.5,0l0.1,1.4c0.2,0,0.4,0,0.7,0c1.4,0,2.9-1,4.1-1.9c-0.2,3.5,0.9,3.9,0.9,6c0,1.4-0.7,2.3-1.5,5.3 c-0.9,3.2,6.4-0.2,6.8-1.5C496.1,539.1,494.8,537.5,494.7,536.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M492.5,525.8c0,0.7,0,1.3,0,2c0,0.5-1.3,0.5-1.2,0c0-0.7,0-1.3,0-2C491.2,525.3,492.5,525.3,492.5,525.8 L492.5,525.8z"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M491.9,526.2c0.1,0,0.2,0,0.3-0.1c0.5-0.6,0.5-1.8,0.2-2.6c-0.2-0.5-0.5-0.8-1.4-0.8 c-0.2,0-0.9-0.1-1.1,0.2c-0.1,0-0.1,0.1-0.2,0.1v1.7c0,0.8,0.8,1.5,1.7,1.5L491.9,526.2L491.9,526.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.4529,
    y1: 524.1461,
    x2: 493.0925,
    y2: 524.1461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M490.1,524.2c0.3,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.6,0.4,0.8c0.2,0.3,0.5,0.5,0.8,0.3 c0.6-0.3,1.3-2.1,0.6-3.2c-0.5-0.8-2.6-0.7-3.2-0.2C489.2,523,489.7,523.9,490.1,524.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M491.3,524.7c0,0.3-0.1,0.5-0.3,0.5c-0.2,0-0.3-0.2-0.3-0.5c0-0.1,0.3-0.5,0.3-0.5 C491.1,524.2,491.3,524.4,491.3,524.7z"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M490.9,528.1c-0.3-0.2-0.3-0.4,0.1-0.6l0.4-0.2c0.3-0.2,0.9-0.2,1.2,0c0.3,0.2,0.3,0.4-0.1,0.6l-0.4,0.2 C491.7,528.3,491.2,528.3,490.9,528.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 492.3055,
    y1: 530.0427,
    x2: 499.3408,
    y2: 530.0427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M494.3,525.4c0.9,0.4,1.9,0.7,2.3,1.5c0.3,0.7,0.1,1.4,0.3,2.1c0.3,1,1.5,1.7,2.1,2.6 c0.7,1.2,0.3,2.9-1,3.7s-3.2,0.7-4.3-0.3c-1.1-0.9-1.5-2.6-0.9-3.9c0.3-0.6,0.7-1,0.9-1.6c0.2-0.6,0.3-1.2-0.1-1.7 c-0.2-0.2-0.6-0.4-0.7-0.7c-0.2-0.4,0.2-0.9,0.1-1.3c0-0.4-1-1.2-0.6-1.5C493,524,493.9,525.2,494.3,525.4z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.1,231.1l-13-7.6c-1.3-0.7-2.9-0.8-4.2,0l-12.5,10.9l10.4,7.5h6.3l12.9-8 C214.2,233.2,214.2,231.7,213.1,231.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.2162,
    y1: 374.575,
    x2: 209.5162,
    y2: 374.575,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M207,197h-27.3v37c0,0.3,0.2,0.7,0.5,0.8l11.5,6.6c1,0.6,2.3,0.6,3.4,0l11.4-6.6c0.3-0.2,0.5-0.5,0.5-0.9 C207,234.1,207,197,207,197z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.7,204.6l-11.5-6.6c-0.6-0.4-0.6-1.3,0-1.7l11.5-6.7c1-0.6,2.1-0.6,3.1,0l11.7,6.8c0.6,0.4,0.6,1.3,0,1.6 l-11.4,6.6C194,205.2,192.7,205.2,191.7,204.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M192.3,202.6l-8.3-4.8c-0.5-0.3-0.5-0.9,0-1.2l8.3-4.8c0.7-0.4,1.5-0.4,2.2,0l8.4,4.9 c0.5,0.3,0.5,0.9,0,1.2l-8.2,4.8C194,203,193.1,203,192.3,202.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.8949,
    y1: 399.55,
    x2: 183.5791,
    y2: 399.55,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M184.1,197.2l8.3-4.8c0.7-0.4,1.5-0.4,2.2,0l8.4,4.9c0.1,0.1,0.2,0.1,0.2,0.2c0.2-0.3,0.1-0.7-0.2-0.9 l-8.4-4.9c-0.7-0.4-1.5-0.4-2.2,0l-8.3,4.8c-0.4,0.2-0.4,0.6-0.3,1C183.9,197.4,183.9,197.3,184.1,197.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M199.5,206.9c0-0.5,0.3-1.2,0.7-1.4s0.7,0,0.7,0.5v13.6l-1.4,0.8V206.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: -2315.7085,
    y1: 359.8514,
    x2: -2315.7085,
    y2: 371.6373,
    gradientTransform: "matrix(-1 0 0 -1 -2115.4084 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M201,219.7v12.1c0,0.5-0.3,1.2-0.7,1.4s-0.7,0-0.7-0.5v-12.1L201,219.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.45,
    y1: 396.8269,
    x2: 197.7672,
    y2: 396.8269,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M196.5,195.4c-1.3-0.7-3.2-0.9-4.8-0.5v0.9c1.1-0.5,2.7-0.5,3.8,0.1c1.1,0.7,1.1,1.7,0,2.4s-3,0.6-4.1,0 l-1,0.6c1.7,1,4.4,1,6.1,0C198.2,198,198.2,196.4,196.5,195.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M507.3,118.3l-10.8-6.2c-0.6-0.4-0.6-1.2,0-1.6l10.8-6.3c0.9-0.5,2-0.5,2.9,0l11,6.3 c0.6,0.3,0.6,1.2,0,1.5l-10.7,6.2C509.5,118.9,508.3,118.9,507.3,118.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.3726,
    y1: 486.3375,
    x2: 495.8845,
    y2: 486.3375,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M496.5,111.3l10.8-6.3c0.9-0.5,2-0.5,2.9,0l11,6.3c0.1,0.1,0.2,0.2,0.3,0.3c0.2-0.4,0.1-1-0.3-1.2 l-11-6.3c-0.9-0.5-2-0.5-2.9,0l-10.8,6.3c-0.5,0.3-0.6,0.8-0.3,1.2C496.3,111.6,496.4,111.4,496.5,111.3z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.8426,
    y1: 482.7442,
    x2: 514.3833,
    y2: 482.7442,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M512.8,109c-1.7-1-4.2-1.2-6.2-0.7v1.2c1.5-0.7,3.6-0.6,4.9,0.2c1.5,0.9,1.5,2.2,0,3.1 c-1.5,0.9-3.9,0.8-5.3,0l-1.3,0.7c2.2,1.3,5.8,1.3,7.9,0C514.9,112.3,514.9,110.3,512.8,109z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.7,441.5L87,424.8c-2.8-1.6-6.3-1.7-9.2,0L41,446.1l32.3,19.2h13.9l28.5-17.6 C118.1,446.3,118,442.9,115.7,441.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.8283,
    y1: 148,
    x2: 109.6794,
    y2: 148,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M107.6,426.4v18c0,0.9-0.4,1.8-1.3,2.3l-30.5,17.7c-2.8,1.6-6.2,1.6-9,0l-30.4-17.6 c-0.9-0.5-1.3-1.4-1.2-2.3H35v-18h72.6V426.4z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.7,446.1l30.5-17.7c1.7-1,1.7-3.5,0-4.5l-30.7-17.8c-2.5-1.5-5.7-1.5-8.2,0l-31.1,18 c-1.7,1-1.7,3.4,0,4.3L66.6,446C69.5,447.8,73,447.8,75.7,446.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.7,459.3l-35.5-20.6c-3.5-2-7.8-2-11.3,0L88,468.3l28.4,20.4h17.2l35.2-21.8 C171.7,465.2,171.6,461,168.7,459.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.3162,
    y1: 166,
    x2: 154.6162,
    y2: 166,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M152.1,366.8H77.8v100.8c0,0.9,0.4,1.8,1.3,2.3l31.2,18.1c2.9,1.6,6.4,1.6,9.2,0l31.1-18 c0.9-0.5,1.3-1.5,1.3-2.4h0.2V366.8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.4,387.3l-31.2-18.1c-1.8-1-1.8-3.6,0-4.6l31.4-18.2c2.6-1.5,5.8-1.5,8.4,0l31.7,18.4 c1.7,1,1.7,3.4,0,4.4l-31.1,18C116.7,389,113.2,389,110.4,387.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.7,485.3L172,466.5c-3.2-1.9-7.2-1.9-10.5,0l-32,18.3v11.5l26.9,15.8h15.8l32.5-19.8 C207.4,490.7,207.3,486.9,204.7,485.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.5641,
    y1: 119.1875,
    x2: 700.0487,
    y2: 119.1875,
    gradientTransform: "matrix(1 0 0 -1 -515.401 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M122.3,437.6v54.6c0,0.8,0.4,1.6,1.2,2.1l28.6,16.6c2.6,1.5,5.8,1.5,8.5,0l28.5-16.5 c0.8-0.5,1.2-1.3,1.2-2.2h0.2v-54.4L122.3,437.6z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.2,456.2l-28.6-16.6c-1.6-0.9-1.6-3.3,0-4.2l28.8-16.7c2.4-1.4,5.3-1.4,7.7,0l29.1,16.9 c1.6,0.9,1.6,3.2,0,4.1l-28.5,16.5C158,457.7,154.8,457.7,152.2,456.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.7,326.1l-10.5-6.1c-1-0.6-2.3-0.6-3.4,0l-13.5,7.8l11.8,7h5.1l10.4-6.4 C292.6,327.8,292.5,326.6,291.7,326.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 7100.8247,
    y1: 266.325,
    x2: 7128.3594,
    y2: 266.325,
    gradientTransform: "matrix(-1 0 0 -1 7392.7515 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M288.7,320.5v6.6c0,0.3-0.2,0.6-0.5,0.8l-11.2,6.5c-1,0.6-2.3,0.6-3.3,0l-11.1-6.4 c-0.3-0.2-0.5-0.5-0.5-0.8c-0.1,0-0.1-6.6-0.1-6.6h26.7V320.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M277.1,327.7l11.2-6.5c0.6-0.4,0.6-1.3,0-1.6l-11.2-6.5c-0.9-0.5-2.1-0.5-3,0l-11.4,6.6 c-0.6,0.4-0.6,1.2,0,1.6l11.1,6.4C274.8,328.3,276.1,328.3,277.1,327.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 7070.0024,
    y1: 287.7069,
    x2: 7089.5352,
    y2: 287.7069,
    gradientTransform: "matrix(-1 0 0 -1 7367.2026 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M291.1,312c-0.4,0-0.7-0.1-1-0.2l-12.1-7c-0.3-0.2-0.4-0.4-0.4-0.6c0-0.3,0.2-0.6,0.6-0.8l4.3-2.5 c0.6-0.4,1.6-0.4,2.2-0.1l12.1,7c0.3,0.2,0.4,0.4,0.4,0.6c0,0.3-0.2,0.6-0.6,0.8l-4.3,2.5C292,311.9,291.5,312,291.1,312z  M290.3,311.6c0.5,0.3,1.4,0.3,2-0.1l4.3-2.5c0.3-0.2,0.5-0.4,0.5-0.6s-0.1-0.3-0.3-0.4l-12.1-7c-0.5-0.3-1.4-0.3-2,0.1l-4.3,2.5 c-0.3,0.2-0.5,0.4-0.5,0.6s0.1,0.3,0.3,0.4L290.3,311.6z"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M281.8,295.6l23.5,13.6c0.7,0.4,1.6-0.1,1.6-0.9v-13.4c0-0.7-0.4-1.3-1-1.7l-24.1-14c-0.2-0.1-0.5,0-0.5,0.3 v15.2C281.3,295,281.5,295.4,281.8,295.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 309.7,
    x2: 284.9025,
    y2: 309.7,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "284.9,285 282.1,283.4 282.1,283.7 284.9,285.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 308.65,
    x2: 284.9025,
    y2: 308.65,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "284.9,286 282.1,284.4 282.1,284.7 284.9,286.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 311.9,
    x2: 283.1092,
    y2: 311.9,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "282.1,281.7 282.1,282 283.1,282.5 283.1,282.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 311.35,
    x2: 283.1092,
    y2: 311.35,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "282.1,282.2 282.1,282.5 283.1,283.1 283.1,282.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 307.4,
    x2: 282.9543,
    y2: 307.4,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "282.1,286.2 282.1,286.5 283,287 283,286.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 306.85,
    x2: 282.9543,
    y2: 306.85,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "282.1,286.8 282.1,287.1 283,287.5 283,287.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 304.85,
    x2: 284.0139,
    y2: 304.85,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "282.1,288.5 282.1,288.7 284,289.8 284,289.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 303.75,
    x2: 284.0139,
    y2: 303.75,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "282.1,289.6 282.1,289.9 284,290.9 284,290.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 303.45,
    x2: 282.8474,
    y2: 303.45,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "282.1,290.2 282.1,290.5 282.8,290.9 282.8,290.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 301.75,
    x2: 282.8474,
    y2: 301.75,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "282.1,291.9 282.1,292.1 282.8,292.6 282.8,292.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.145,
    y1: 300.65,
    x2: 282.8474,
    y2: 300.65,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "282.1,293 282.1,293.3 282.8,293.7 282.8,293.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M275.4,315.3c1.5-0.6,3-1.1,4.4-1.7c1.5-0.6,3.8-1.4,4.2,1c0.1,0.8,0.1,1.7,0,2.5l-2.3-1.3 c0-0.3,0-0.5,0-0.5s-1.4,0.5-2,0.8c-1.2,0.5-2.5,0.9-3.7,1.4C274.6,317.9,274,315.8,275.4,315.3z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M278.9,317.2c1.5-0.5,2.9-1.1,4.4-1.6c0.5-0.2,1.1-0.5,1.7-0.5c1.2-0.1,2.2,0.7,2.4,1.9 c0.1,0.7,0.1,1.4,0,2.2l-2.2-1.3v-0.1c-0.1-0.4,0.1-0.3-0.3-0.3c-0.4-0.1-1.4,0.5-1.8,0.7c-1.2,0.4-2.4,0.9-3.6,1.3 C278.1,319.9,277.5,317.7,278.9,317.2z"
  })))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M278.2,305.4c0.3-0.2,0.3-0.6-0.1-0.8l-0.7-0.4c-0.4-0.2-1-0.3-1.3-0.1c-0.3,0.2-0.3,0.6,0.1,0.8l0.7,0.4 C277.2,305.5,277.8,305.6,278.2,305.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M285.9,307.4c-0.6,0.3-1.2,0.7-1.8,1c-0.7,0.4-1.6,1.1-2.4,1.3c-0.5,0.1-0.9-0.2-1.3-0.7l-0.9,0.6 c0.5,0.8,1,1.5,2,1.4c0.8-0.1,1.7-0.8,2.4-1.2c0.8-0.5,1.7-0.9,2.5-1.4C287.1,308,286.6,307,285.9,307.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.3118,
    y1: 274.2598,
    x2: 706.3118,
    y2: 285.9768,
    gradientTransform: "matrix(-1 0 0 -1 983.5887 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M274.3,312.8c0.3-2.3,0.5-4.3,1-6.6c0.7-2.8,1.9-2.5,2.7-1.9c1.2,0.8,1.8,1.6,1.8,3.7 c0.2,0.3,0.4,0.7,0.6,1l-0.7,0.5c0,0.1,0,0.3,0,0.4c-0.2,3.2-0.5,3,0.2,7.6c0.1,0.6,0.2,1.2-0.1,1.7c-0.4,0.8-1.3,0.7-2.1,0.6 C274.5,318.9,273.8,316.7,274.3,312.8z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M276.9,302.3c0,0.7,0,1.4,0,2.1c0,0.5,1.2,0.5,1.2,0c0-0.7,0-1.4,0-2.1 C278,301.8,276.9,301.8,276.9,302.3L276.9,302.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M277.3,302.8c-0.1,0-0.2,0-0.3-0.1c-0.5-0.6-0.5-1.9-0.2-2.7c0.2-0.6,0.4-0.8,1.3-0.9 c0.2,0,0.8-0.1,1.1,0.2c0.1,0,0.1,0.1,0.2,0.1v1.8c0,0.9-0.7,1.6-1.6,1.6H277.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M279,300.7c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.5,0.5-0.8,0.3 c-0.5-0.3-1.2-2.2-0.6-3.4c0.4-0.8,2.5-0.7,3-0.2C279.9,299.5,279.4,300.3,279,300.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.6247,
    y1: 303.9985,
    x2: 279.6413,
    y2: 303.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M275.4,300.4c-0.1,0.7,0.1,1.4-0.3,1.9c-0.4,0.6-1.9,1-2.8,2c-1.5,1.8-0.4,4.8,2.3,5.3 c2.6,0.5,4-2,2.6-4.2c-0.7-1.1,0.4-1,0.8-1.6c0.2-0.3,0.4-0.9,0.3-1.2c-0.1-0.3-0.2-0.3-0.3-0.7c-0.5-1.5,1.3-0.9,1.6-2.1 C280.1,297.8,275.9,297.7,275.4,300.4z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M285.6,308.1c-0.2-0.3-0.1-0.7,0.3-0.9l0.7-0.4c0.3-0.2,0.7-0.1,0.9,0.3c0.2,0.3,0.1,0.7-0.3,0.9l-0.7,0.4 C286.2,308.6,285.8,308.4,285.6,308.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M293.5,298.3c1.8,1.1,3.3,0.2,3.3-1.9s-1.5-4.7-3.3-5.7v-1.8c2.7,1.6,4.9,5.4,4.9,8.5s-2.2,4.4-4.9,2.8 C293.5,300.1,293.5,298.3,293.5,298.3L293.5,298.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 690.0211,
    y1: 298.05,
    x2: 694.8923,
    y2: 298.05,
    gradientTransform: "matrix(-1 0 0 -1 983.5887 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M290.3,292.6c0,2.1,1.5,4.7,3.3,5.8v1.8c-2.7-1.6-4.9-5.4-4.9-8.5C288.7,291.7,290.3,292.6,290.3,292.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.9,439.3l10-5.8c1-0.6,2.2-0.6,3.2,0l12.8,7.4l-11.3,6.7h-4.8l-9.9-6.1 C139.1,440.9,139.1,439.7,139.9,439.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 1583.0491,
    y1: 153.125,
    x2: 1609.2784,
    y2: 153.125,
    gradientTransform: "matrix(1 0 0 -1 -1443.3691 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M142.7,434v6.3c0,0.3,0.2,0.6,0.5,0.8l10.6,6.2c1,0.6,2.2,0.6,3.1,0l10.6-6.1c0.3-0.2,0.4-0.5,0.4-0.8 c0.1,0,0.1-6.3,0.1-6.3h-25.3V434z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M153.8,440.9l-10.6-6.2c-0.6-0.3-0.6-1.2,0-1.6l10.7-6.2c0.9-0.5,2-0.5,2.9,0l10.8,6.3 c0.6,0.3,0.6,1.2,0,1.5l-10.6,6.1C156,441.4,154.8,441.4,153.8,440.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 1552.4869,
    y1: 173.6569,
    x2: 1571.0869,
    y2: 173.6569,
    gradientTransform: "matrix(1 0 0 -1 -1417.8203 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M139.3,425.5l-4.1-2.4c-0.3-0.2-0.5-0.5-0.5-0.7s0.1-0.4,0.4-0.6l11.5-6.7c0.5-0.3,1.5-0.3,2.1,0.1 l4.1,2.4c0.3,0.2,0.5,0.5,0.5,0.7s-0.1,0.4-0.4,0.6l-11.5,6.7c-0.2,0.1-0.6,0.2-0.9,0.2C140.1,425.8,139.6,425.7,139.3,425.5z  M152.8,418.8c0.2-0.1,0.3-0.3,0.3-0.4c0-0.2-0.2-0.4-0.4-0.6l-4.1-2.4c-0.6-0.3-1.4-0.4-1.9-0.1l-11.5,6.7 c-0.2,0.1-0.3,0.3-0.3,0.4c0,0.2,0.2,0.4,0.4,0.6l4.1,2.4c0.6,0.3,1.4,0.4,1.9,0.1L152.8,418.8z"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M145.1,420c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l0.7,0.7c0.2,0.2,0.6,0.2,0.9,0 c0.2-0.2,0.2-0.6,0-0.9L145.1,420z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148,419.2c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l0.7,0.7c0.2,0.2,0.6,0.2,0.9,0 c0.2-0.2,0.2-0.6,0-0.9L148,419.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.791,
    y1: 420.9488,
    x2: 156.3273,
    y2: 420.9488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091C13"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M148.1,421c0.8,0.4,1.5,0.9,2.3,1.3c0.7,0.4,1.5,1.1,2.3,1c1,0,1.4-0.9,1.9-1.6s1.1-1.5,1.6-2.2 s-0.6-1.3-1.1-0.6c-0.4,0.6-0.8,1.1-1.2,1.7c-0.3,0.5-0.8,1.6-1.5,1.5s-1.4-0.8-2-1.1c-0.5-0.3-1.1-0.6-1.6-0.9 C148,419.5,147.4,420.6,148.1,421L148.1,421z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 1565.9891,
    y1: 165.2732,
    x2: 1574.9875,
    y2: 165.2732,
    gradientTransform: "matrix(1 0 0 -1 -1417.8203 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M151.4,426.4c1.8,0.8,3.5,2,5.3,3c1.1,0.6,0.1,2.4-1,1.7c-1.5-0.9-3.1-1.7-4.6-2.6 c-0.1-0.1-0.2-0.2-0.4-0.2c0-0.1-0.1-0.1-0.3-0.2c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0,0.2-0.1,0.4v0.1l-2.4,1.4 C148.5,427.7,149.4,425.5,151.4,426.4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M150.7,428.3c-0.1-0.1-0.2-0.1-0.3-0.2C150.6,428.2,150.7,428.2,150.7,428.3z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M155.8,413.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2-0.3-0.7,0-1-0.1 c-0.1,0-0.1-0.1-0.2-0.2c-0.3-0.1-0.5,0.3-0.9,0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.5,0.2,0.7c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.5,0.4,0.6 c0.1,0.1,0.2,0.1,0.2,0.2v0.3c0,0.1,0.1,0.1,0.1,0.1c0.1-0.1,0.1-0.1,0.1-0.1c0-0.2,0.1-0.5,0.2-0.5c0.1,0,0.2,0.2,0.2,0.5 c0,0.1,0,0.3-0.1,0.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.4,0.4,0.7,0.3l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0,0.1-0.1 s0.1-0.1,0.1-0.2c0.1-0.2,0.3-0.2,0.4-0.4c0-0.1,0-0.2,0-0.3c0-0.2,0.3-0.2,0.3-0.4c0.1-0.2,0-0.3-0.1-0.5 c-0.1-0.3,0.1-0.6,0.2-0.8C156.1,413.7,156,413.5,155.8,413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M154.7,416.9c-0.2,0.1-0.5-0.1-0.7-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0.1-0.2,0.1-0.3 c0-0.2-0.1-0.5-0.2-0.5c-0.1,0-0.2,0.2-0.2,0.5v0.1c-0.1,0-0.2,0-0.2-0.1v-0.3c-0.1-0.1-0.2-0.1-0.2-0.2 c-0.2-0.1-0.3-0.3-0.4-0.6v1.1c0,0.7,0.6,1.4,1.3,1.4c0,0.5,0,0.9,0,1.4c0,0.4,1,0.4,1,0c0-0.6,0-1.1,0-1.7 C154.8,416.8,154.7,416.9,154.7,416.9z"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M153.7,419c-0.2-0.1-0.2-0.4,0.1-0.5l0.4-0.2c0.3-0.2,0.7-0.2,0.9,0c0.2,0.1,0.2,0.4-0.1,0.5l-0.4,0.2 C154.4,419.1,153.9,419.1,153.7,419z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M149.3,410.2L127,423.1c-0.7,0.4-1.5-0.1-1.5-0.9v-12.8c0-0.7,0.4-1.3,0.9-1.6l23-13.3 c0.2-0.1,0.4,0,0.4,0.2v14.5C149.8,409.7,149.7,410,149.3,410.2z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "146.4,400.1 149,398.6 149,398.9 146.4,400.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "146.4,401.1 149,399.6 149,399.8 146.4,401.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,397 149,397.2 148.1,397.8 148.1,397.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,397.5 149,397.8 148.1,398.3 148.1,398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,401.3 149,401.6 148.2,402 148.2,401.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,401.8 149,402.1 148.2,402.5 148.2,402.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,403.4 149,403.7 147.2,404.7 147.2,404.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,404.5 149,404.8 147.2,405.8 147.2,405.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,405.1 149,405.3 148.3,405.7 148.3,405.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,406.7 149,407 148.3,407.3 148.3,407.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "149,407.7 149,408 148.3,408.4 148.3,408.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M147.9,429.7c-0.1,0-0.1-0.1-0.2-0.1C147.9,429.6,147.9,429.6,147.9,429.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 1562.9272,
    y1: 163.6805,
    x2: 1572.4833,
    y2: 163.6805,
    gradientTransform: "matrix(1 0 0 -1 -1417.8203 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M154.2,431.1c-1.2-0.7-2.4-1.5-3.7-2.2c-0.6-0.4-1.2-0.7-1.9-1c-2-1-2.7,1.2-3.2,2.7 c-0.1,0.5-0.3,1-0.4,1.5l2.5-1.4c0.1-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.1-0.3,0.1-0.4c-0.1,0-0.1-0.1-0.2-0.1c0.2,0,0.2,0,0.2,0.1 c0.2,0.1,0.4,0.3,0.5,0.3c1.6,1,3,1.8,4.6,2.8C154.1,433.4,155.3,431.7,154.2,431.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.888,
    y1: 425.5307,
    x2: 157.3266,
    y2: 425.5307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M157,422c-0.1-1.5-0.6-4.3-2-3.9c-1.2,0.4-2.3,0.6-2.7,1.5l-0.1,0.1c-0.4,0.6-2,3.3-2.7,3.1 c-0.6-0.1-0.6-0.3-3.7-2.1c-0.7-0.4-1.3,0.7-0.6,1.1c3.6,2,3.9,2.3,4.6,2.3c0.8,0,1.1-0.4,2.3-2.1c0.1,1.2,0.2,3.4,0.1,8.3 c0,0.4-0.2,1.7,0,2.1s0.4,0.6,0.8,0.6c0.4,0,0.8-0.1,1.2-0.3c3-1.6,3-2,3.1-3.9C157.4,426.6,157.2,424.3,157,422z"
  })), /*#__PURE__*/React.createElement("g", null, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "st157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M137.1,414.9c-2.5,1.5-4.6,0.3-4.6-2.6s2.1-6.5,4.6-8s4.6-0.3,4.6,2.6S139.6,413.4,137.1,414.9z  M137.1,404.6c-2.4,1.4-4.3,4.7-4.3,7.4c0,2.7,1.9,3.8,4.3,2.5c2.4-1.4,4.3-4.7,4.3-7.4C141.4,404.4,139.5,403.3,137.1,404.6z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M137.2,412.8c-1.6,0.9-2.8,0.2-2.8-1.6c0-1.8,1.3-4,2.8-4.9c1.6-0.9,2.8-0.2,2.8,1.6 S138.7,411.9,137.2,412.8z M137.2,406.4c-1.5,0.9-2.7,2.9-2.7,4.6s1.2,2.4,2.7,1.5s2.7-2.9,2.7-4.6 C139.8,406.3,138.6,405.6,137.2,406.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: -5253.3306,
    y1: 1088.3286,
    x2: -5241.8169,
    y2: 1088.3286,
    gradientTransform: "matrix(0.866 -0.5 0 -1.1547 4681.564 -957.3589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M142.2,406.6c0-0.3-0.2-0.5-0.5-0.3s-0.5,0.6-0.5,0.9c0,2.5-1.8,5.5-3.9,6.8c-2.2,1.3-3.9,0.2-3.9-2.2 c0-2.5,1.7-5.5,3.9-6.7c0.3-0.2,0.6-0.6,0.6-0.9s-0.2-0.5-0.5-0.3c-2.8,1.7-5,5.5-5,8.6c0,3.2,2.2,4.4,5,2.8 C139.9,413.7,142.1,409.9,142.2,406.6C142.1,406.7,142.2,406.7,142.2,406.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: -5251.1333,
    y1: 1088.4963,
    x2: -5244.021,
    y2: 1088.4963,
    gradientTransform: "matrix(0.866 -0.5 0 -1.1547 4681.564 -957.3589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M137.2,406c-1.7,1-3.1,3.3-3.1,5.3c0,0.2,0.1,0.3,0.3,0.2c0.2-0.1,0.3-0.4,0.3-0.6c0-1.6,1.1-3.4,2.4-4.2 c1.3-0.8,2.4-0.2,2.4,1.4c0,1.5-1.1,3.4-2.4,4.2c-0.2,0.1-0.3,0.4-0.3,0.6s0.1,0.3,0.3,0.2c1.7-1,3.1-3.4,3.1-5.3 C140.2,405.8,138.9,405,137.2,406z"
  })))), /*#__PURE__*/React.createElement("g", null, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M232,259.7c0-2.7,1.9-3.7,4.2-2.4s4.2,4.6,4.2,7.2c0,2.7-1.9,3.7-4.2,2.4S232,262.3,232,259.7z  M232.3,259.8c0,2.5,1.8,5.5,3.9,6.8c2.2,1.2,3.9,0.2,3.9-2.2c0-2.5-1.8-5.5-3.9-6.8C234,256.3,232.3,257.3,232.3,259.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1210.7559,
    y1: -1582.5005,
    x2: 1221.2167,
    y2: -1582.5005,
    gradientTransform: "matrix(-0.866 -0.5 0 -1.1547 1289.1766 -957.3589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M231.6,259.4c0-0.3,0.2-0.4,0.5-0.3c0.3,0.2,0.5,0.5,0.5,0.8c0,2.3,1.6,5,3.6,6.1s3.6,0.2,3.6-2 s-1.6-5-3.5-6.1c-0.3-0.2-0.5-0.6-0.5-0.8c0-0.3,0.2-0.4,0.4-0.3c2.5,1.5,4.5,5,4.5,7.8c0,2.9-2,4-4.5,2.6 C233.7,265.8,231.7,262.3,231.6,259.4L231.6,259.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.7,309.5l-10-5.8c-1-0.6-2.2-0.6-3.2,0l-12.8,7.4l11.3,6.7h4.8l9.9-6.1 C262.5,311.1,262.5,310,261.7,309.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: -1759.3947,
    y1: 283.225,
    x2: -1732.083,
    y2: 283.225,
    gradientTransform: "matrix(-1 0 0 -1 -1496.3484 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M259.9,303.7v6.5c0,0.3-0.2,0.6-0.5,0.8l-11.1,6.4c-1,0.6-2.3,0.6-3.3,0l-11-6.4 c-0.3-0.2-0.5-0.5-0.5-0.8c-0.1,0-0.1-6.5-0.1-6.5H259.9z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M248.3,310.9l11.1-6.4c0.6-0.4,0.6-1.3,0-1.6l-11.1-6.5c-0.9-0.5-2.1-0.5-3,0l-11.3,6.5 c-0.6,0.4-0.6,1.2,0,1.6l11,6.4C246.1,311.5,247.3,311.5,248.3,310.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.5597,
    y1: 304.3569,
    x2: -0.1521,
    y2: 304.3569,
    gradientTransform: "matrix(1 0 0 -1 268.435 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M262.2,295.3c-0.4,0-0.7-0.1-1-0.2l-12-6.9c-0.3-0.2-0.4-0.4-0.4-0.6c0-0.3,0.2-0.6,0.6-0.8l4.3-2.5 c0.7-0.4,1.6-0.4,2.2-0.1l12,6.9c0.3,0.2,0.4,0.4,0.4,0.6c0,0.3-0.2,0.6-0.6,0.8l-4.3,2.5 C263.1,295.2,262.6,295.3,262.2,295.3z M261.4,294.8c0.5,0.3,1.4,0.2,1.9-0.1l4.3-2.5c0.3-0.2,0.4-0.4,0.4-0.6 s-0.1-0.3-0.3-0.4l-12-6.9c-0.5-0.3-1.4-0.2-1.9,0.1l-4.3,2.5c-0.3,0.2-0.4,0.4-0.4,0.6s0.1,0.3,0.3,0.4L261.4,294.8z"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M257.4,289.2c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.2,0.6,0,0.9l-0.7,0.7c-0.2,0.2-0.6,0.2-0.9,0 c-0.2-0.2-0.2-0.6,0-0.9L257.4,289.2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M254.4,288.4c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.2,0.6,0,0.9l-0.7,0.7c-0.2,0.2-0.6,0.2-0.9,0 c-0.2-0.2-0.2-0.6,0-0.9L254.4,288.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: -1776.5475,
    y1: 303.873,
    x2: -1767.6952,
    y2: 303.873,
    gradientTransform: "matrix(-1 0 0 -1 -1521.8972 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M254.3,290.2c-0.8,0.4-1.6,0.9-2.4,1.3c-0.7,0.4-1.6,1.1-2.4,1.1c-1,0-1.5-0.9-2-1.7 c-0.6-0.8-1.1-1.6-1.7-2.3c-0.5-0.7,0.6-1.3,1.1-0.7c0.4,0.6,0.8,1.2,1.2,1.7s0.9,1.7,1.6,1.5c0.7-0.2,1.5-0.8,2.1-1.2 c0.6-0.3,1.1-0.6,1.7-1C254.4,288.7,255.1,289.8,254.3,290.2L254.3,290.2z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M250.9,295.9c-1.9,0.9-3.7,2.1-5.5,3.1c-1.2,0.7-0.1,2.5,1.1,1.8c1.6-0.9,3.2-1.8,4.8-2.7 c0.1-0.1,0.2-0.2,0.4-0.3c0-0.1,0.1-0.1,0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0.1,0.4v0.1l2.5,1.4 C253.9,297.1,253,294.9,250.9,295.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M251.6,297.8c0.1-0.1,0.2-0.1,0.3-0.2C251.7,297.7,251.6,297.7,251.6,297.8z"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M248.4,288.1c0.2-0.1,0.2-0.4-0.1-0.6l-0.4-0.2c-0.3-0.2-0.7-0.2-1,0c-0.2,0.1-0.2,0.4,0.1,0.6l0.4,0.2 C247.8,288.3,248.2,288.3,248.4,288.1z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M253,279l23.3,13.5c0.7,0.4,1.6-0.1,1.6-0.9v-13.3c0-0.7-0.4-1.3-1-1.7L253,262.7c-0.2-0.1-0.4,0-0.4,0.3 v15.1C252.5,278.4,252.7,278.8,253,279z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 326.2,
    x2: 256.0787,
    y2: 326.2,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st165",
    points: "256.1,268.5 253.3,266.9 253.3,267.2 256.1,268.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 325.15,
    x2: 256.0787,
    y2: 325.15,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "256.1,269.5 253.3,267.9 253.3,268.2 256.1,269.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 328.4,
    x2: 254.3003,
    y2: 328.4,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st167",
    points: "253.3,265.2 253.3,265.5 254.3,266 254.3,265.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 327.8,
    x2: 254.3003,
    y2: 327.8,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "253.3,265.8 253.3,266 254.3,266.6 254.3,266.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 323.95,
    x2: 254.1468,
    y2: 323.95,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st169",
    points: "253.3,269.7 253.3,270 254.1,270.4 254.1,270.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 323.4,
    x2: 254.1468,
    y2: 323.4,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st170",
    points: "253.3,270.2 253.3,270.5 254.1,271 254.1,270.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 321.4,
    x2: 255.1973,
    y2: 321.4,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st171",
    points: "253.3,271.9 253.3,272.2 255.2,273.3 255.2,273  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 320.3,
    x2: 255.1973,
    y2: 320.3,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "253.3,273 253.3,273.3 255.2,274.4 255.2,274.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 320.05,
    x2: 254.0403,
    y2: 320.05,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "253.3,273.6 253.3,273.9 254,274.3 254,274  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 318.35,
    x2: 254.0403,
    y2: 318.35,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st174",
    points: "253.3,275.3 253.3,275.6 254,276 254,275.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3438,
    y1: 317.25,
    x2: 254.0403,
    y2: 317.25,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "253.3,276.4 253.3,276.7 254,277.1 254,276.8  "
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M254.5,299.3c0.1,0,0.1-0.1,0.2-0.1C254.5,299.2,254.5,299.2,254.5,299.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M247.9,300.7c1.3-0.7,2.5-1.6,3.8-2.3c0.6-0.4,1.3-0.7,1.9-1.1c2.1-1,2.9,1.2,3.3,2.8 c0.2,0.5,0.3,1,0.4,1.5l-2.6-1.5c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.3-0.1-0.4c0.1,0,0.1-0.1,0.2-0.1 c-0.2,0-0.2,0-0.2,0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-1.7,1-3.2,1.9-4.8,2.9C248,303.2,246.7,301.4,247.9,300.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: -1772.7565,
    y1: 293.0507,
    x2: -1773.1373,
    y2: 303.4114,
    gradientTransform: "matrix(-1 0 0 -1 -1521.8972 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M245,291.2c0.1-1.6,0.7-4.5,2.1-4.1c1.3,0.4,2.3,0.6,2.8,1.6l0.1,0.1c0.4,0.6,2.1,3.4,2.8,3.3 s0.6-0.3,3.8-2.1c0.7-0.4,1.4,0.7,0.7,1.1c-3.8,2.1-4,2.4-4.8,2.4s-1.1-0.4-2.4-2.2c-0.1,1.2-0.2,3.6-0.1,8.7 c0,0.4,0.2,1.8,0,2.1c-0.2,0.4-0.4,0.7-0.8,0.7c-0.4,0-0.9-0.1-1.2-0.4c-3.1-1.7-3.2-2.1-3.3-4 C244.6,296.1,244.8,293.7,245,291.2z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M249.3,284.6c-0.1,0.1-0.2,0.1-0.3,0.2v0.3c0,0.1-0.1,0.1-0.1,0.1h-0.1v-0.1c0-0.2-0.1-0.4-0.3-0.4 s-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0.1,0.3c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.2-0.5,0.4-0.8,0.3c0,0-0.1,0-0.1-0.1c0,0.5,0,1,0,1.5 c0,0.4,1.2,0.4,1.2,0s0-0.8,0-1.3c0.8-0.1,1.5-0.6,1.5-1.3v-1C249.7,284.3,249.5,284.5,249.3,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M247.3,286.2c0.3,0.1,0.6-0.1,0.8-0.3c0.1-0.2,0.2-0.3,0.3-0.5c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.2,0.1-0.4,0.3-0.4s0.3,0.2,0.3,0.4v0.1h0.1c0.1,0,0.1-0.1,0.1-0.1v-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.3,0.5-0.5 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.1-0.1-0.2s-0.3-0.2-0.5-0.2c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2,0.1-0.4,0.2c-0.8-0.2-2-0.1-2.3,0.4c-0.6,0.9,0,2.2,0.5,2.6C247.2,286.1,247.3,286.2,247.3,286.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.676,
    y1: 315.8576,
    x2: 674.7184,
    y2: 315.8576,
    gradientTransform: "matrix(-1 0 0 -1 939.4106 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M264.7,281.7c1.9,1.1,3.4,0.2,3.4-1.9s-1.5-4.8-3.4-5.9V272c2.8,1.6,5,5.5,5,8.7s-2.2,4.5-5,2.9 C264.7,283.5,264.7,281.7,264.7,281.7L264.7,281.7z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M264.8,272.1v1.9c-1.8-1-3.3-0.2-3.3,1.9l-1.6-0.9C259.8,271.8,262,270.5,264.8,272.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M295.3,267.5c0.3-0.6,0.5-1.4,0.5-2.4c0-3.5-2.5-7.7-5.5-9.5c-0.8-0.5-1.5-0.7-2.2-0.7c-0.5,0-1,0-1.4,0.2 l2.4-1.3c1-0.6,2.4-0.6,4,0.3c3,1.8,5.5,6,5.5,9.5c0,1.6-0.5,2.8-1.4,3.4c-0.1,0-0.1,0.1-0.2,0.1s-2.7,1.5-2.7,1.5 C294.7,268.3,295,267.9,295.3,267.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.8642,
    y1: 332.1805,
    x2: 295.8401,
    y2: 332.1805,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M286.7,255c0.4-0.2,0.9-0.3,1.4-0.2c0.7,0,1.4,0.3,2.2,0.7c3,1.8,5.5,6,5.5,9.5c0,1-0.2,1.8-0.5,2.4 c-0.3,0.5-0.6,0.9-1.1,1.1c-1,0.6-2.4,0.5-3.9-0.4c-3-1.8-5.5-6-5.5-9.5C284.9,256.8,285.6,255.5,286.7,255z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M290,264.6c-0.6-0.4-1.2-0.9-1.7-1.4v-1.5c0.3,0.4,0.7,0.7,1,1c0.4,0.3,0.7,0.6,1,0.7 c0.2,0.1,0.4,0.2,0.5,0.2s0.2-0.1,0.2-0.2s0-0.2-0.1-0.3c-0.1-0.1-0.2-0.3-0.4-0.5c-0.2-0.2-0.4-0.4-0.7-0.7 c-0.3-0.3-0.6-0.7-0.8-1c-0.2-0.3-0.4-0.6-0.5-0.9s-0.1-0.6-0.1-0.9c0-0.5,0.1-0.8,0.4-1c0.3-0.1,0.7-0.1,1.3,0.2v-0.6l0.8,0.5 v0.6c0.5,0.3,1.1,0.8,1.6,1.4l-0.5,1c-0.6-0.6-1.1-1.1-1.5-1.3c-0.2-0.1-0.4-0.2-0.5-0.2s-0.1,0.1-0.1,0.2s0,0.2,0.1,0.3 c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0.2,0.4,0.4,0.6,0.7c0.6,0.6,1,1.1,1.2,1.5s0.4,0.9,0.4,1.3c0,0.5-0.1,0.9-0.4,1 c-0.3,0.2-0.7,0.1-1.3-0.1v0.9l-0.8-0.5V264.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.7142,
    y1: 331.85,
    x2: 237.3874,
    y2: 331.85,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M235.8,263.9c-0.4-0.2-0.7-0.5-1.1-0.9v-1c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.2,0.4,0.4,0.6,0.5 c0.1,0.1,0.3,0.1,0.3,0.1c0.1,0,0.1,0,0.1-0.1s0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.2-0.3s-0.3-0.3-0.5-0.5s-0.4-0.4-0.5-0.6 s-0.2-0.4-0.3-0.6s-0.1-0.4-0.1-0.6c0-0.3,0.1-0.5,0.3-0.6s0.5,0,0.8,0.1v-0.4l0.5,0.3v0.4c0.3,0.2,0.7,0.5,1,0.9l-0.3,0.7 c-0.4-0.4-0.7-0.7-1-0.8c-0.1-0.1-0.2-0.1-0.3-0.1s-0.1,0-0.1,0.1s0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.4,0.4 c0.4,0.4,0.6,0.7,0.8,0.9c0.2,0.3,0.2,0.6,0.2,0.9s-0.1,0.5-0.3,0.6s-0.4,0.1-0.8-0.1v0.6l-0.5-0.3v-0.6H235.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.3,276.8l-10.6-6.2c-1.1-0.6-2.3-0.6-3.4,0l-10.2,8.9l8.5,6.1h5.2l10.6-6.5 C323.2,278.6,323.1,277.3,322.3,276.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.5162,
    y1: 326.5125,
    x2: 319.8162,
    y2: 326.5125,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M317.3,249.1H295v30.3c0,0.3,0.1,0.5,0.4,0.7l9.4,5.4c0.9,0.5,1.9,0.5,2.8,0l9.3-5.4 c0.3-0.2,0.4-0.4,0.4-0.7C317.3,279.3,317.3,249.1,317.3,249.1z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M304.8,255.2l-9.4-5.4c-0.5-0.3-0.5-1.1,0-1.4l9.4-5.4c0.8-0.4,1.7-0.4,2.5,0l9.5,5.5c0.5,0.3,0.5,1,0,1.3 l-9.3,5.4C306.7,255.7,305.6,255.7,304.8,255.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.1,284.6l-9.8-5.6c-1-0.6-2.2-0.6-3.1,0l-9.6,5.5v3.5l8.1,4.7h4.8l9.8-5.9 C333.9,286.2,333.9,285.1,333.1,284.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 821.3128,
    y1: 312.5125,
    x2: 842.4665,
    y2: 312.5125,
    gradientTransform: "matrix(1 0 0 -1 -515.401 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M308.4,270.3v16.4c0,0.2,0.1,0.5,0.4,0.6l8.6,5c0.8,0.5,1.8,0.5,2.5,0l8.6-5c0.2-0.1,0.4-0.4,0.3-0.7 c0.1,0,0.1-16.3,0.1-16.3H308.4z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M317.3,275.9l-8.6-5c-0.5-0.3-0.5-1,0-1.3l8.6-5c0.7-0.4,1.6-0.4,2.3,0l8.7,5.1c0.5,0.3,0.5,0.9,0,1.2 l-8.6,5C319.1,276.3,318.1,276.3,317.3,275.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M322.5,271.1c0.3-0.6,0.5-1.4,0.5-2.4c0-3.5-2.5-7.7-5.5-9.5c-0.8-0.5-1.5-0.7-2.2-0.7c-0.5,0-1,0-1.4,0.2 l2.4-1.3c1-0.6,2.4-0.6,4,0.3c3,1.8,5.5,6,5.5,9.5c0,1.6-0.5,2.8-1.4,3.4c-0.1,0-0.1,0.1-0.2,0.1s-2.7,1.5-2.7,1.5 C321.9,272,322.2,271.6,322.5,271.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.0726,
    y1: 328.4805,
    x2: 323.0484,
    y2: 328.4805,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M313.9,258.7c0.4-0.2,0.9-0.3,1.4-0.2c0.7,0,1.4,0.3,2.2,0.7c3,1.8,5.5,6,5.5,9.5c0,1-0.2,1.8-0.5,2.4 c-0.3,0.5-0.6,0.9-1.1,1.1c-1,0.6-2.4,0.5-3.9-0.4c-3-1.8-5.5-6-5.5-9.5C312.1,260.5,312.8,259.2,313.9,258.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M309.6,248.9c0.3-0.6,0.5-1.4,0.5-2.4c0-3.5-2.5-7.7-5.5-9.5c-0.8-0.5-1.5-0.7-2.2-0.7c-0.5,0-1,0-1.4,0.2 l2.4-1.3c1-0.6,2.4-0.6,4,0.3c3,1.8,5.5,6,5.5,9.5c0,1.6-0.5,2.8-1.4,3.4c-0.1,0-0.1,0.1-0.2,0.1s-2.7,1.5-2.7,1.5 C309,249.8,309.4,249.4,309.6,248.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.1844,
    y1: 350.6805,
    x2: 310.1603,
    y2: 350.6805,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M301,236.5c0.4-0.2,0.9-0.3,1.4-0.2c0.7,0,1.4,0.3,2.2,0.7c3,1.8,5.5,6,5.5,9.5c0,1-0.2,1.8-0.5,2.4 c-0.3,0.5-0.6,0.9-1.1,1.1c-1,0.6-2.4,0.5-3.9-0.4c-3-1.8-5.5-6-5.5-9.5C299.2,238.3,299.9,237,301,236.5z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "304.5,242.8 305.4,242.6 305.4,241.6 304.5,241.8 304.5,239.7 303,238.8 303,242.1 302.2,242.2  302.2,243.2 303,243.1 303,245.5 306.8,247.7 306.8,246.2 304.5,244.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.8298,
    y1: 300.1,
    x2: 294.9804,
    y2: 300.1,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "293.5,293.6 294.1,293.5 294.1,292.8 293.5,292.9 293.5,291.5 292.4,290.9 292.4,293.1  291.8,293.2 291.8,293.9 292.4,293.8 292.4,295.4 295,296.9 295,296 293.5,295.1  "
  }))), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "317.3,261.3 315.2,264.2 317.2,269.6 319.3,266.6  "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M301.4,256.2c0-0.6-0.3-1.2-0.8-1.5c-0.4-0.2-0.8,0-0.8,0.6v6l1.5,0.9L301.4,256.2L301.4,256.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.7,
    y1: 315.7044,
    x2: 300.7,
    y2: 328.9529,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M299.9,261.3v15.8c0,0.6,0.3,1.2,0.8,1.5c0.4,0.2,0.8,0,0.8-0.6v-15.9L299.9,261.3z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M314.2,276.5c0-0.6-0.3-1.2-0.8-1.5c-0.4-0.2-0.8,0-0.8,0.6c0,0.1,0,6,0,6l1.5,0.8L314.2,276.5L314.2,276.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.4,
    y1: 306.1103,
    x2: 313.4,
    y2: 319.3584,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M312.6,281.5v4c0,0.6,0.3,1.2,0.8,1.5c0.4,0.2,0.8,0,0.8-0.6c0-0.1,0-4,0-4L312.6,281.5z"
  })), /*#__PURE__*/React.createElement("g", null, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.5,290.9l-10.6-6.2c-1.1-0.6-2.3-0.6-3.4,0l-10.2,8.9l8.5,6.1h5.2l10.6-6.5 C349.4,292.7,349.4,291.5,348.5,290.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.7467,
    y1: 312.4125,
    x2: 346.0467,
    y2: 312.4125,
    gradientTransform: "matrix(1 0 0 -1 -2.5162 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M343.5,263.2h-22.3v30.3c0,0.3,0.1,0.5,0.4,0.7l9.4,5.4c0.9,0.5,1.9,0.5,2.8,0l9.3-5.4 c0.3-0.2,0.4-0.4,0.4-0.7C343.5,293.4,343.5,263.2,343.5,263.2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M331,269.3l-9.4-5.4c-0.5-0.3-0.5-1.1,0-1.4l9.4-5.4c0.8-0.4,1.7-0.4,2.5,0l9.5,5.5c0.5,0.3,0.5,1,0,1.3 l-9.3,5.4C332.9,269.8,331.9,269.8,331,269.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M335,263.4c0.3-0.6,0.5-1.4,0.5-2.4c0-3.5-2.5-7.7-5.5-9.5c-0.8-0.5-1.5-0.7-2.2-0.7c-0.5,0-1,0-1.4,0.2 l2.4-1.3c1-0.6,2.4-0.6,4,0.3c3,1.8,5.5,6,5.5,9.5c0,1.6-0.5,2.8-1.4,3.4c-0.1,0-0.1,0.1-0.2,0.1s-2.7,1.5-2.7,1.5 C334.4,264.3,334.7,263.9,335,263.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.5701,
    y1: 336.1805,
    x2: 335.5459,
    y2: 336.1805,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M326.4,251c0.4-0.2,0.9-0.3,1.4-0.2c0.7,0,1.4,0.3,2.2,0.7c3,1.8,5.5,6,5.5,9.5c0,1-0.2,1.8-0.5,2.4 c-0.3,0.5-0.6,0.9-1.1,1.1c-1,0.6-2.4,0.5-3.9-0.4c-3-1.8-5.5-6-5.5-9.5C324.6,252.8,325.3,251.5,326.4,251z"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M332,259.3c-0.2-0.3-0.4-0.7-0.8-1c0.3,0,0.5,0,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.8c0-0.5-0.2-1.1-0.5-1.5 c-0.2-0.3-0.5-0.6-0.9-0.8v-0.8l-0.6-0.4v0.8c-0.1,0-0.2-0.1-0.2-0.1l-0.5-0.3v-0.8l-0.6-0.4v0.8l-0.8-0.5v6.4l0.8,0.5v0.8l0.6,0.4 v-0.8l0.8,0.4v0.8l0.6,0.4v-0.8c0.4,0.1,0.7,0.2,1,0.1c0.4-0.1,0.6-0.5,0.6-1C332.2,260,332.1,259.6,332,259.3z M329.4,255.5 l0.4,0.3c0.5,0.3,0.7,0.6,0.7,1c0,0.2-0.1,0.3-0.2,0.4c-0.1,0-0.3,0-0.5-0.1l-0.5-0.3L329.4,255.5z M329.9,259.6l-0.5-0.3v-1.4 l0.5,0.3c0.2,0.1,0.4,0.3,0.5,0.5s0.2,0.4,0.2,0.6C330.6,259.8,330.4,259.8,329.9,259.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.2993,
    y1: 316.3,
    x2: 265.7738,
    y2: 316.3,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M265.6,278.8c-0.1-0.2-0.2-0.4-0.4-0.6c0.2,0,0.3,0,0.4-0.1s0.1-0.2,0.1-0.4c0-0.3-0.1-0.6-0.3-0.9 c-0.1-0.2-0.3-0.3-0.5-0.5v-0.5l-0.3-0.2v0.4l-0.1-0.1l-0.3-0.2v-0.4l-0.3-0.2v0.4l-0.5-0.3v3.7l0.5,0.3v0.4l0.3,0.2v-0.4l0.4,0.3 v0.4l0.3,0.2v-0.5c0.2,0.1,0.4,0.1,0.5,0.1c0.2-0.1,0.3-0.3,0.3-0.6C265.8,279.2,265.7,279,265.6,278.8z M264.2,276.7l0.2,0.1 c0.3,0.2,0.4,0.3,0.4,0.5c0,0.1,0,0.2-0.1,0.2s-0.2,0-0.3-0.1l-0.3-0.2L264.2,276.7z M264.5,279l-0.3-0.2V278l0.3,0.2 c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.2,0.1,0.3C264.9,279.1,264.7,279.1,264.5,279z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M327.4,271.5c0-0.6-0.3-1.2-0.8-1.5c-0.4-0.2-0.8,0-0.8,0.6v2.3l1.5,0.9L327.4,271.5L327.4,271.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.6,
    y1: 306.1102,
    x2: 326.6,
    y2: 319.3585,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M325.8,272.9v19.5c0,0.6,0.3,1.2,0.8,1.5c0.4,0.2,0.8,0,0.8-0.6v-19.5L325.8,272.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M273.3,231.8c-0.1,0.1-0.2,0.1-0.3,0.2v0.3c0,0.1-0.1,0.1-0.1,0.1h-0.1v-0.1c0-0.2-0.1-0.4-0.3-0.4 s-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0.1,0.3c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.2-0.5,0.4-0.8,0.3c0,0-0.1,0-0.1-0.1c0,0.5,0,1,0,1.5 c0,0.4,1.2,0.4,1.2,0s0-0.8,0-1.3c0.8-0.1,1.4-0.6,1.4-1.3v-1C273.7,231.5,273.5,231.7,273.3,231.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.4489,
    y1: 231.6633,
    x2: 274.2,
    y2: 231.6633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M271.3,233.3c0.3,0.1,0.6-0.1,0.8-0.3c0.1-0.2,0.2-0.3,0.3-0.5c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.2,0.1-0.4,0.3-0.4s0.3,0.2,0.3,0.4v0.1h0.1c0.1,0,0.1-0.1,0.1-0.1V232c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.3,0.5-0.5 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.1,0-0.2,0 s-0.2,0.1-0.4,0.2c-0.8-0.2-2-0.1-2.3,0.4c-0.6,0.9,0,2.2,0.5,2.6C271.2,233.3,271.3,233.3,271.3,233.3z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M270.7,243.8c-1-1.9-1.9-3.8-2.9-5.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.1-0.2,0.1-0.4,0.2-0.6 c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.2-0.2,0.3-0.3l-1-0.8c-0.2,0.2-0.4,0.4-0.6,0.6c-0.1,0.1-0.3,0.4-0.2,0.6c1,2,2,4,3,6 C269.7,244.8,271.1,244.5,270.7,243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M268.6,237.3l-1-0.8c-0.2,0.2-0.3,0.3-0.5,0.5l1,0.8C268.3,237.6,268.4,237.5,268.6,237.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M267.6,238.4c0.1-0.1,0.2-0.2,0.3-0.3c0-0.1-0.1-0.2-0.1-0.2C267.7,238,267.6,238.2,267.6,238.4z"
  }))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M274.8,261.1c-0.4-0.2-1.1-0.2-1.6,0.1l-0.6,0.3c-0.5,0.2-0.5,0.6-0.1,0.7c0.4,0.2,1.1,0.2,1.6-0.1l0.6-0.3 C275.2,261.6,275.2,261.3,274.8,261.1z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M272.3,259.3c-0.4-0.2-1.1-0.2-1.6,0.1l-0.6,0.3c-0.5,0.2-0.5,0.6-0.1,0.7c0.4,0.2,1.1,0.2,1.6-0.1l0.6-0.3 C272.6,259.8,272.7,259.5,272.3,259.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.3625,
    y1: 349.6007,
    x2: 271.1646,
    y2: 334.8045,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M274.3,245.8c0.1-1.2-2.2-1.2-2.3,0c0,0.5,0,0.9-0.1,1.4l-1.1-0.5c0-0.7-0.1-1.4-0.1-2 c-0.1-1.2-2.3-1.2-2.3,0c0.3,4.9,0.5,9.8,0.6,14.7c0,1.2,2.3,1.2,2.3,0c-0.1-3.7-0.2-7.5-0.4-11.2l0.9,0.4 c-0.2,4.2-0.2,8.4-0.1,12.6c0,1.2,2.3,1.2,2.3,0C273.9,256,274,250.9,274.3,245.8z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M274.5,239.2c0.1,0.2,0.2,0.4,0.3,0.6l1.3-0.5c-0.1-0.2-0.2-0.4-0.3-0.5L274.5,239.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.8627,
    y1: 346.1156,
    x2: 271.704,
    y2: 357.0522,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M274.5,239.2l1.3-0.4c0-0.1-0.1-0.1-0.1-0.1c-0.5-0.8-0.9-1.7-1.4-2.5l-0.1-0.1c-0.3-0.5-0.9-1-1.6-1.3 c0.1-0.2,0-0.4-0.3-0.5l-1-0.3c-0.2-0.1-0.5,0.1-0.6,0.2c-0.1,0.1-0.3,0-0.4,0c-0.5,0-0.9,0.3-1.2,0.7c-0.5,0.5-1,1-1.6,1.6 l0.8,0.7v8c0.2,0.9,0.9,1.3,3.5,2.5c0.4,0.2,0.9,0.3,1.4,0.3s0.7-0.2,0.9-0.6c0.2-0.3,0.1-1.5,0-1.9c-0.1-3.3,0-5.3,0-6.5 C274.4,239.1,274.5,239.1,274.5,239.2z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M274.3,247.9H274c0,0-0.1,0-0.1-0.1v-0.6c0,0,0-0.1,0.1-0.1h0.2c0,0,0.1,0,0.1,0.1L274.3,247.9L274.3,247.9 z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M273.2,246l1-0.5c0.3-0.1,0.4-0.5,0.4-0.8s-0.3-0.5-0.5-0.4l-1,0.5c-0.3,0.1-0.4,0.5-0.4,0.8 C272.8,246,273,246.1,273.2,246z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M276.1,239.2l-1.3,0.5c0.2,0.3,0.3,0.6,0.5,0.8c-0.8,1.4-1.5,2.8-2.3,4.3c-0.4,0.7,0.5,1.1,0.8,0.4 c0.4-0.8,1-1.4,1.4-2.2C276.3,240.9,277.2,241,276.1,239.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M111.3,379.4l-21.9-12.7c-1.2-0.7-1.2-2.5,0-3.2l22.1-12.8c1.8-1.1,4.1-1.1,5.9,0l22.3,12.9 c1.2,0.7,1.2,2.4,0,3.1l-21.9,12.7C115.8,380.6,113.3,380.6,111.3,379.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.352,
    y1: 236.1125,
    x2: 83.2719,
    y2: 236.1125,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M89.4,365.2l22.1-12.7c1.8-1.1,4.1-1.1,5.9,0l22.4,12.9c0.3,0.2,0.5,0.4,0.7,0.6c0.5-0.8,0.3-1.9-0.7-2.5 l-22.4-12.9c-1.8-1.1-4.1-1.1-5.9,0l-22.1,12.7c-0.9,0.5-1.2,1.7-0.7,2.5C88.8,365.6,89.1,365.3,89.4,365.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.6528,
    y1: 258.5,
    x2: 127.3285,
    y2: 258.5,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1401,
    style: {
      stopColor: "#7A8DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    style: {
      stopColor: "#889BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5694,
    style: {
      stopColor: "#90A3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M127.3,333.7l-0.1-0.1c-3.2-1.9-7.4-2.8-11.6-2.9l0.1,9.6L127.3,333.7z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M123,355c0.1,0,0.2-0.1,0.3-0.1C123.2,354.9,123.1,355,123,355z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M122.3,355.2c0.1,0,0.2-0.1,0.3-0.1C122.5,355.1,122.4,355.2,122.3,355.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.7477,
    y1: 251.4,
    x2: 127.3292,
    y2: 251.4,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1401,
    style: {
      stopColor: "#7A8DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    style: {
      stopColor: "#889BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5694,
    style: {
      stopColor: "#90A3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st200",
    d: "M127.3,333.7l-11.6,6.7l0.1,5.5l11.5,5.6V333.7L127.3,333.7z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M126.5,353.6c0.2-0.1,0.4-0.2,0.6-0.3C126.9,353.4,126.7,353.5,126.5,353.6z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M123.7,354.8c0.1,0,0.2-0.1,0.3-0.1C124,354.7,123.9,354.7,123.7,354.8z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M125.8,353.9c0.1-0.1,0.3-0.1,0.4-0.2C126.1,353.8,126,353.8,125.8,353.9z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M124.5,354.5c0.1,0,0.2-0.1,0.3-0.1C124.7,354.4,124.6,354.5,124.5,354.5z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M125.2,354.2c0.1-0.1,0.2-0.1,0.4-0.2C125.4,354.1,125.3,354.2,125.2,354.2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M120,355.7c0.1,0,0.1,0,0.2,0C120.1,355.7,120,355.7,120,355.7z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M121.5,355.4c0.1,0,0.2,0,0.3-0.1C121.7,355.4,121.6,355.4,121.5,355.4z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M120.7,355.6c0.1,0,0.1,0,0.2,0C120.9,355.5,120.8,355.5,120.7,355.6z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M118.4,355.9L118.4,355.9C118.4,355.9,118.4,355.9,118.4,355.9z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M117.6,356L117.6,356C117.6,356,117.6,356,117.6,356z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M119.2,355.8c0.1,0,0.1,0,0.2,0C119.3,355.8,119.2,355.8,119.2,355.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.7,
    y1: 223.5239,
    x2: 100.7,
    y2: 256.1727,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M103,370.3v-17h0.1l0.1-0.1v-8.9v-8.8c-1.9-1.1-3.3-2.4-4.1-3.8c-0.1-0.2-0.2-0.3-0.3-0.5 c-0.2-0.3-0.3-0.6-0.4-0.9v-0.1c0-0.1-0.1-0.2-0.1-0.4v-0.1c0-0.1,0-0.2-0.1-0.3v-0.1c0-0.1,0-0.3,0-0.4c0-0.2,0-0.3,0-0.5v15.8 v11.5v8.1c0.2,2.4,1.9,4.8,5,6.6C103.1,370.3,103,370.3,103,370.3L103,370.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.9441,
    y1: 253.3,
    x2: 103.2218,
    y2: 253.3,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.590021e-7,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M103.2,335.5v8.7v8.9l12.6-7.3l-0.1-5.5l-0.1-9.6v-2.4h-0.1L103.2,335.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.1408,
    y1: 265.9,
    x2: 115.5515,
    y2: 265.9,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92A5FF"
    }
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M98.2,329.2v0.1c0,0.1,0,0.2,0.1,0.3v0.1c0,0.1,0.1,0.2,0.1,0.4v0.1c0.1,0.3,0.2,0.6,0.4,0.9 c0.1,0.2,0.2,0.3,0.3,0.5c0.8,1.4,2.2,2.7,4.1,3.8l12.4-7.1l-11.3-7.5c-0.4,0.2-0.8,0.4-1.2,0.6c-3.3,1.9-4.9,4.4-5,6.8 c0,0.2,0,0.3,0,0.5C98.2,329,98.2,329.1,98.2,329.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.85,
    y1: 219.8452,
    x2: 115.85,
    y2: 236.924,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M128.5,352.3c-0.2,0.1-0.3,0.3-0.5,0.4c-0.3,0.2-0.6,0.4-0.8,0.5c-0.2,0.1-0.4,0.2-0.6,0.3 c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1s-0.2,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.1s-0.2,0.1-0.3,0.1 c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3,0.1c-0.2,0-0.4,0.1-0.6,0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.5,0.1-0.7,0.1h-0.1c-0.2,0-0.5,0-0.7,0.1h-0.1c-0.3,0-0.5,0-0.8,0.1c-0.3,0-0.6,0-0.8,0c-0.3,0-0.6,0-0.8,0 c-4.4,0-8.7-1-12.1-2.9H103v17c0.1,0,0.1,0.1,0.2,0.1c2.5,1.4,5.5,2.3,8.6,2.6c5.4,0.6,11.2-0.3,15.3-2.7c0.6-0.3,1.1-0.7,1.6-1.1 v-17.1C128.7,352.2,128.6,352.3,128.5,352.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 103,
    y1: 242.95,
    x2: 128.7265,
    y2: 242.95,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M115.8,345.9l-12.6,7.3l-0.2,0.1c3.4,1.9,7.8,2.9,12.1,2.9c0.3,0,0.6,0,0.8,0c0.3,0,0.6,0,0.8,0 c0.3,0,0.6,0,0.8-0.1h0.1c0.2,0,0.5,0,0.7-0.1h0.1c0.2,0,0.5-0.1,0.7-0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.1 c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.2,0,0.3-0.1c0.2,0,0.3-0.1,0.5-0.1 c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3-0.1,0.4-0.1s0.2-0.1,0.3-0.1 c0.1,0,0.3-0.1,0.4-0.1s0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.4-0.1c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.1,0.4-0.3,0.5-0.4 s0.2-0.1,0.2-0.2l-1.4-0.7L115.8,345.9L115.8,345.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 77,
    y1: 340.9401,
    x2: 77,
    y2: 344.5229,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M82.7,247.4c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C82.7,249.5,82.7,248.4,82.7,247.4L82.7,247.4z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M70.8,247.4v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C70.8,247.3,70.8,247.3,70.8,247.4z"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M78.3,248.3c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C78.1,248.7,78.2,248.5,78.3,248.3z M77.8,246.1l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L77.8,246.1z M75.4,248l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C76.2,248.2,75.8,248.2,75.4,248z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.1,
    y1: 343.9423,
    x2: 77.1,
    y2: 347.5253,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M82.8,244.4c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C82.8,246.5,82.8,245.4,82.8,244.4L82.8,244.4z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M70.9,244.4v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C70.9,244.3,70.9,244.3,70.9,244.4z"
  }))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M78.3,245.3c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C78.1,245.7,78.3,245.5,78.3,245.3z M77.9,243.1l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L77.9,243.1z M75.5,245l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C76.2,245.2,75.9,245.2,75.5,245z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.1,
    y1: 347.1011,
    x2: 77.1,
    y2: 350.6841,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M82.8,241.3c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C82.9,243.3,82.9,242.3,82.8,241.3L82.8,241.3z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M70.9,241.2v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C70.9,241.1,70.9,241.2,70.9,241.2z"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M78.4,242.2c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C78.2,242.6,78.4,242.4,78.4,242.2z M77.9,239.9l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L77.9,239.9z M75.5,241.8l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C76.3,242.1,75.9,242,75.5,241.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.2,
    y1: 350.2602,
    x2: 77.2,
    y2: 353.843,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M82.9,238.1c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C82.9,240.2,82.9,239.1,82.9,238.1L82.9,238.1z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M71,238.1v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C71,238,71,238,71,238.1z"
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M78.5,239c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C78.3,239.4,78.5,239.2,78.5,239z M78,236.7l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2l-0.4-0.2 L78,236.7z M75.6,238.6l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3C76.4,238.9,76,238.9,75.6,238.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_183_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.8,
    y1: 349.131,
    x2: 108.8,
    y2: 352.714,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M114.5,239.2c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C114.5,241.3,114.5,240.2,114.5,239.2L114.5,239.2z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M102.6,239.2v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C102.6,239.1,102.6,239.2,102.6,239.2z"
  }))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M110.1,240.2c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3L110,237l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C109.9,240.5,110.1,240.3,110.1,240.2z M109.6,237.9l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L109.6,237.9z M107.2,239.8l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C108,240,107.6,240,107.2,239.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_184_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.9,
    y1: 352.1333,
    x2: 108.9,
    y2: 355.7162,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M114.6,236.2c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C114.6,238.3,114.6,237.2,114.6,236.2L114.6,236.2z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M102.7,236.2v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C102.7,236.1,102.7,236.1,102.7,236.2z"
  }))), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M110.2,237.2c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C109.9,237.5,110.1,237.3,110.2,237.2z M109.7,234.9l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L109.7,234.9z M107.3,236.8l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C108.1,237,107.7,237,107.3,236.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 109,
    y1: 355.2923,
    x2: 109,
    y2: 358.8753,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M114.7,233.1c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C114.7,235.1,114.7,234.1,114.7,233.1L114.7,233.1z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M102.8,233v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C102.8,232.9,102.8,233,102.8,233z"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M110.2,234c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C110,234.4,110.2,234.2,110.2,234z M109.8,231.7l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L109.8,231.7z M107.4,233.6l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C108.1,233.9,107.8,233.9,107.4,233.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 109,
    y1: 358.4511,
    x2: 109,
    y2: 362.0341,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M114.7,229.9c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C114.8,232,114.8,230.9,114.7,229.9L114.7,229.9z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M102.9,229.9v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C102.8,229.8,102.8,229.8,102.9,229.9z"
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M110.3,230.8c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4L112,228l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C110.1,231.2,110.3,231,110.3,230.8z M109.8,228.6l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L109.8,228.6z M107.4,230.5l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C108.2,230.7,107.9,230.7,107.4,230.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.1,
    y1: 352.0564,
    x2: 96.1,
    y2: 355.6395,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M101.8,236.3c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C101.8,238.4,101.8,237.3,101.8,236.3L101.8,236.3z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M89.9,236.3v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C89.9,236.2,89.9,236.2,89.9,236.3z"
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M97.4,237.2c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C97.2,237.6,97.3,237.4,97.4,237.2z M96.9,235l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L96.9,235z M94.5,236.9l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C95.3,237.1,94.9,237.1,94.5,236.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_188_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.2,
    y1: 355.0587,
    x2: 96.2,
    y2: 358.6416,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M101.9,233.3c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C101.9,235.4,101.9,234.3,101.9,233.3L101.9,233.3z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M90,233.3v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C90,233.2,90,233.2,90,233.3z"
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M97.4,234.2c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C97.2,234.6,97.4,234.4,97.4,234.2z M97,232l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2l-0.4-0.2 L97,232z M94.6,233.8l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3C95.3,234.1,95,234.1,94.6,233.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.2,
    y1: 358.2178,
    x2: 96.2,
    y2: 361.8006,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M101.9,230.2c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C101.9,232.2,102,231.1,101.9,230.2L101.9,230.2z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M90,230.1v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C90,230,90,230.1,90,230.1z"
  }))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M97.5,231.1c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4L92,231l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C97.3,231.4,97.5,231.3,97.5,231.1z M97,228.8l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L97,228.8z M94.6,230.7l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C95.4,230.9,95,230.9,94.6,230.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_190_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.3,
    y1: 361.3765,
    x2: 96.3,
    y2: 364.9595,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M102,227c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C102,229,102,228,102,227L102,227z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M90.1,227v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C90.1,226.9,90.1,226.9,90.1,227z"
  }))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M97.6,227.9c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1L98,225l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4l-4.9,2.8 l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C97.4,228.3,97.6,228.1,97.6,227.9z M97.1,225.6l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L97.1,225.6z M94.7,227.5l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C95.5,227.8,95.1,227.8,94.7,227.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_191_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.4,
    y1: 364.7179,
    x2: 96.4,
    y2: 368.3007,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M102.1,223.7c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C102.1,225.7,102.1,224.6,102.1,223.7L102.1,223.7z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M90.2,223.6v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C90.2,223.5,90.2,223.6,90.2,223.6z"
  }))), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M97.7,224.6c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C97.4,224.9,97.6,224.8,97.7,224.6z M97.2,222.3l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L97.2,222.3z M94.8,224.2l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C95.6,224.4,95.2,224.4,94.8,224.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.8,
    y1: 346.1577,
    x2: 88.8,
    y2: 349.7406,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M94.5,242.2c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C94.5,244.3,94.5,243.2,94.5,242.2L94.5,242.2z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M82.6,242.2v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C82.6,242.1,82.6,242.1,82.6,242.2z"
  }))), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M90.1,243.1c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C89.9,243.5,90,243.3,90.1,243.1z M89.6,240.9l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L89.6,240.9z M87.2,242.7l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C88,243,87.6,243,87.2,242.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_193_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.4,
    y1: 336.8897,
    x2: 87.4,
    y2: 340.4727,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M93.1,251.5c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C93.1,253.5,93.1,252.5,93.1,251.5L93.1,251.5z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M81.2,251.4v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C81.2,251.3,81.2,251.4,81.2,251.4z"
  }))), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M88.7,252.4c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C88.4,252.8,88.6,252.6,88.7,252.4z M88.2,250.1l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L88.2,250.1z M85.8,252l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C86.6,252.3,86.2,252.3,85.8,252z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_194_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.5,
    y1: 340.0486,
    x2: 87.5,
    y2: 343.6314,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M93.2,248.3c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C93.2,250.4,93.2,249.3,93.2,248.3L93.2,248.3z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M81.3,248.3v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C81.3,248.2,81.3,248.2,81.3,248.3z"
  }))), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M88.8,249.2c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C88.6,249.6,88.8,249.4,88.8,249.2z M88.3,247l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L88.3,247z M85.9,248.9l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C86.7,249.1,86.3,249.1,85.9,248.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.1,
    y1: 341.8783,
    x2: 101.1,
    y2: 345.4612,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M106.8,246.5c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C106.8,248.5,106.8,247.5,106.8,246.5L106.8,246.5z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M94.9,246.5v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C94.9,246.3,94.9,246.4,94.9,246.5z"
  }))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M102.4,247.4c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C102.2,247.8,102.4,247.6,102.4,247.4z M101.9,245.1l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L101.9,245.1z M99.5,247l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C100.3,247.3,99.9,247.3,99.5,247z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_196_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.1,
    y1: 345.555,
    x2: 101.1,
    y2: 349.1379,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M106.8,242.8c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C106.8,244.9,106.8,243.8,106.8,242.8L106.8,242.8z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M94.9,242.8v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C94.9,242.7,94.9,242.7,94.9,242.8z"
  }))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M102.4,243.7c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C102.2,244.1,102.4,243.9,102.4,243.7z M101.9,241.5l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 L101,242L101.9,241.5z M99.5,243.4l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C100.3,243.6,99.9,243.6,99.5,243.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_197_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.6,
    y1: 341.8426,
    x2: 113.6,
    y2: 345.4256,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M119.3,246.5c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C119.3,248.6,119.3,247.5,119.3,246.5L119.3,246.5z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M107.4,246.5v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C107.4,246.4,107.4,246.4,107.4,246.5z"
  }))), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M114.9,247.4c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C114.7,247.8,114.8,247.6,114.9,247.4z M114.4,245.2l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L114.4,245.2z M112,247.1l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C112.8,247.3,112.4,247.3,112,247.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_198_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.6,
    y1: 345.5192,
    x2: 113.6,
    y2: 349.1022,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M119.3,242.9c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C119.3,244.9,119.3,243.8,119.3,242.9L119.3,242.9z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M107.4,242.8v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C107.4,242.7,107.4,242.8,107.4,242.8z"
  }))), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M114.9,243.8c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C114.7,244.1,114.8,244,114.9,243.8z M114.4,241.5l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L114.4,241.5z M112,243.4l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C112.8,243.6,112.4,243.6,112,243.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_199_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.9,
    y1: 348.7861,
    x2: 113.9,
    y2: 352.3692,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M119.6,239.6c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C119.6,241.6,119.6,240.6,119.6,239.6L119.6,239.6z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M107.7,239.6v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C107.7,239.4,107.7,239.5,107.7,239.6z"
  }))), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M115.1,240.5c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C114.9,240.9,115.1,240.7,115.1,240.5z M114.6,238.2l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L114.6,238.2z M112.3,240.1l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C113,240.4,112.7,240.4,112.3,240.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_200_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.4,
    y1: 340.432,
    x2: 126.4,
    y2: 344.015,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M132.1,247.9c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C132.1,250,132.2,248.9,132.1,247.9L132.1,247.9z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M120.2,247.9v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C120.2,247.8,120.2,247.9,120.2,247.9z"
  }))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M127.7,248.9c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 L122,248l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C127.5,249.2,127.7,249,127.7,248.9z M127.2,246.6l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.5-0.2 l-0.4-0.2L127.2,246.6z M124.8,248.5l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C125.6,248.7,125.2,248.7,124.8,248.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_202_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.7,
    y1: 343.7389,
    x2: 126.7,
    y2: 347.3217,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M132.4,244.6c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C132.4,246.7,132.4,245.6,132.4,244.6L132.4,244.6z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M120.5,244.6v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C120.5,244.5,120.5,244.5,120.5,244.6z"
  }))), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M128,245.6c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3L129,243c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C127.8,245.9,127.9,245.7,128,245.6z M127.5,243.3l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.5-0.2 l-0.4-0.2L127.5,243.3z M125.1,245.2l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C125.9,245.4,125.5,245.4,125.1,245.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_203_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.3,
    y1: 331.4943,
    x2: 97.3,
    y2: 335.0772,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st230",
    d: "M103,256.9c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2s0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C103,258.9,103,257.9,103,256.9L103,256.9z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M91.1,256.8v0.1c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2s0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C91.1,256.7,91.1,256.8,91.1,256.8z"
  }))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M98.6,257.8c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C98.3,258.2,98.5,258,98.6,257.8z M98.1,255.5l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L98.1,255.5z M95.7,257.4l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C96.5,257.7,96.1,257.7,95.7,257.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_204_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.3,
    y1: 334.6532,
    x2: 97.3,
    y2: 338.2361,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st231",
    d: "M103,253.7c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C103,255.8,103,254.7,103,253.7L103,253.7z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M91.1,253.7v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C91.1,253.6,91.1,253.6,91.1,253.7z"
  }))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M98.6,254.6c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C98.3,255,98.5,254.8,98.6,254.6z M98.1,252.4l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L98.1,252.4z M95.7,254.3l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C96.5,254.5,96.1,254.5,95.7,254.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_205_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.3,
    y1: 337.9354,
    x2: 97.3,
    y2: 341.5184,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M103,250.4c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C103,252.5,103,251.4,103,250.4L103,250.4z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M91.1,250.4v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C91.1,250.3,91.1,250.3,91.1,250.4z"
  }))), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M98.6,251.4c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C98.3,251.7,98.5,251.5,98.6,251.4z M98.1,249.1l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2 l-0.4-0.2L98.1,249.1z M95.7,251l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C96.5,251.2,96.1,251.2,95.7,251z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_206_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.1,
    y1: 334.7353,
    x2: 110.1,
    y2: 338.318,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st233",
    d: "M115.8,253.6c-0.1,0.8-0.6,1.7-1.7,2.3c-2.3,1.3-6.1,1.3-8.4,0c-0.7-0.4-1.2-0.9-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,1,0,2.2,0,2.2 c0.1,0.8,0.6,1.7,1.8,2.3c0.9,0.5,2,0.8,3.1,0.9c1.9,0.2,3.9-0.1,5.4-0.9c1.1-0.6,1.7-1.5,1.7-2.3c0-0.1,0-0.1,0-0.2 C115.8,255.7,115.8,254.6,115.8,253.6L115.8,253.6z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M103.9,253.6v0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2 c0.3,0.5,0.8,0.9,1.4,1.3c2.4,1.4,6.1,1.4,8.4,0c1.1-0.6,1.7-1.5,1.7-2.3c0-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.3-0.2-0.4 c-0.3-0.5-0.7-0.9-1.4-1.3c-1-0.6-2.3-0.9-3.6-1c-0.4,0-0.8,0-1.3,0c-1.3,0.1-2.6,0.4-3.6,1c-0.1,0-0.2,0.1-0.2,0.1 c-0.7,0.5-1.1,1-1.3,1.5c-0.1,0.2-0.1,0.5-0.2,0.7C103.9,253.5,103.9,253.5,103.9,253.6z"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M111.4,254.6c0.1-0.2,0-0.4-0.3-0.6c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6-0.1,0.9-0.3c0.4-0.2,0.6-0.5,0.4-0.8 c-0.1-0.2-0.2-0.4-0.5-0.6l0.6-0.4l-0.5-0.3l-0.6,0.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-0.3l0.6-0.3l-0.5-0.3l-0.6,0.3l-0.7-0.4 l-4.9,2.8l0.7,0.4l-0.6,0.3l0.5,0.3l0.6-0.3l0.6,0.4l-0.6,0.3l0.5,0.3l0.6-0.4c0.4,0.2,0.8,0.3,1.2,0.3c0.6,0,1.1-0.1,1.5-0.3 C111.2,254.9,111.4,254.7,111.4,254.6z M110.9,252.3l0.4,0.2c0.4,0.2,0.5,0.4,0.2,0.6c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.5-0.2 l-0.4-0.2L110.9,252.3z M108.5,254.2l-0.5-0.3l1-0.6l0.4,0.3c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,0.2-0.2,0.3 C109.3,254.4,108.9,254.4,108.5,254.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.4,487.6l-15.1-8.8c-1.5-0.9-3.3-0.9-4.8,0L521.2,490l17,10.1h7.3l15-9.2 C561.7,490.1,561.7,488.3,560.4,487.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_207_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.4069,
    y1: 104.05,
    x2: 557.2903,
    y2: 104.05,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M556.2,479.7v9.4c0,0.5-0.2,0.9-0.7,1.2l-16,9.3c-1.5,0.8-3.3,0.8-4.7,0l-16-9.3c-0.5-0.3-0.7-0.7-0.7-1.2 H518v-9.4H556.2z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M539.5,490l16-9.3c0.9-0.5,0.9-1.8,0-2.4l-16.1-9.3c-1.3-0.8-3-0.8-4.3,0l-16.3,9.5c-0.9,0.5-0.9,1.8,0,2.3 l16,9.3C536.2,490.9,538,490.9,539.5,490z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M536.3,486.7l-12.1-7c-0.7-0.4-0.7-1.4,0-1.8l12.2-7.1c1-0.6,2.3-0.6,3.3,0L552,478 c0.7,0.4,0.7,1.3,0,1.7l-12.1,7C538.8,487.3,537.4,487.3,536.3,486.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_208_",
    gradientUnits: "userSpaceOnUse",
    x1: 550.7435,
    y1: 119.275,
    x2: 520.7994,
    y2: 119.275,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M524.2,478.8l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.1c0.2,0.1,0.3,0.2,0.4,0.4c0.3-0.5,0.1-1.1-0.4-1.4 l-12.4-7.1c-1-0.6-2.3-0.6-3.3,0l-12.2,7.1c-0.5,0.3-0.6,0.9-0.4,1.4C523.9,479,524,478.9,524.2,478.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_209_",
    points: "1,1 2,1 1,2  "
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_210_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_211_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_212_",
    className: "st236"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_210_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_213_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7,
    y1: 133.8318,
    x2: 537.7,
    y2: 104.9625,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st237",
    d: "M525.6,461.9V478l0,0c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9 c0.3-0.2,0.4-0.5,0.4-0.8v-1.9l0,0v-14.4L525.6,461.9z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_214_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7,
    y1: 133.8318,
    x2: 537.7,
    y2: 104.9625,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3.409785e-7,
    style: {
      stopColor: "#92A5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3645,
    style: {
      stopColor: "#8FA2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    style: {
      stopColor: "#8699FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8767,
    style: {
      stopColor: "#7688FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7DFF"
    }
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st238",
    d: "M525.6,461.9V478c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9c0.3-0.2,0.4-0.5,0.4-0.8 v-1.9v-14.4L525.6,461.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_215_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.85,
    y1: 126.653,
    x2: 537.85,
    y2: 133.838,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st239",
    d: "M549.7,456.1c-0.1,1.7-1.2,3.3-3.4,4.6c-4.6,2.7-12.2,2.7-16.9,0c-1.4-0.8-2.3-1.7-2.9-2.7 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.2-0.1-0.2-0.1-0.3v-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3 c0,2.1,0,4.5,0,4.5c0.1,1.7,1.3,3.3,3.5,4.6c1.8,1,3.9,1.6,6.2,1.9c3.8,0.4,7.8-0.2,10.7-1.9c2.2-1.3,3.4-3,3.5-4.7 c0-0.1,0-0.3,0-0.4C549.8,460.2,549.8,458,549.7,456.1L549.7,456.1z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M525.9,456c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3v0.1c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.3,0.7 c0.1,0.1,0.1,0.2,0.2,0.3c0.6,1,1.5,1.9,2.9,2.7c4.7,2.7,12.3,2.7,16.9,0c2.2-1.3,3.4-3,3.5-4.7c0-0.6-0.1-1.1-0.3-1.7 c-0.1-0.3-0.2-0.5-0.3-0.8c-0.6-1-1.5-1.9-2.8-2.6c0,0-0.1,0-0.1-0.1c-2-1.1-4.5-1.8-7.1-2c-0.8-0.1-1.7-0.1-2.5,0 c-2.7,0.1-5.3,0.8-7.3,2c-0.2,0.1-0.3,0.2-0.5,0.3c-1.4,0.9-2.3,2-2.7,3.1c-0.2,0.5-0.3,0.9-0.3,1.4 C525.9,455.8,525.9,455.9,525.9,456z"
  }))), /*#__PURE__*/React.createElement("g", null, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.5L536.4,462.5L536.4,462.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "536.4,462.4 536.5,462.5 536.4,462.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M536.4,462.4l0.1,0.1L536.4,462.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_201_",
    className: "st207",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8  535.9,453.8 533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_216_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_217_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_216_",
    style: {
      overflow: "visible"
    }
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "529.1,456 537.7,461 537.5,461.1 528.9,456.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_218_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_219_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_218_",
    style: {
      overflow: "visible"
    }
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st241",
    points: "529.4,455.9 537.9,460.8 537.7,461 529.1,456  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_220_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_221_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_220_",
    style: {
      overflow: "visible"
    }
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st242",
    points: "529.6,455.7 538.2,460.7 537.9,460.8 529.4,455.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_222_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_222_",
    style: {
      overflow: "visible"
    }
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st243",
    points: "529.9,455.6 538.4,460.5 538.2,460.7 529.6,455.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_224_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_225_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_224_",
    style: {
      overflow: "visible"
    }
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "530.1,455.5 538.6,460.4 538.4,460.5 529.9,455.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_226_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_227_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_226_",
    style: {
      overflow: "visible"
    }
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st245",
    points: "530.4,455.3 538.9,460.3 538.6,460.4 530.1,455.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_228_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_229_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_228_",
    style: {
      overflow: "visible"
    }
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st246",
    points: "530.6,455.2 539.1,460.1 538.9,460.3 530.4,455.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_230_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_231_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_230_",
    style: {
      overflow: "visible"
    }
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st247",
    points: "530.8,455 539.4,460 539.1,460.1 530.6,455.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_232_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_232_",
    style: {
      overflow: "visible"
    }
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st248",
    points: "531.1,454.9 539.6,459.8 539.4,460 530.8,455  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_234_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_235_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_234_",
    style: {
      overflow: "visible"
    }
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st249",
    points: "531.3,454.7 539.9,459.7 539.6,459.8 531.1,454.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_236_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_237_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_236_",
    style: {
      overflow: "visible"
    }
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st250",
    points: "531.6,454.6 540.1,459.5 539.9,459.7 531.3,454.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_238_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_239_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_238_",
    style: {
      overflow: "visible"
    }
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st251",
    points: "531.8,454.5 540.4,459.4 540.1,459.5 531.6,454.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_240_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_240_",
    style: {
      overflow: "visible"
    }
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "532.1,454.3 540.6,459.3 540.4,459.4 531.8,454.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_242_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_243_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_242_",
    style: {
      overflow: "visible"
    }
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st253",
    points: "532.3,454.2 540.9,459.1 540.6,459.3 532.1,454.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_244_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_245_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_244_",
    style: {
      overflow: "visible"
    }
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "532.6,454 541.1,459 540.9,459.1 532.3,454.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_246_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_247_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_246_",
    style: {
      overflow: "visible"
    }
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st255",
    points: "532.8,453.9 541.3,458.8 541.1,459 532.6,454  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_248_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_249_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_248_",
    style: {
      overflow: "visible"
    }
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "533.1,453.8 541.6,458.7 541.3,458.8 532.8,453.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_250_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_251_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_250_",
    style: {
      overflow: "visible"
    }
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st257",
    points: "533.3,453.6 541.8,458.6 541.6,458.7 533.1,453.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_252_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_253_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_252_",
    style: {
      overflow: "visible"
    }
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st258",
    points: "533.5,453.5 542.1,458.4 541.8,458.6 533.3,453.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_254_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_255_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_254_",
    style: {
      overflow: "visible"
    }
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st259",
    points: "533.8,453.3 542.3,458.3 542.1,458.4 533.5,453.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_256_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_257_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_256_",
    style: {
      overflow: "visible"
    }
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st260",
    points: "534,453.2 542.6,458.1 542.3,458.3 533.8,453.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_258_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_259_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_258_",
    style: {
      overflow: "visible"
    }
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st261",
    points: "534.3,453 542.8,458 542.6,458.1 534,453.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_260_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_260_",
    style: {
      overflow: "visible"
    }
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st262",
    points: "534.5,452.9 543.1,457.8 542.8,458 534.3,453  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_262_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_263_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_262_",
    style: {
      overflow: "visible"
    }
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st263",
    points: "534.8,452.8 543.3,457.7 543.1,457.8 534.5,452.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_264_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_265_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_264_",
    style: {
      overflow: "visible"
    }
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "535,452.6 543.6,457.6 543.3,457.7 534.8,452.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_266_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_267_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_266_",
    style: {
      overflow: "visible"
    }
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st265",
    points: "535.3,452.5 543.8,457.4 543.6,457.6 535,452.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_268_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_269_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_268_",
    style: {
      overflow: "visible"
    }
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st266",
    points: "535.5,452.3 544,457.3 543.8,457.4 535.3,452.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_270_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_270_",
    style: {
      overflow: "visible"
    }
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st267",
    points: "535.8,452.2 544.3,457.1 544,457.3 535.5,452.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_272_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_273_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_272_",
    style: {
      overflow: "visible"
    }
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st268",
    points: "536,452 544.5,457 544.3,457.1 535.8,452.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_274_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_275_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_274_",
    style: {
      overflow: "visible"
    }
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st269",
    points: "536.2,451.9 544.8,456.8 544.5,457 536,452  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_276_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_277_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_276_",
    style: {
      overflow: "visible"
    }
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st270",
    points: "536.5,451.8 545,456.7 544.8,456.8 536.2,451.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_278_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_278_",
    style: {
      overflow: "visible"
    }
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st271",
    points: "536.7,451.6 545.3,456.6 545,456.7 536.5,451.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_280_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_281_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_280_",
    style: {
      overflow: "visible"
    }
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st272",
    points: "537,451.5 545.5,456.4 545.3,456.6 536.7,451.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_282_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_283_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_282_",
    style: {
      overflow: "visible"
    }
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st273",
    points: "537.2,451.3 545.8,456.3 545.5,456.4 537,451.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_284_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_285_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_284_",
    style: {
      overflow: "visible"
    }
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st274",
    points: "537.5,451.2 546,456.1 545.8,456.3 537.2,451.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_286_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_287_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_286_",
    style: {
      overflow: "visible"
    }
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st275",
    points: "537.7,451.1 546.3,456 546,456.1 537.5,451.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_288_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_288_",
    style: {
      overflow: "visible"
    }
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st276",
    points: "538,450.9 546.5,455.9 546.3,456 537.7,451.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_290_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_291_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_290_",
    style: {
      overflow: "visible"
    }
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st277",
    points: "538.2,450.8 546.7,455.7 546.5,455.9 538,450.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_292_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_293_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_292_",
    style: {
      overflow: "visible"
    }
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st278",
    points: "538.5,450.6 547,455.6 546.7,455.7 538.2,450.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_294_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_294_",
    style: {
      overflow: "visible"
    }
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "538.7,450.5 547.2,455.4 547,455.6 538.5,450.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_296_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_297_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_296_",
    style: {
      overflow: "visible"
    }
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st280",
    points: "538.9,450.3 547.5,455.3 547.2,455.4 538.7,450.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_298_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_299_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_298_",
    style: {
      overflow: "visible"
    }
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st281",
    points: "539.2,450.2 547.7,455.1 547.5,455.3 538.9,450.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_300_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_301_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_300_",
    style: {
      overflow: "visible"
    }
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st282",
    points: "539.4,450.1 548,455 547.7,455.1 539.2,450.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_302_",
    points: "539.1,455.4 541.9,455.7 543.5,454.7 540.7,454.4 544,452.5 541.1,450.8 535.9,453.8  533.4,453.6 531.8,454.5 534.2,454.8 530.4,457 537.5,461.1 539.8,459.7 535.7,457.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_303_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_302_",
    style: {
      overflow: "visible"
    }
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st283",
    points: "548,455 539.4,450.1 539.6,449.9 548.2,454.9  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.4,186.2l-15.1-8.8c-1.5-0.9-3.3-0.9-4.8,0l-19.3,11.2l17,10.1h7.3l15-9.2 C306.7,188.7,306.6,186.9,305.4,186.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_304_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.3924,
    y1: 405.45,
    x2: 302.2755,
    y2: 405.45,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st284",
    d: "M301.2,178.3v9.4c0,0.5-0.2,0.9-0.7,1.2l-16,9.3c-1.5,0.8-3.3,0.8-4.7,0l-16-9.3c-0.5-0.3-0.7-0.7-0.7-1.2 H263v-9.4H301.2z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.5,188.6l16-9.3c0.9-0.5,0.9-1.8,0-2.4l-16.1-9.3c-1.3-0.8-3-0.8-4.3,0l-16.3,9.5 c-0.9,0.5-0.9,1.8,0,2.3l16,9.3C281.2,189.5,283,189.5,284.5,188.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M280.8,186.4l-12.1-7c-0.7-0.4-0.7-1.4,0-1.8l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.2 c0.7,0.4,0.7,1.3,0,1.7l-12.1,7C283.3,187.1,281.9,187.1,280.8,186.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_305_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.2271,
    y1: 419.475,
    x2: 265.283,
    y2: 419.475,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st285",
    d: "M268.7,178.6l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.1c0.2,0.1,0.3,0.2,0.4,0.4c0.3-0.5,0.1-1.1-0.4-1.4 l-12.4-7.1c-1-0.6-2.3-0.6-3.3,0l-12.2,7.1c-0.5,0.3-0.6,0.9-0.4,1.4C268.4,178.8,268.5,178.7,268.7,178.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_306_",
    points: "1,1 2,1 1,2  "
  }))), _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_307_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_308_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_306_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_309_",
    className: "st286"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_310_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.2,
    y1: 454.2129,
    x2: 282.2,
    y2: 402.0196,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st287",
    d: "M270.1,142.6v35.2l0,0c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9 c0.3-0.2,0.4-0.5,0.4-0.8v-1.9l0,0v-32.6L270.1,142.6z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_311_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.2,
    y1: 454.2129,
    x2: 282.2,
    y2: 402.0196,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3.409785e-7,
    style: {
      stopColor: "#92A5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3645,
    style: {
      stopColor: "#8FA2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    style: {
      stopColor: "#8699FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8767,
    style: {
      stopColor: "#7688FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7DFF"
    }
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st288",
    d: "M270.1,142.6v35.2c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9c0.3-0.2,0.4-0.5,0.4-0.8 v-1.9v-32.6L270.1,142.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_312_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.35,
    y1: 443.8356,
    x2: 282.35,
    y2: 451.0206,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st289",
    d: "M294.2,138.9c-0.1,1.7-1.2,3.3-3.4,4.6c-4.6,2.7-12.2,2.7-16.9,0c-1.4-0.8-2.3-1.7-2.9-2.7 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.2-0.1-0.2-0.1-0.3v-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3 c0,2.1,0,4.5,0,4.5c0.1,1.7,1.3,3.3,3.5,4.6c1.8,1,3.9,1.6,6.2,1.9c3.8,0.4,7.8-0.2,10.7-1.9c2.2-1.3,3.4-3,3.5-4.7 c0-0.1,0-0.3,0-0.4C294.2,143,294.3,140.8,294.2,138.9L294.2,138.9z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M270.4,138.8c0,0.1,0,0.2,0,0.3s0,0.2,0.1,0.3v0.1c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.3,0.7 c0.1,0.1,0.1,0.2,0.2,0.3c0.6,1,1.5,1.9,2.9,2.7c4.7,2.7,12.3,2.7,16.9,0c2.2-1.3,3.4-3,3.5-4.7c0-0.6-0.1-1.1-0.3-1.7 c-0.1-0.3-0.2-0.5-0.3-0.8c-0.6-1-1.5-1.9-2.8-2.6c0,0-0.1,0-0.1-0.1c-2-1.1-4.5-1.8-7.1-2c-0.8-0.1-1.7-0.1-2.5,0 c-2.7,0.1-5.3,0.8-7.3,2c-0.2,0.1-0.3,0.2-0.5,0.3c-1.4,0.9-2.3,2-2.7,3.1c-0.2,0.5-0.3,0.9-0.3,1.4 C270.4,138.6,270.4,138.7,270.4,138.8z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M277.2,140.9c-0.9-0.6-1.7-1.3-2.2-2l2.2-1.3c0.3,0.5,0.6,0.9,1,1.4s0.9,0.8,1.3,1.1 c0.4,0.2,0.7,0.4,1,0.4s0.5,0,0.7-0.1c0.1-0.1,0.2-0.2,0.2-0.3s-0.1-0.3-0.3-0.6c-0.2-0.2-0.4-0.6-0.7-1 c-0.4-0.5-0.6-0.9-0.7-1.2c-0.1-0.4-0.1-0.7,0.1-1s0.5-0.6,1-0.8c0.7-0.4,1.6-0.6,2.5-0.6s1.9,0.3,2.9,0.8l0.9-0.5l1.4,0.8 l-0.9,0.5c0.8,0.5,1.5,1.2,2,2L287,139c-0.5-0.8-1.2-1.4-1.9-1.8c-0.4-0.2-0.7-0.3-0.9-0.4c-0.2,0-0.4,0-0.6,0.1 c-0.1,0.1-0.2,0.2-0.2,0.3s0.1,0.3,0.2,0.5s0.4,0.5,0.7,0.9c0.6,0.7,0.9,1.3,0.9,1.8s-0.4,0.9-1,1.3c-0.8,0.4-1.6,0.7-2.6,0.6 c-1,0-1.9-0.2-3-0.7l-1.3,0.8l-1.4-0.8L277.2,140.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.5,544.9l-15.1-8.8c-1.5-0.9-3.3-0.9-4.8,0l-19.3,11.2l17,10.1h7.3l15-9.2 C412.7,547.3,412.7,545.6,411.5,544.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_313_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.4649,
    y1: 46.85,
    x2: 408.348,
    y2: 46.85,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st290",
    d: "M407.3,536.9v9.4c0,0.5-0.2,0.9-0.7,1.2l-16,9.3c-1.5,0.8-3.3,0.8-4.7,0l-16-9.3c-0.5-0.3-0.7-0.7-0.7-1.2 h-0.1v-9.4H407.3z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.5,547.3l16-9.3c0.9-0.5,0.9-1.8,0-2.4l-16.1-9.3c-1.3-0.8-3-0.8-4.3,0l-16.3,9.5c-0.9,0.5-0.9,1.8,0,2.3 l16,9.3C387.3,548.1,389.1,548.1,390.5,547.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M229,491.8c0.4-0.2,1-0.2,1.4,0.1l0.6,0.3c0.4,0.2,0.5,0.6,0.1,0.8c-0.4,0.2-1,0.2-1.4-0.1l-0.6-0.3 C228.7,492.4,228.6,492,229,491.8z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M213.4,483.7c0.3,0.3,0.4,0.9,0.3,1.4l-0.2,0.6c-0.1,0.5-0.5,0.6-0.8,0.3c-0.3-0.3-0.4-0.9-0.3-1.4l0.2-0.6 C212.7,483.6,213.1,483.4,213.4,483.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_314_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.0387,
    y1: 111.2066,
    x2: 228.7888,
    y2: 120.385,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M224.4,474.2c-1,2.3-2,4.6-3.1,6.9c0.2-0.2,0.4-0.3,0.6-0.5c-2.7,0.8-5.4,1.6-8.2,2.5 c-1.2,0.4-0.7,2.3,0.5,1.9c1.3-0.4,2.6-0.8,4-1.2c1.4-0.4,2.9-0.7,4.2-1.3c1.1-0.5,1.5-2.5,1.9-3.5c0.6-1.3,1.2-2.6,1.7-3.9 C226.6,474.1,224.9,473,224.4,474.2L224.4,474.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_315_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.0926,
    y1: 103.9134,
    x2: 221.9757,
    y2: 117.2529,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st292",
    d: "M221.1,477.3c4.1,3.5,6.6,9.1,7.8,14.3c0.3,1.3,2.2,0.7,1.9-0.5c-1.2-5.5-4-11.4-8.3-15.2 C221.5,475,220.1,476.5,221.1,477.3L221.1,477.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st293",
    d: "M218.7,475c0,0.6,1,0.6,1,0c0-0.2,0-0.4,0-0.6l-1,0.1C218.7,474.7,218.7,474.9,218.7,475z"
  })), /*#__PURE__*/React.createElement("g", null, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st294",
    d: "M226.7,464.9l0.1,0.1l0.2-0.9C226.7,464.1,226.3,464.6,226.7,464.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_316_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.6988,
    y1: 126.8375,
    x2: 226.8631,
    y2: 126.8375,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st295",
    d: "M226.5,464c-0.8,0.2-1.6,0.4-2.2,0.7l1.3,5.7l1.3-5.4l0.2-0.9V464C226.9,463.9,226.7,463.9,226.5,464z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M232.7,463.8c-0.7,1-1.4,2-2.1,3c-1-0.9-2.1-1.7-3.1-2.6l-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1v0.1L227,465 l-1.3,5.4l-1.3-5.7c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.8,0.6-1.7,1.3-2.5,1.9s-1.9,1.2-2.1,2.2 c-0.3,1.7-0.3,3.6-0.3,5.4l1-0.1c0-0.7,0.1-1.4,0.1-2c0.1-1-0.1-2.2,0.2-3.1c0.2-0.8,1.4-1.4,2-1.8c0.2-0.2,0.4-0.3,0.6-0.5 c-0.1,0.9-0.4,2.7-1.7,8.1c-0.1,0.4-0.4,1.6-0.2,1.9s0.3,0.6,0.8,0.6c0.4,0,0.7-0.2,1.1-0.3c3.5-1.5,3.6-1.8,4-3.5 c0.6-2.1,0.8-4.2,1.1-6.2c0.1-0.5,0.1-1,0.1-1.6c0.8,0.7,1.6,1.4,2.5,2c0.3,0.2,0.6,0.2,0.8-0.1c0.8-1.1,1.6-2.3,2.4-3.4 L232.7,463.8z"
  })))), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M219.2,476.6c-0.3,0-0.6-0.3-0.6-0.6v-0.7c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v0.7 C219.7,476.3,219.5,476.6,219.2,476.6z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st293",
    d: "M233.8,464c0.4-0.5-0.5-1-0.9-0.5c-0.1,0.1-0.1,0.2-0.2,0.3l0.8,0.6C233.6,464.2,233.7,464.1,233.8,464z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M224.9,465.1c-0.3-0.2-0.2-0.4,0.1-0.6l0.4-0.2c0.3-0.2,0.8-0.2,1.1,0s0.2,0.4-0.1,0.6L226,465 C225.7,465.2,225.2,465.2,224.9,465.1z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st296",
    d: "M228.1,459.3c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.3-0.2-0.6-0.2c-0.1,0-0.2,0-0.2,0c-0.2,0-0.3,0.2-0.6,0.3 c-0.1,0-0.3,0-0.4,0c-0.5,0-0.9,0.2-1.3,0.5c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0.1,0.4 c0,0.1,0,0.1,0.1,0.2s0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.3V462v-0.1c-0.1,0-0.2-0.2-0.2-0.4c0-0.2,0.1-0.4,0.3-0.4 c0.1,0,0.3,0.2,0.3,0.4c0,0.1,0,0.1,0,0.1c0.2-0.1,0.1-0.3,0.2-0.5c0-0.1,0.1-0.2,0.2-0.3c0.5-0.5,1.2-0.1,1.7-0.4 c0.1-0.1,0.2-0.1,0.3-0.3C228,460,228.1,459.6,228.1,459.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M225.8,461c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.2,0,0.4-0.1,0.5v-0.1c0-0.2-0.1-0.4-0.3-0.4 c-0.1,0-0.3,0.2-0.3,0.4c0,0.2,0.1,0.4,0.2,0.4v0.1v0.1c0,0.7,0,1.4,0,2.1c0,0.5,1.1,0.5,1.1,0c0-0.4,0-0.9,0-1.3 c0.7-0.1,1.2-0.7,1.2-1.3v-1.1C227,460.8,226.2,460.4,225.8,461z"
  }))), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M233.3,463.9c-0.3-0.2-0.3-0.5-0.2-0.8l0.4-0.6c0.2-0.3,0.5-0.3,0.8-0.2c0.3,0.2,0.3,0.5,0.2,0.8l-0.4,0.6 C233.9,464,233.5,464.1,233.3,463.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_317_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.5292,
    y1: 292.831,
    x2: 68.7375,
    y2: 292.831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st297",
    d: "M65.7,290c0.1,0.5,0,1.1,0.3,1.5c0.3,0.5,1.5,0.8,2.2,1.6c1.2,1.4,0.3,3.7-1.8,4.1 c-2.1,0.4-3.2-1.6-2.1-3.3c0.3-0.5,0.1-0.7-0.1-0.9c0.2,0,0.3-0.1,0.3-0.3c0-0.6,0-1.1,0-1.7v-0.1c0.1-0.1,0.2-0.2,0.2-0.4 c0-0.2-0.1-0.3-0.2-0.3s-0.2,0.2-0.2,0.3v0.1c-0.1-0.1-0.1-0.3-0.1-0.4s0-0.2-0.1-0.2c-1.2,0.2-0.7-0.7-1.4-0.6v0.5 c-0.1-0.1-0.1-0.2-0.1-0.3C62,288,65.4,287.9,65.7,290z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_318_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.7862,
    y1: 317.85,
    x2: 64.0138,
    y2: 317.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st298",
    d: "M63.8,317.3c-0.3-0.2-0.9-0.2-1.2,0.1l-0.5,0.3c-0.4,0.2-0.4,0.5-0.1,0.7c0.3,0.2,0.9,0.2,1.2-0.1l0.5-0.3 C64.1,317.9,64.1,317.5,63.8,317.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_319_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1959,
    y1: 313.6,
    x2: 69.0744,
    y2: 313.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st299",
    d: "M68.7,312.7c-0.4,0-0.9,0.2-1.1,0.6l-0.3,0.5c-0.2,0.3-0.1,0.7,0.2,0.7c0.4,0,0.9-0.2,1.1-0.6l0.3-0.5 C69.2,313.1,69.1,312.8,68.7,312.7z"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M62,305.9c0-0.2,0-0.4,0-0.6l0.2-3.8c0-0.3,0.2-0.5,0.3-0.6c0.2-0.1,0.5-0.1,0.7,0s0.3,0.3,0.2,0.5 l-0.2,3.5c0,0.2,0,0.4-0.1,0.6c-0.1,0.7-0.2,1.5,0.2,1.9c1.1,1.2,2.2,2.3,3.3,3.4c0.6,0.6,1.1,1.1,1.7,1.7c0.3,0.3,0.2,0.7,0,0.9 c-0.2,0.2-0.6,0.3-0.9,0c-0.6-0.6-1.2-1.2-1.7-1.7c-1.1-1.1-2.3-2.3-3.4-3.5C61.9,307.6,62,306.8,62,305.9z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M66.3,303.1c-2,4-2.5,9.3-2.2,13.9c0.1,1.1-1.3,1.1-1.4,0c-0.3-4.9,0.3-10.6,2.4-14.8 C65.6,301.2,66.8,302.1,66.3,303.1L66.3,303.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_320_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.972,
    y1: 305.35,
    x2: 66.6,
    y2: 305.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st300",
    d: "M62,306.9c0,0,0.6,1.2,2.6,1.5l2-4.5l-4.5-1.6C62.1,302.3,61.9,305.3,62,306.9z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st293",
    d: "M61.6,297.6l0.6,0.7c-0.2,0.2-0.4,0.3-0.7,0.5l-0.6-0.7C61.2,297.9,61.4,297.8,61.6,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M58.7,299.8c0.6-0.4,1.2-0.9,1.8-1.3c0.2-0.1,0.3-0.2,0.5-0.4l0.6,0.7c-0.2,0.1-0.3,0.2-0.4,0.3 c-0.6,0.5-1.3,1-1.9,1.5C58.7,300.9,58.3,300.1,58.7,299.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_321_",
    gradientUnits: "userSpaceOnUse",
    x1: 723.921,
    y1: 289.5318,
    x2: 723.921,
    y2: 299.8811,
    gradientTransform: "matrix(-1 0 0 -1 787.921 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st301",
    d: "M63.2,292.8c0.1-0.1,0.2-0.1,0.3-0.1c0.5-0.2,1-0.1,1.4,0.2l-1.4,10.9c-0.1-0.1-0.3-0.1-0.4-0.2 L63.2,292.8z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M62.8,297.6c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.3,0.3-0.5,0.5l-0.6-0.7c0.1-0.1,0.3-0.2,0.3-0.2s0.6-2.6,1-4 c0-0.1,0-0.1,0.1-0.1c0.1-0.2,0.1-0.3,0.3-0.4l-0.1,10.8c-0.5-0.3-0.8-0.6-0.9-0.8c-0.5-1.1,0.6-2.4,0.6-3.1 C62.8,299,62.8,298.3,62.8,297.6z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st293",
    d: "M68,298.7l0.9-0.2c0.1,0.2,0.1,0.5,0.1,0.7l-0.8,0.2C68.1,299.1,68.1,298.9,68,298.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M69,299.2c0,0.2,0.1,0.4,0.1,0.6c0.2,0.8,0.4,1.6,0.7,2.5c0.1,0.5-0.7,0.8-0.8,0.2c-0.3-1-0.5-2.1-0.8-3.1 L69,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st302",
    d: "M67.7,297.5C67.7,297.4,67.7,297.4,67.7,297.5C67.6,297.2,67.8,297.6,67.7,297.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M64.9,292.9c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0.1,0,0.2,0.1c0.6,0.7,1.1,1.3,1.7,2c0.4,0.5,1.1,1.1,1.4,1.7 c0.2,0.4,0.3,0.9,0.4,1.4l-0.9,0.2c-0.1-0.4-0.2-0.8-0.4-1.2c0,0,0,0,0.1,0.1s-0.1-0.3-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.3-0.4-0.7-0.8-1-1.2c-0.1-0.1-0.2-0.2-0.2-0.3c0.3,1.9-0.3,2.3-0.1,3.6c0.1,1,1.2,1.8,0.7,4c-0.3,1.4-2.1,1.1-3.3,0.5 L64.9,292.9z"
  }))))), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M64.6,293.3c0.2-0.1,0.2-0.3-0.1-0.4l-0.3-0.2c-0.2-0.1-0.6-0.1-0.7,0c-0.2,0.1-0.2,0.3,0.1,0.4l0.3,0.2 C64.1,293.4,64.4,293.4,64.6,293.3z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st303",
    d: "M63.5,291.7c0,0.3,0,0.5,0,0.8C63.4,292.3,63.3,291.9,63.5,291.7L63.5,291.7z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M62.5,289.4c0.7-0.2,0.2,0.8,1.4,0.6c0.1,0,0.1,0.1,0.1,0.2s0,0.3,0.1,0.4v-0.1c0-0.2,0.1-0.3,0.2-0.3 s0.2,0.2,0.2,0.3c0,0.2-0.1,0.3-0.2,0.3c0,0.1,0,0.1,0,0.2c0,0.6,0,1.1,0,1.7c0,0.2-0.1,0.3-0.3,0.3c-0.3,0-0.6-0.1-0.6-0.3 c0-0.1,0-0.1,0-0.2c0-0.3,0-0.5,0-0.8h-0.1c-0.5,0-0.9-0.4-0.9-0.9v-0.9L62.5,289.4L62.5,289.4z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M57.9,300.7c0.1,0.2,0.4,0.4,0.7,0.2l0.6-0.3c0.2-0.1,0.4-0.4,0.2-0.7c-0.1-0.2-0.4-0.4-0.7-0.2l-0.6,0.3 C57.9,300.1,57.8,300.4,57.9,300.7z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M69.3,303.6c0.3,0,0.5-0.2,0.6-0.4l0.1-0.6c0-0.3-0.2-0.5-0.4-0.6c-0.3,0-0.5,0.2-0.6,0.4l-0.1,0.6 C68.8,303.3,69,303.5,69.3,303.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M521.8,246.6c0,0.4-0.4,0.7-0.9,0.7l-1.3-0.1c-0.4,0-0.8-0.4-0.7-0.8c0-0.4,0.4-0.7,0.9-0.7l1.3,0.1 C521.5,245.9,521.8,246.2,521.8,246.6z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M511.6,228.3c0.4,0,0.9,0.3,0.9,0.7l0.1,1.2c0,0.4-0.3,0.8-0.7,0.8c-0.4,0-0.9-0.3-0.9-0.7l-0.1-1.2 C510.8,228.7,511.2,228.4,511.6,228.3z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M524,235.4c-0.3,0.2-0.8-0.1-1-0.4c-0.1-0.2-0.2-0.5-0.4-0.7c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.3-0.2-0.6-0.4-0.6s-0.4,0.3-0.4,0.6v0.1h-0.1c-0.1,0-0.2-0.1-0.2-0.2v-0.5c-0.1-0.1-0.2-0.2-0.4-0.2 c-0.2-0.2-0.5-0.4-0.7-0.8v1.4c0,1,0.8,1.8,1.9,1.9c0,0.6,0,1.2,0,1.8s1.5,0.6,1.5,0c0-0.7,0-1.5,0-2.2 C524.1,235.3,524.1,235.4,524,235.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M521.4,233.1c0.1,0.1,0.2,0.2,0.4,0.2v0.5c0,0.1,0.1,0.2,0.2,0.2h0.1v-0.1c0-0.3,0.2-0.6,0.4-0.6 s0.4,0.3,0.4,0.6c0,0.2,0,0.3-0.1,0.4c0.1,0.2,0.2,0.5,0.4,0.7c0.2,0.3,0.6,0.6,1,0.4c0.1,0,0.1-0.1,0.2-0.1 c0.7-0.6,1.4-2.5,0.6-3.8c-0.4-0.7-2-0.8-3-0.6c-0.2-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0.1-0.6,0.3 c0,0.1-0.1,0.2-0.1,0.2c0,0.3,0.1,0.6,0.3,0.9c0,0.1,0.1,0.2,0.1,0.4C520.9,232.7,521.2,233,521.4,233.1z"
  }))), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M517.3,273.2c0.5-0.3,1.4-0.2,1.9,0.1l0.7,0.4c0.6,0.3,0.6,0.7,0.1,1s-1.4,0.2-1.9-0.1l-0.7-0.4 C516.9,273.9,516.8,273.4,517.3,273.2z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M521.3,270.7c0.5-0.3,1.4-0.2,1.9,0.1l0.7,0.4c0.6,0.3,0.6,0.7,0.1,1s-1.4,0.2-1.9-0.1l-0.7-0.4 C520.9,271.4,520.8,271,521.3,270.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_322_",
    gradientUnits: "userSpaceOnUse",
    x1: -2259.2998,
    y1: 345.4235,
    x2: -2259.2998,
    y2: 321.6391,
    gradientTransform: "matrix(-1 0 0 -1 -1735.6421 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st304",
    d: "M523,250.8c-0.6,3.9-1.4,7.7-1.3,11.6c0.1,2.7,0.2,5.5,0.3,8.2c0.1,1.6,2.8,1.6,2.7,0 c-0.1-2.7-0.2-5.4-0.3-8.2c-0.2-3.7,0.6-7.4,1.2-11C525.9,249.9,523.3,249.3,523,250.8L523,250.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_323_",
    gradientUnits: "userSpaceOnUse",
    x1: -2255.2373,
    y1: 345.4234,
    x2: -2255.2373,
    y2: 321.6389,
    gradientTransform: "matrix(-1 0 0 -1 -1735.6421 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st305",
    d: "M518.8,251.4c-0.4,3.6-0.9,7.3-1.1,10.9c-0.1,3.6,0.2,7.2,0.3,10.8c0,1.6,2.8,1.6,2.7,0 c-0.1-3.6-0.4-7.2-0.3-10.8c0.1-3.6,0.7-7.3,1.1-10.9C521.7,249.9,519,249.9,518.8,251.4L518.8,251.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_324_",
    gradientUnits: "userSpaceOnUse",
    x1: -2263.5793,
    y1: 351.4485,
    x2: -2256.1538,
    y2: 351.4485,
    gradientTransform: "matrix(-1 0 0 -1 -1735.6421 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st306",
    d: "M521.5,247.2c1.8-0.5,3.7-1.3,5-2.5c2.3-2.1,1.5-4.6-0.5-6.6c-0.8-0.7-2,0.3-1.2,1.1 c1.9,1.9,2,3.7-0.4,5.2c-1,0.6-2.1,1.1-3.3,1.4C520.1,246,520.5,247.5,521.5,247.2L521.5,247.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_325_",
    gradientUnits: "userSpaceOnUse",
    x1: -2267.7385,
    y1: 335.7897,
    x2: -2252.4133,
    y2: 353.9855,
    gradientTransform: "matrix(-1 0 0 -1 -1735.6421 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st307",
    d: "M512.6,230.3c1.1,1.6,2.1,3.4,3.4,4.9c0.5,0.7,1.4,1.1,2.3,1.5c0.4,0.2,0.9,0.3,1.4,0.5 c0.8,0.2,1.5,0.4,2.2,0.5c0.1,0,0.2-0.1,0.3-0.1c0-0.2,0.1-0.5,0.4-0.6l1.2-0.4c0.3-0.1,0.6,0.1,0.7,0.3v0.1 c1.1,0.1,2.3,0.9,1.9,4.5c-0.1,0.9-0.2,3-0.4,4.4c0,0.3,0,0.6-0.1,0.8c-0.1,0.6-0.1,1.2-0.1,1.8c0,1.5,0.1,2.4,0,2.9 c-0.2,2.3-2.5,2.6-5.5,4c-0.6,0.2-1.6,0.2-2-0.5l0.6-9.2c0.3-2.8,0.3-4,0.9-5.6c0.2-0.4,0.3-0.8,0.5-1.1c-0.4-0.1-0.9-0.2-1.3-0.3 c-0.5-0.1-0.9-0.3-1.4-0.4c-1-0.4-2-0.8-2.7-1.5c-1.6-1.5-2.7-3.7-3.9-5.5C510.7,230.4,512.1,229.5,512.6,230.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_326_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.503,
    y1: 123.2112,
    x2: 337.0394,
    y2: 123.2112,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#2234A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1346,
    style: {
      stopColor: "#263299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    style: {
      stopColor: "#2F2D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    style: {
      stopColor: "#342A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36296D"
    }
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st308",
    d: "M333.1,467.4c-0.1,0.6,0.1,1.3-0.3,1.8s-1.8,0.9-2.6,1.9c-1.4,1.7-0.4,4.5,2.2,4.9c2.5,0.5,3.7-1.9,2.5-3.9 c-0.6-1,0.4-1,0.7-1.5c0.2-0.3,0.4-0.8,0.2-1.1c-0.1-0.3-0.2-0.3-0.3-0.6c-0.5-1.4,1.2-0.8,1.5-1.9 C337.4,465,333.5,464.9,333.1,467.4z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M334,471.8c-0.8,1.4-2.1,2.8-2.6,4.4c0,0.1-0.1,0.2-0.1,0.3l1.2,0.4c0-0.1,0.1-0.2,0.1-0.3 c0,0,0.2-0.4,0.3-0.5c1-1.6,1.2-1.8,2.2-3.5C335.6,471.8,334.5,471.1,334,471.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_327_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.3453,
    y1: 493.65,
    x2: 327.0886,
    y2: 493.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st309",
    d: "M326.8,493c-0.4-0.2-1.1-0.2-1.5,0.1l-0.6,0.3c-0.4,0.3-0.5,0.6-0.1,0.9c0.4,0.2,1.1,0.2,1.5-0.1l0.6-0.3 C327.2,493.6,327.2,493.2,326.8,493z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_328_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.2454,
    y1: 495.95,
    x2: 331.7546,
    y2: 495.95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st310",
    d: "M331.4,495c-0.4-0.1-1.1,0.1-1.4,0.5l-0.5,0.5c-0.4,0.4-0.3,0.8,0.1,0.9s1.1-0.1,1.4-0.5l0.5-0.5 C331.9,495.4,331.8,495.1,331.4,495z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M335.7,485.2c-1.5,1-3.1,1.8-4.5,2.9c-0.7,0.5-0.8,1.4-1,2.2c-0.3,1.6-0.4,3.3,0.1,4.9 c0.3,0.8,1.5,0.5,1.3-0.4c-0.5-1.4-0.4-3-0.1-4.5c0.2-0.9,0.2-1,0.8-1.5c1.3-0.9,2.6-1.7,3.9-2.6 C337.1,485.9,336.4,484.7,335.7,485.2L335.7,485.2z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M327.1,493c0.4-1.7,0.8-3.4,1.3-5c0.6-2.1,2.4-2.9,4.1-3.9c0.7-0.4,0.1-1.6-0.7-1.1c-1.9,1.2-4,2.1-4.7,4.5 c-0.5,1.7-0.9,3.5-1.4,5.3C325.6,493.4,326.9,493.8,327.1,493L327.1,493z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_329_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.7,
    y1: 106.4383,
    x2: 333.7,
    y2: 121.804,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st311",
    d: "M337.5,472.5c0.4,1,0.5,2.2,0.5,3.4c0,1.9,0.1,3.8,0.1,5.7c0,1.3,0,2.6-0.5,3.7c-0.3,0.5-0.7,1-1.1,1.4 c-0.6,0.6-1.3,1.1-2,1.6c-0.2,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.6-0.2c-1.4-0.9-2.7-2-3.7-3.6c-0.2-0.3-0.4-0.6-0.4-1 c0-0.6,0.5-1,0.9-1.4c0.5-0.3,0.9-0.7,1.4-1c0.4-0.2,0.8-0.5,1-0.9c0.5-0.7,0.5-1.6,0.6-2.5c0.1-1.2,0.2-2.4,0.3-3.6 c0.1-0.8,0.1-1.7,0.4-2.4C334.9,469.8,336.7,470.8,337.5,472.5z"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M337,467.1c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.3-0.8-0.6-1.3-0.6c-0.4,0-0.7,0.1-1,0.4 c-0.1,0.1-0.6,0.5-0.5,0.7c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.3,1.3-0.1,1.7,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.2,0,0.4,0.1,0.5v-0.1 c0-0.2,0.1-0.4,0.3-0.4c0.1,0,0.3,0.2,0.3,0.4c0,0.2-0.1,0.4-0.2,0.4v0.1v0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.2-0.5 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.3,0.1-0.4C337.1,467.4,337,467.2,337,467.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M336.5,468.6c0.1,0,0.2-0.2,0.2-0.4c0-0.2-0.1-0.4-0.3-0.4c-0.1,0-0.3,0.2-0.3,0.4c0,0.1,0,0.1,0,0.2 c-0.2-0.1-0.1-0.3-0.2-0.5c0-0.1-0.1-0.2-0.2-0.3c-0.5-0.5-1.2-0.1-1.7-0.4v1.2c0,0.7,0.5,1.3,1.2,1.4c0,0.4,0,0.7,0,1.1 c-0.2,0-0.3,0-0.5,0.1c-0.3,0.2-0.3,0.5,0.1,0.7l0.4,0.2c0.3,0.2,0.8,0.2,1.1,0c0.3-0.2,0.3-0.4,0-0.6v-0.1c0-0.7,0-1.5,0-2.2 C336.5,468.8,336.5,468.7,336.5,468.6L336.5,468.6z"
  }))), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M330.4,481.3c-0.2,0.8,1.1,1.2,1.3,0.4c0.3-1.5,0.5-3.6,0.9-4.8l-1.2-0.4C330.8,478,330.7,479.8,330.4,481.3 z"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M329.7,485.9l4.5-2.6c0.1-0.1,0.1-0.2,0-0.3l-2.9-1.7c-0.1-0.1-0.3-0.1-0.4,0l-4.6,2.6 c-0.1,0.1-0.1,0.2,0,0.3l3,1.7C329.4,486,329.5,486,329.7,485.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "329.6,485.7 334,483.2 331,481.5 326.6,484  "
  }))), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M330.6,481.2c0.3-0.1,0.7,0,0.8,0.3c0.1,0.3,0,0.7-0.3,0.8l-0.9,0.4c-0.3,0.1-0.7,0-0.8-0.3 c-0.1-0.3,0-0.7,0.3-0.8L330.6,481.2z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M331.7,481.8c0.3-0.1,0.7,0,0.8,0.3c0.1,0.3,0,0.7-0.3,0.8l-0.9,0.4c-0.3,0.1-0.7,0-0.8-0.3 c-0.1-0.3,0-0.7,0.3-0.8L331.7,481.8z"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M336.3,472.8c0.1,0.9,0.2,1.8,0.3,2.7c0.1,0.8,0.5,2.2,0,3c-0.4,0.8-1.7,1.2-2.4,1.7 c-0.8,0.5-1.5,1-2.3,1.4c-0.7,0.4-0.1,1.6,0.7,1.1c0.9-0.5,1.8-1.1,2.6-1.6c0.9-0.5,2-1,2.5-1.9c0.6-1,0.3-2.1,0.2-3.2 c-0.1-1.1-0.3-2.2-0.4-3.2C337.5,471.9,336.2,471.9,336.3,472.8L336.3,472.8z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_330_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.3078,
    y1: 402.9788,
    x2: 272.4926,
    y2: 402.9788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st312",
    d: "M272,192.3l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C272.5,192.3,272.3,192.5,272,192.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_331_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.3868,
    y1: 358.1856,
    x2: 187.5715,
    y2: 358.1856,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st313",
    d: "M187.1,237.1l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 S187.4,237.3,187.1,237.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_332_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.3555,
    y1: 338.095,
    x2: 383.5404,
    y2: 338.095,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st314",
    d: "M383.1,257.2l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C383.5,257.2,383.3,257.3,383.1,257.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_333_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.3037,
    y1: 332.2788,
    x2: 393.4888,
    y2: 332.2788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st315",
    d: "M393,263l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C393.5,263,393.3,263.2,393,263z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_334_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.1109,
    y1: 326.6788,
    x2: 403.2956,
    y2: 326.6788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st316",
    d: "M402.8,268.6l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C403.3,268.6,403.1,268.8,402.8,268.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_335_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.7944,
    y1: 320.4788,
    x2: 413.9793,
    y2: 320.4788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st317",
    d: "M413.5,274.8l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C414,274.8,413.8,275,413.5,274.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_336_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.5403,
    y1: 271.6,
    x2: 331.725,
    y2: 271.6,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st318",
    d: "M329,323.7l2.2-1.3c0.3-0.2,0.5-0.6,0.5-0.9c0-0.4-0.2-0.5-0.5-0.4l-2.2,1.3c-0.3,0.2-0.5,0.6-0.5,0.9 C328.5,323.7,328.8,323.8,329,323.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_337_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.592,
    y1: 265.7806,
    x2: 321.7771,
    y2: 265.7806,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st319",
    d: "M319.1,329.5l2.2-1.3c0.3-0.2,0.5-0.6,0.5-0.9s-0.2-0.5-0.5-0.4l-2.2,1.3c-0.3,0.2-0.5,0.6-0.5,0.9 S318.8,329.7,319.1,329.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_338_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.7849,
    y1: 260.1788,
    x2: 311.9698,
    y2: 260.1788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st320",
    d: "M309.3,335.1l2.2-1.3c0.3-0.2,0.5-0.6,0.5-0.9c0-0.4-0.2-0.5-0.5-0.4l-2.2,1.3c-0.3,0.2-0.5,0.6-0.5,0.9 C308.8,335.1,309,335.3,309.3,335.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_339_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.1,
    y1: 253.905,
    x2: 301.2847,
    y2: 253.905,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st321",
    d: "M298.6,341.4l2.2-1.3c0.3-0.2,0.5-0.6,0.5-0.9c0-0.4-0.2-0.5-0.5-0.4l-2.2,1.3c-0.3,0.2-0.5,0.6-0.5,0.9 S298.3,341.5,298.6,341.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_340_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.4329,
    y1: 176.005,
    x2: 523.6179,
    y2: 176.005,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st322",
    d: "M523.1,419.3l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 S523.4,419.4,523.1,419.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_341_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.7804,
    y1: 376,
    x2: 271.0311,
    y2: 376,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st323",
    d: "M254.7,245.2h-0.5v-11c0-1.6-0.9-3.1-2.3-3.8l-22.1-12.2c-0.7-0.4-1.1-1-1.1-1.8s0.4-1.4,1-1.8l41-23.8 l0.3,0.5l-41,23.8c-0.5,0.3-0.8,0.8-0.8,1.3c0,0.6,0.3,1.1,0.8,1.3l22.1,12.2c1.6,0.9,2.5,2.5,2.5,4.3v11H254.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_342_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.7682,
    y1: 339.9,
    x2: 204.5825,
    y2: 339.9,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st324",
    d: "M204.6,272.6h-0.5v-10.8c0-1-0.5-1.9-1.4-2.4l-27.1-15.1c-0.5-0.3-0.8-0.8-0.8-1.4c0-0.6,0.3-1.1,0.8-1.4 l10.3-5.9l0.3,0.5l-10.3,5.9c-0.4,0.2-0.6,0.6-0.6,1s0.2,0.8,0.6,1l27.1,15.1c1,0.6,1.7,1.7,1.7,2.8v10.7H204.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_343_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3647,
    y1: 324.15,
    x2: 382.0734,
    y2: 324.15,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st325",
    d: "M362.9,284.1h-0.5V268c0-0.9,0.5-1.7,1.3-2.2l18.2-10.2l0.3,0.5L364,266.3c-0.6,0.3-1,1-1,1.7L362.9,284.1 L362.9,284.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_344_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.1711,
    y1: 318.25,
    x2: 391.8817,
    y2: 318.25,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st326",
    d: "M372.7,290h-0.5v-16.3c0-0.9,0.5-1.8,1.3-2.2l18.2-10l0.3,0.5l-18.2,10c-0.6,0.3-1,1-1,1.7L372.7,290 L372.7,290z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_345_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0652,
    y1: 312.55,
    x2: 401.7758,
    y2: 312.55,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st327",
    d: "M382.6,295.7h-0.5v-16.3c0-0.9,0.5-1.8,1.3-2.2l18.2-10l0.3,0.5l-18.2,10c-0.6,0.3-1,1-1,1.7L382.6,295.7 L382.6,295.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_346_",
    gradientUnits: "userSpaceOnUse",
    x1: 393,
    y1: 306.25,
    x2: 412.2671,
    y2: 306.25,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st328",
    d: "M393.5,302.1H393v-16.2c0-0.9,0.5-1.7,1.2-2.2l17.8-10.3l0.3,0.5l-17.8,10.3c-0.6,0.4-1,1-1,1.7V302.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_347_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.9865,
    y1: 189.525,
    x2: 522.1864,
    y2: 189.525,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st329",
    d: "M508.9,426c-1.2,0-2.4-0.3-3.4-1l-67.8-41.5c-0.2-0.1-0.5-0.1-0.7,0s-0.4,0.4-0.4,0.7l0.1,2.7h-0.5 l-0.1-2.7c0-0.5,0.2-0.9,0.6-1.1s0.9-0.2,1.3,0l67.8,41.5c2,1.2,4.6,1.2,6.6-0.2l9.6-6.6l0.3,0.4l-9.6,6.6 C511.5,425.6,510.2,426,508.9,426z"
  }))), /*#__PURE__*/React.createElement("g", null, _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.8,441.2l-15.1-8.8c-1.5-0.9-3.3-0.9-4.8,0l-19.3,11.2l17,10.1h7.3l15-9.2 C478.1,443.7,478,441.9,476.8,441.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_348_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.7804,
    y1: 150.55,
    x2: 473.6636,
    y2: 150.55,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3E3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#D0D0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#BEBEED"
    }
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st330",
    d: "M472.6,433.2v9.4c0,0.5-0.2,0.9-0.7,1.2l-16,9.3c-1.5,0.8-3.3,0.8-4.7,0l-16-9.3c-0.5-0.3-0.7-0.7-0.7-1.2 h-0.1v-9.4H472.6z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M455.8,443.6l16-9.3c0.9-0.5,0.9-1.8,0-2.4l-16.1-9.3c-1.3-0.8-3-0.8-4.3,0l-16.3,9.5c-0.9,0.5-0.9,1.8,0,2.3 l16,9.3C452.6,444.5,454.4,444.5,455.8,443.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_349_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.9764,
    y1: 148.0788,
    x2: 445.1613,
    y2: 148.0788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st331",
    d: "M444.7,447.2l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C445.2,447.2,444.9,447.4,444.7,447.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_350_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.4369,
    y1: 43.9788,
    x2: 379.6217,
    y2: 43.9788,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st332",
    d: "M379.1,551.3l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C379.6,551.3,379.4,551.5,379.1,551.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_351_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.8684,
    y1: 42.5738,
    x2: 464.0535,
    y2: 42.5738,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M463.6,552.7l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 C464.1,552.7,463.8,552.9,463.6,552.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_352_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.7138,
    y1: 101.7856,
    x2: 528.8987,
    y2: 101.7856,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M528.4,493.5l-2.2-1.3c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.4,0.2-0.5,0.5-0.4l2.2,1.3c0.3,0.2,0.5,0.6,0.5,0.9 S528.7,493.7,528.4,493.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_353_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.9305,
    y1: 161.3829,
    x2: 443.7305,
    y2: 161.3829,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st335",
    d: "M437.4,449.8c-0.6,0-1.2-0.2-1.7-0.5l-55.2-33.2c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0.1-0.4,0.2-0.4,0.4 l0.1,3.3h-0.5l-0.1-3.4c0.1-0.4,0.4-0.7,0.8-0.8c0.4-0.1,0.7-0.1,1.1,0.1l55.2,33.2c0.9,0.6,2.1,0.5,3-0.1l4.4-3.1l0.3,0.4 l-4.4,3.1C438.7,449.6,438.1,449.8,437.4,449.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_354_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.4,
    y1: 91.925,
    x2: 410.3916,
    y2: 91.925,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M363.4,559c-0.9,0-1.7-0.2-2.5-0.7L337.2,544c-0.6-0.4-1-1-1-1.7s0.4-1.4,1-1.7l71.9-45.1 c0.4-0.3,0.7-0.8,0.7-1.3s-0.3-1-0.7-1.3L330,445.8c-0.2-0.1-0.5-0.1-0.7,0s-0.4,0.4-0.4,0.6v2.6h-0.5v-2.6c0-0.5,0.2-0.9,0.6-1.1 s0.9-0.2,1.2,0l79.1,47.1c0.6,0.4,1,1,1,1.7s-0.3,1.4-1,1.7L337.5,541c-0.4,0.3-0.7,0.8-0.7,1.3s0.3,1,0.7,1.3l23.6,14.3 c1.4,0.9,3.2,0.8,4.6-0.1l12.2-8l0.3,0.4l-12.2,8C365.2,558.8,364.3,559,363.4,559z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M386.9,545.1l-12.1-7c-0.7-0.4-0.7-1.4,0-1.8l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.2 c0.7,0.4,0.7,1.3,0,1.7l-12.1,7C389.4,545.7,388,545.7,386.9,545.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_355_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.2997,
    y1: 60.875,
    x2: 371.3554,
    y2: 60.875,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st337",
    d: "M374.7,537.2l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.1c0.2,0.1,0.3,0.2,0.4,0.4c0.3-0.5,0.1-1.1-0.4-1.4 l-12.4-7.1c-1-0.6-2.3-0.6-3.3,0l-12.2,7.1c-0.5,0.3-0.6,0.9-0.4,1.4C374.4,537.4,374.6,537.3,374.7,537.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_356_",
    points: "1,1 2,1 1,2  "
  }))), _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_357_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_358_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_356_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_359_",
    className: "st338"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_360_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.3,
    y1: 111.3882,
    x2: 388.3,
    y2: 40.8702,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st339",
    d: "M376.2,486.6v49.8l0,0c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9 c0.3-0.2,0.4-0.5,0.4-0.8v-1.9l0,0v-48.2L376.2,486.6z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_361_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.3,
    y1: 111.3882,
    x2: 388.3,
    y2: 40.8702,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3.409785e-7,
    style: {
      stopColor: "#92A5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3645,
    style: {
      stopColor: "#8FA2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    style: {
      stopColor: "#8699FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8767,
    style: {
      stopColor: "#7688FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7DFF"
    }
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st340",
    d: "M376.2,486.6v49.8c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9c0.3-0.2,0.4-0.5,0.4-0.8 v-1.9v-48.2L376.2,486.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_362_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.45,
    y1: 100.9542,
    x2: 388.45,
    y2: 108.1391,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st341",
    d: "M400.3,481.8c-0.1,1.7-1.2,3.3-3.4,4.6c-4.6,2.7-12.2,2.7-16.9,0c-1.4-0.8-2.3-1.7-2.9-2.7 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.2-0.1-0.2-0.1-0.3v-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3 c0,2.1,0,4.5,0,4.5c0.1,1.7,1.3,3.3,3.5,4.6c1.8,1,3.9,1.6,6.2,1.9c3.8,0.4,7.8-0.2,10.7-1.9c2.2-1.3,3.4-3,3.5-4.7 c0-0.1,0-0.3,0-0.4C400.3,485.9,400.3,483.7,400.3,481.8L400.3,481.8z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M376.5,481.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3v0.1c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.3,0.7 c0.1,0.1,0.1,0.2,0.2,0.3c0.6,1,1.5,1.9,2.9,2.7c4.7,2.7,12.3,2.7,16.9,0c2.2-1.3,3.4-3,3.5-4.7c0-0.6-0.1-1.1-0.3-1.7 c-0.1-0.3-0.2-0.5-0.3-0.8c-0.6-1-1.5-1.9-2.8-2.6c0,0-0.1,0-0.1-0.1c-2-1.2-4.5-1.8-7.1-2c-0.8-0.1-1.7-0.1-2.5,0 c-2.7,0.1-5.3,0.8-7.3,2c-0.2,0.1-0.3,0.2-0.5,0.3c-1.4,0.9-2.3,2-2.7,3.1c-0.2,0.5-0.3,0.9-0.3,1.4 C376.4,481.5,376.4,481.6,376.5,481.7z"
  }))), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M391.4,483.6c0.1-0.4-0.1-0.8-0.5-1.2c0.6,0.2,1.2,0.2,1.9,0.2c0.7-0.1,1.3-0.2,1.8-0.6 c0.8-0.5,1.1-1,0.9-1.6c-0.1-0.4-0.5-0.7-1-1.2l1.3-0.7l-1-0.6l-1.2,0.7c-0.1-0.1-0.3-0.2-0.4-0.2l-0.9-0.5l1.2-0.7l-1-0.6 l-1.2,0.7l-1.4-0.9l-9.8,5.6l1.4,0.8l-1.2,0.7l1,0.6l1.2-0.7l1.3,0.8l-1.1,0.7l1,0.6l1.2-0.7c0.8,0.3,1.5,0.5,2.3,0.6 c1.2,0.1,2.2-0.1,3.1-0.6C391,484.3,391.3,484,391.4,483.6z M390.5,479l0.7,0.4c0.8,0.5,1,0.9,0.4,1.2c-0.3,0.2-0.6,0.2-1,0.2 s-0.7-0.2-1.1-0.4l-0.8-0.5L390.5,479z M385.7,482.8l-0.9-0.5l2-1.2l0.9,0.5c0.4,0.2,0.6,0.5,0.7,0.7c0,0.2-0.1,0.4-0.4,0.6 C387.2,483.4,386.5,483.3,385.7,482.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_363_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.4001,
    y1: 145.6625,
    x2: 527.5001,
    y2: 145.6625,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M509.7,503c-1.2,0-2.4-0.3-3.5-1l-35.3-21.1c-0.9-0.5-1.4-1.4-1.4-2.4s0.5-1.9,1.3-2.5l37-24.4 c0.8-0.5,1.3-1.4,1.2-2.4c0-1-0.5-1.8-1.4-2.3l-88.3-52.5c-0.3-0.2-0.6-0.2-0.9,0s-0.5,0.5-0.5,0.8v2.3h-0.5v-2.3 c0-0.5,0.3-1,0.7-1.3c0.5-0.3,1-0.3,1.5,0l88.3,52.5c1,0.6,1.6,1.6,1.6,2.8c0,1.1-0.5,2.2-1.5,2.8l-37,24.4 c-0.7,0.5-1.1,1.2-1.1,2s0.5,1.6,1.2,2l35.3,21.1c2.1,1.3,4.7,1.2,6.8-0.2l14-9.3l0.3,0.4l-14,9.3C512.3,502.6,511,503,509.7,503z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M452.2,441.4l-12.1-7c-0.7-0.4-0.7-1.4,0-1.8l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.2 c0.7,0.4,0.7,1.3,0,1.7l-12.1,7C454.7,442.1,453.3,442.1,452.2,441.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_364_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.6151,
    y1: 164.475,
    x2: 436.671,
    y2: 164.475,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2919,
    style: {
      stopColor: "#EAEAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#E3E5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    style: {
      stopColor: "#D0D5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#B1BDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    style: {
      stopColor: "#879AE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#6D86E0"
    }
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st343",
    d: "M440,433.6l12.2-7.1c1-0.6,2.3-0.6,3.3,0l12.4,7.1c0.2,0.1,0.3,0.2,0.4,0.4c0.3-0.5,0.1-1.1-0.4-1.4 l-12.4-7.1c-1-0.6-2.3-0.6-3.3,0l-12.2,7.1c-0.5,0.3-0.6,0.9-0.4,1.4C439.7,433.8,439.9,433.7,440,433.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_365_",
    points: "1,1 2,1 1,2  "
  }))), _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_366_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_367_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_368_",
    className: "st344"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_369_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.6,
    y1: 195.7522,
    x2: 453.6,
    y2: 147.5727,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st345",
    d: "M441.5,401v31.7l0,0c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9 c0.3-0.2,0.4-0.5,0.4-0.8v-1.9l0,0v-30.1L441.5,401z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_370_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.6,
    y1: 195.7522,
    x2: 453.6,
    y2: 147.5727,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3.409785e-7,
    style: {
      stopColor: "#92A5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3645,
    style: {
      stopColor: "#8FA2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    style: {
      stopColor: "#8699FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8767,
    style: {
      stopColor: "#7688FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B7DFF"
    }
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st346",
    d: "M441.5,401v31.7c0,0.3,0.1,0.6,0.4,0.8l10.2,5.9c0.9,0.5,2.1,0.5,3,0l10.2-5.9c0.3-0.2,0.4-0.5,0.4-0.8 v-1.9v-30.1L441.5,401z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_371_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.75,
    y1: 185.9892,
    x2: 453.75,
    y2: 193.174,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD33F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7364"
    }
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st347",
    d: "M465.6,396.7c-0.1,1.7-1.2,3.3-3.4,4.6c-4.6,2.7-12.2,2.7-16.9,0c-1.4-0.8-2.3-1.7-2.9-2.7 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.2-0.1-0.2-0.1-0.3v-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3 c0,2.1,0,4.5,0,4.5c0.1,1.7,1.3,3.3,3.5,4.6c1.8,1,3.9,1.6,6.2,1.9c3.8,0.4,7.8-0.2,10.7-1.9c2.2-1.3,3.4-3,3.5-4.7 c0-0.1,0-0.3,0-0.4C465.6,400.8,465.6,398.7,465.6,396.7L465.6,396.7z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M441.8,396.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3v0.1c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.3,0.7 c0.1,0.1,0.1,0.2,0.2,0.3c0.6,1,1.5,1.9,2.9,2.7c4.7,2.7,12.3,2.7,16.9,0c2.2-1.3,3.4-3,3.5-4.7c0-0.6-0.1-1.1-0.3-1.7 c-0.1-0.3-0.2-0.5-0.3-0.8c-0.6-1-1.5-1.9-2.8-2.6c0,0-0.1,0-0.1-0.1c-2-1.1-4.5-1.8-7.1-2c-0.8-0.1-1.7-0.1-2.5,0 c-2.7,0.1-5.3,0.8-7.3,2c-0.2,0.1-0.3,0.2-0.5,0.3c-1.4,0.9-2.3,2-2.7,3.1c-0.2,0.5-0.3,0.9-0.3,1.4 C441.8,396.4,441.8,396.5,441.8,396.7z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "459.5,392.5 449.6,394.1 446.9,399.8 456.9,398.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_372_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.8471,
    y1: 103.425,
    x2: 466.3471,
    y2: 103.425,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st348",
    d: "M454.5,556.6c-0.8,0-1.5-0.2-2.2-0.6l-43-26.2c-0.6-0.4-1-1-1-1.7s0.3-1.3,0.9-1.7l55.6-37.2 c0.8-0.5,1.2-1.4,1.2-2.3s-0.5-1.7-1.3-2.2l-99.2-59.5c-0.2-0.1-0.5-0.1-0.7,0s-0.4,0.4-0.3,0.6l0.1,2.6h-0.5l-0.1-2.6 c0-0.5,0.2-0.9,0.6-1.1s0.9-0.2,1.2,0l99.2,59.5c0.9,0.6,1.5,1.6,1.5,2.7s-0.5,2.1-1.4,2.7l-55.6,37.2c-0.4,0.3-0.7,0.8-0.7,1.3 s0.3,1,0.7,1.2l43,26.2c1.3,0.8,2.9,0.7,4.2-0.2l5.6-4.1l0.3,0.4l-5.6,4.1C456.2,556.4,455.3,556.6,454.5,556.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M380.9,456.4c0.4-0.2,1-0.2,1.4,0.1l0.6,0.3c0.4,0.2,0.5,0.6,0.1,0.8c-0.4,0.2-1,0.2-1.4-0.1l-0.6-0.3 C380.6,457,380.5,456.6,380.9,456.4z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M384.3,454.4c0.4-0.2,1-0.2,1.4,0.1l0.6,0.3c0.4,0.2,0.5,0.6,0.1,0.8c-0.4,0.2-1,0.2-1.4-0.1l-0.6-0.3 C384,454.9,383.9,454.6,384.3,454.4z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M385.6,437.9c-0.1,1-0.3,2-0.5,3H385l-1.3,0.8c0.1-1.1,0.2-2.2,0.3-3.3c0.1-1.3-1.9-1.3-2,0 c-0.3,3-0.7,6-0.8,9c-0.1,3,0.1,6,0.2,9c0,1.3,2.1,1.3,2,0c-0.1-3-0.3-6-0.2-9c0-1.6,0.2-3.2,0.3-4.7c0.1,0,1.4-0.8,1.4-0.8 c-0.3,1.9-0.4,3.7-0.4,5.6c0.1,2.3,0.1,4.5,0.2,6.8c0,1.3,2.1,1.3,2,0c-0.1-2.2-0.1-4.5-0.2-6.7c-0.1-3.1,0.4-6.1,0.9-9.1 C387.7,437.2,385.8,436.6,385.6,437.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M386.6,426.6c0,0.6,0,1.3,0,1.9c0,0.4-1.1,0.4-1.1,0c0-0.6,0-1.3,0-1.9 C385.5,426.1,386.6,426.1,386.6,426.6L386.6,426.6z"
  }))), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M386.1,427c0.1,0,0.2,0,0.3-0.1c0.5-0.6,0.5-1.7,0.1-2.4c-0.2-0.5-0.4-0.7-1.3-0.8c-0.2,0-0.8-0.1-1,0.2 c-0.1,0-0.1,0.1-0.2,0.1v1.6c0,0.8,0.7,1.4,1.5,1.4L386.1,427L386.1,427z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_373_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.3314,
    y1: 169.0367,
    x2: 322.8611,
    y2: 169.0367,
    gradientTransform: "matrix(1 0 0 -1 64.4158 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2865,
    style: {
      stopColor: "#6732EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    style: {
      stopColor: "#450D95"
    }
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st349",
    d: "M387,423.8c-0.3-0.5-1.5-0.6-2.3-0.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.4,0.1-0.4,0.2s0,0.1,0,0.2c0,0.2,0.1,0.5,0.2,0.7c0.1,0.3,0.3,0.7,0.6,0.9c0.3,0.2,0.6,0.4,0.8,0.6 c0.2,0.2,0.2,0.5,0.4,0.8c0.2,0.2,0.5,0.4,0.7,0.3C387,426.6,387.6,424.9,387,423.8z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M384.8,425.8h0.2l0,0v-0.6l0,0h-0.2l0,0V425.8C384.8,425.7,384.8,425.8,384.8,425.8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st145",
    cx: 385.3,
    cy: 425.6,
    rx: 0.3,
    ry: 0.5
  }))), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M384.9,429.2c-0.3-0.2-0.3-0.5,0.1-0.7l0.4-0.2c0.3-0.2,0.9-0.2,1.1,0c0.3,0.2,0.3,0.5-0.1,0.7l-0.4,0.2 C385.8,429.3,385.2,429.3,384.9,429.2z"
  }))), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st302",
    d: "M385.3,426.4l-0.7,0.3c-0.3,0.2-0.7,0-0.9-0.3c-0.2-0.4,0-0.8,0.3-0.9l0.7-0.3c0.3-0.2,0.7,0,0.9,0.3 C385.8,425.9,385.6,426.3,385.3,426.4z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M383.1,426.6c-0.1-0.3,0.1-0.6,0.4-0.7l0.7-0.2c0.3-0.1,0.6,0.1,0.7,0.4s-0.1,0.6-0.4,0.7l-0.7,0.2 C383.6,427,383.2,426.9,383.1,426.6z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M388,441.6c-0.3,0-0.6-0.3-0.6-0.6v-0.7c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v0.7 C388.6,441.4,388.3,441.6,388,441.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_374_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.6015,
    y1: 152.6389,
    x2: 319.6015,
    y2: 164.1421,
    gradientTransform: "matrix(1 0 0 -1 64.4158 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108108,
    style: {
      stopColor: "#9FAFFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6F6FF"
    }
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st351",
    d: "M387.8,428.7c-0.1-0.1-0.2-0.2-0.3-0.3c-0.6-0.6-1.6-0.3-2-0.2c-1.1,0.3-1.5,0.7-1.9,1.3 c-0.5,0.2-1,0.4-1.5,0.6s-1,0.3-1.5,0.5c-0.1,0-0.3,0-0.4,0.1c1.2-1.3,2.4-2.6,3.6-3.9c0.4-0.5-0.3-1.2-0.7-0.7 c-1.4,1.5-2.8,3.1-4.2,4.6c-0.1,0.1-0.2,0.3-0.1,0.5c0.4,1.1,2,0.5,2.8,0.3c0.5-0.2,1-0.3,1.6-0.5c-0.3,1-0.3,2-0.5,4 c-0.3,2.6-2.5,6.6,1.1,6.9c1.9,0.2,4-1,4.2-2.7c0.1-0.5-0.3-2.2-0.1-3.8c0.1-0.5,0.1-1.6,0.2-2.6c0.4,2.4,0.4,5-0.3,7.3 c-0.2,0.6,0.8,0.9,1,0.3C389.7,436.5,389.3,432.3,387.8,428.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_375_",
    gradientUnits: "userSpaceOnUse",
    x1: 3111.5227,
    y1: -962.1996,
    x2: 3115.8484,
    y2: -962.1996,
    gradientTransform: "matrix(0.866 0.5 1.5 -0.2887 -859.7828 -1532.6108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st352",
    d: "M393.7,303.1l-2.3-1.4c-0.3-0.2-0.3-0.5,0.1-0.8c0.4-0.2,1-0.2,1.3-0.1l2.3,1.4c0.3,0.2,0.3,0.5-0.1,0.8 S394.1,303.3,393.7,303.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_376_",
    gradientUnits: "userSpaceOnUse",
    x1: 3098.8694,
    y1: -962.1945,
    x2: 3103.1953,
    y2: -962.1945,
    gradientTransform: "matrix(0.866 0.5 1.5 -0.2887 -859.7828 -1532.6108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st353",
    d: "M382.8,296.8l-2.3-1.4c-0.3-0.2-0.3-0.5,0.1-0.8c0.4-0.2,1-0.2,1.3-0.1l2.3,1.4c0.3,0.2,0.3,0.5-0.1,0.8 C383.7,297,383.1,297,382.8,296.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_377_",
    gradientUnits: "userSpaceOnUse",
    x1: 3087.458,
    y1: -962.2583,
    x2: 3091.7839,
    y2: -962.2583,
    gradientTransform: "matrix(0.866 0.5 1.5 -0.2887 -859.7828 -1532.6108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st354",
    d: "M372.8,291.1l-2.3-1.4c-0.3-0.2-0.3-0.5,0.1-0.8c0.4-0.2,1-0.2,1.3-0.1l2.3,1.4c0.3,0.2,0.3,0.5-0.1,0.8 C373.7,291.3,373.1,291.3,372.8,291.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_378_",
    gradientUnits: "userSpaceOnUse",
    x1: 3075.7495,
    y1: -961.9988,
    x2: 3080.0752,
    y2: -961.9988,
    gradientTransform: "matrix(0.866 0.5 1.5 -0.2887 -859.7828 -1532.6108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st355",
    d: "M363.1,285.2l-2.3-1.4c-0.3-0.2-0.3-0.5,0.1-0.8c0.4-0.2,1-0.2,1.3-0.1l2.3,1.4c0.3,0.2,0.3,0.5-0.1,0.8 C364,285.3,363.4,285.4,363.1,285.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_379_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.1941,
    y1: 321.4131,
    x2: 206.3831,
    y2: 321.4131,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st356",
    d: "M203.8,273.7l2.3-1.4c0.3-0.2,0.3-0.5-0.1-0.8c-0.4-0.2-1-0.2-1.3-0.1l-2.3,1.4c-0.3,0.2-0.3,0.5,0.1,0.8 C202.9,273.9,203.5,273.9,203.8,273.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_380_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.2935,
    y1: 222.1131,
    x2: 312.4826,
    y2: 222.1131,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st357",
    d: "M309.9,373l2.3-1.4c0.3-0.2,0.3-0.5-0.1-0.8c-0.4-0.2-1-0.2-1.3-0.1l-2.3,1.4c-0.3,0.2-0.3,0.5,0.1,0.8 C309,373.2,309.6,373.2,309.9,373z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_381_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.7735,
    y1: 227.7132,
    x2: 322.9625,
    y2: 227.7132,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M320.4,367.4l2.3-1.4c0.3-0.2,0.3-0.5-0.1-0.8c-0.4-0.2-1-0.2-1.3-0.1l-2.3,1.4c-0.3,0.2-0.3,0.5,0.1,0.8 C319.5,367.6,320.1,367.6,320.4,367.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_382_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.6781,
    y1: 233.4131,
    x2: 332.8671,
    y2: 233.4131,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st359",
    d: "M330.3,361.7l2.3-1.4c0.3-0.2,0.3-0.5-0.1-0.8c-0.4-0.2-1-0.2-1.3-0.1l-2.3,1.4c-0.3,0.2-0.3,0.5,0.1,0.8 S330,361.9,330.3,361.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_383_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.6624,
    y1: 239.2132,
    x2: 342.8515,
    y2: 239.2132,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st360",
    d: "M340.3,355.9l2.3-1.4c0.3-0.2,0.3-0.5-0.1-0.8c-0.4-0.2-1-0.2-1.3-0.1l-2.3,1.4c-0.3,0.2-0.3,0.5,0.1,0.8 C339.4,356.1,340,356.1,340.3,355.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_384_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.3004,
    y1: 348.7131,
    x2: 256.4895,
    y2: 348.7131,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st361",
    d: "M253.9,246.4l2.3-1.4c0.3-0.2,0.3-0.5-0.1-0.8c-0.4-0.2-1-0.2-1.3-0.1l-2.3,1.4c-0.3,0.2-0.3,0.5,0.1,0.8 C253,246.6,253.6,246.6,253.9,246.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_385_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.2823,
    y1: 91.8697,
    x2: 330.6853,
    y2: 91.8697,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.741732e-7,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B893"
    }
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st362",
    d: "M282.3,546.5c-0.9,0-1.7-0.2-2.5-0.7l-9.6-5.8l0.3-0.4l9.6,5.8c1.4,0.8,3,0.8,4.4,0l44.9-26.4 c0.5-0.3,0.8-0.8,0.8-1.4c0-0.6-0.3-1.1-0.8-1.4L281,486.9c-0.7-0.4-1.1-1.2-1.1-2.1s0.5-1.6,1.2-2l32.5-17.8 c0.5-0.2,0.7-0.7,0.7-1.2s-0.3-1-0.7-1.2l-7.9-4.2c-0.2-0.1-0.5-0.1-0.7,0s-0.3,0.4-0.3,0.7l0.4,3.7h-0.5l-0.4-3.7 c0-0.5,0.2-0.9,0.5-1.1c0.4-0.3,0.9-0.3,1.3-0.1l7.9,4.2c0.6,0.3,1,1,1,1.7s-0.4,1.3-1,1.7l-32.5,17.8c-0.6,0.3-0.9,0.9-0.9,1.6 s0.3,1.3,0.9,1.6l48.4,29.4c0.6,0.4,1,1.1,1,1.8c0,0.8-0.4,1.4-1.1,1.8l-44.9,26.4C284,546.3,283.2,546.5,282.3,546.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_386_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.1,
    y1: 221.6542,
    x2: 305.1,
    y2: 254.1542,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st363",
    d: "M310.6,372.3h-0.5v-25.6c0-0.6-0.3-1.1-0.8-1.3l-9.7-5.1l0.2-0.5l9.7,5.1c0.7,0.4,1.1,1,1.1,1.8 L310.6,372.3L310.6,372.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_387_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.7,
    y1: 227.659,
    x2: 315.7,
    y2: 260.159,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M321.2,366.3h-0.5v-25.6c0-0.6-0.3-1.1-0.8-1.3l-9.7-5.1l0.2-0.5l9.7,5.1c0.7,0.4,1.1,1,1.1,1.8 L321.2,366.3L321.2,366.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_388_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.5,
    y1: 233.3596,
    x2: 325.5,
    y2: 265.8596,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st365",
    d: "M331,360.6h-0.5V335c0-0.6-0.3-1.1-0.8-1.3l-9.7-5.1l0.2-0.5l9.7,5.1c0.7,0.4,1.1,1,1.1,1.8L331,360.6 L331,360.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_389_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.6,
    y1: 239.1,
    x2: 335.6,
    y2: 271.6,
    gradientTransform: "matrix(1 0 0 -1 0 594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41B883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04972114,
    style: {
      stopColor: "#41B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#41B883"
    }
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st366",
    d: "M341.1,354.9h-0.5v-25.6c0-0.6-0.3-1.1-0.8-1.3l-9.7-5.1l0.2-0.5l9.7,5.1c0.7,0.4,1.1,1,1.1,1.8 L341.1,354.9L341.1,354.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/station.9b64d857aac74d809c09dcab7022e04c.svg";
export { ForwardRef as ReactComponent };